<div class="top" #extra (keydown)="hotkeys($event)" (paste)="pastefunc($event)">
  <ng-container *ngIf="(cardType && ((firstLoadCheck > 0) ? (cardData !== null) : true))">
  <ng-container [ngSwitch]="cardType">
    <ng-container *ngSwitchCase="'document'">
        <div class="embeddcode pdfViewer">
        <label [style.visibility]="(isCursorHovering ? 'visible' : 'hidden')">
            Landing page headline
          </label>
            <div class="dataField bdrfill" id="pdfHight">
                <ng2-pdfjs-viewer [pdfSrc]="cardData.image.images.original" (onDocumentLoad)="pdfDocumentLoaded($event)"
                downloadFileName="mySample" viewerId="MyID" [zoom]="60" [print]="false" [find]="false" [download]="false" [fullScreen]="false" [openFile]="false" [pagemode]="none">
                </ng2-pdfjs-viewer>
             </div>
              <div class="storyaction right" *ngIf="EditMode">
                <span class="handle sortpara" *ngIf="!hideDragger"><i class="icon-move"></i></span>
                <span class="deleteHeadline" (click)="deleteElement()"><i class="icon-delete"></i></span>
                <span class="viewpdf" (click)="renderpdf(cardData.image.images.original)"><i class="icon-view-image"></i></span>
              </div>
            </div>
            <div class="lightBox pdflightbox block" *ngIf="openPdf">

              <span class="tickcls whitename right pointer closePdfIcon" (click)="openPdf = false;" ><i class="icon-close"></i></span>
                <div class="pdf-modal">
                   <ng2-pdfjs-viewer [pdfSrc]="pdfSrc" (onDocumentLoad)="pdfDocumentLoaded($event)" [print]="false"
                    [zoom]="100" [find]="false" [download]="false" [fullScreen]="true" [openFile]="false">
                   </ng2-pdfjs-viewer>
                 </div>

             </div>
    </ng-container>
    <ng-container *ngSwitchCase="'paragraph'">
        <div #paraEl class="paragraph  " *ngIf="cardData" (focus)="outerDivFocus = true" (blur)="outerDivFocus = false"
          (mouseenter)="hoverEnter()" (mouseleave)="hoverLeave()"  (click)="editorClick('paragraph')">

          <label [style.visibility]="focusFlag ? 'visible' : 'hidden'">
            {{(id === 'newElement') ? 'Paragraph (Draft)' : 'Paragraph'}}
            <span>{{cardData.metadata ? cardData.metadata.wordCount : ''}} words</span>
          </label>
           <ng-container *ngIf="sharedService.isdomainConfig('story','isStoryListingEnabled')">
            <button id="backlinkID" class="story_link" *ngIf="showHyperlinkIcon " (click)="hyperlinkStoryList($event, 'paragraph')">
              <i class="icomoon icon-link icon-info" data-title="Hyperlink StoryList"></i></button>
           </ng-container>



          <div class="dataField bdrfill">
            <ng-container *ngIf="isCKEditorEnabled">
              <div id="paraElement" (keyup)="paragraphKeyUpEvent($event)" (keydown)="paragraphKeyDownEventCk($event)" (keyup.enter)="autoBacklink(id,$event)">
                <ckeditor #editorPara (mousedown)="mouseDown()" (mouseleave)="mouseLeave()" *ngIf="!textDifferenceCase" [editor]="ckEditor"  id="{{id}}"
                [(ngModel)]="cardData.paragraph.body"
                [config]="getEditorConfig()"
                [tabindex]="0"
                (ready)="ckchanges($event, 'ready', 'paragraph','parabody')"
                (change)="ckchanges($event, 'change', 'paragraph','parabody')"
                (blur)="ckchanges($event, 'blur', 'paragraph','parabody')"
                (focus)="ckchanges($event, 'focus', 'paragraph','parabody')"
                (error)="ckchanges($event, 'error', 'paragraph','parabody')"
                ></ckeditor>
                <p *ngIf="textDifferenceCase" [innerHtml]="cardData.paragraph.body"></p>
              </div>
            </ng-container>

          </div>
          <span (click)="trigger($event)"></span>
          <div class="storyaction" *ngIf="EditMode">
            <ng-container *ngIf="id === 'newElement'">
              <span class="deleteHeadline" (click)="clearParagraph()"><i class="icon-delete"></i></span>
              <span class="deleteHeadline" *ngIf="isPage == 'false' && sharedService.isdomainConfig('story','autoBacklinking') && (selectedToRemove && selectedToRemove.length !== 0)"
                (click)="removeHyperlinkSelection($event)"><i title="Remove Selected Hyperlink" class="icon-broken-link1"></i></span>
                <ng-container class="speechblock" *ngIf="enableSpeechToTextPara">
                  <span class="speechTextIcon" (click)="speechToText()" *ngIf="speechButton">
                    <img src="assets/images/micro_default.svg" *ngIf="speechButton">
                </span>
                <span class="speechTextIcon" (click)="speechStop()" *ngIf="!speechButton">
                    <img src="assets/images/micro_red-2.svg" *ngIf="!speechButton">
                </span>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="id !== 'newElement'">
              <span class="handle sortpara" id="buttonDragAndDrop" *ngIf="!hideDragger"><i class="icon-move"></i></span>
              <span class="deleteHeadline" (click)="deleteElement()"><i class="icon-delete"></i></span>
              <span class="deleteHeadline" *ngIf="isPage == 'false' && sharedService.isdomainConfig('story','autoBacklinking') && (selectedToRemove && selectedToRemove.length !== 0)"
                 (click)="removeHyperlinkSelection($event)"><i title="Remove Selected Hyperlink" class="icon-broken-link1"></i></span>
                <ng-container class="speechblock" *ngIf="enableSpeechToTextPara">
                  <span class="speechTextIcon" (click)="speechToText()" *ngIf="speechButton">
                    <img src="assets/images/micro_default.svg" *ngIf="speechButton">
                </span>
                   <span class="speechTextIcon" (click)="speechStop()" *ngIf="!speechButton">
                    <img src="assets/images/micro_red-2.svg" *ngIf="!speechButton">
                </span>
                </ng-container>
            </ng-container>

          </div>
        </div>
    </ng-container>
    <ng-container *ngSwitchCase="'paywall'" >
      <div (focus)="outerDivFocus = true" (blur)="outerDivFocus = false"
      [class]="outerDivFocus ? 'enableFocus sampleImage': 'sampleImage'" (mouseenter)="hoverEnter()"
      (mouseleave)="hoverLeave()" >
      <label [style.visibility]="(isCursorHovering ? 'visible' : 'hidden')">
      Paywall
      </label>
      <div class="dataField bdrfill">
      <span>Paywall</span>
      </div>
     <div class="storyaction">
      <span class="deleteHeadline" (click)="deleteElement()"><i class="icon-delete"></i></span>
    </div>
     </div>
    </ng-container>

    <!-- Gif -->
    <ng-container *ngSwitchCase="'gif'">
      <ng-container *ngIf="storytype === 'story' && leadMediaGif === true">
        <div #imageElement tabindex="0" (focus)="outerDivFocus = true" (blur)="outerDivFocus = false"
          [class]="outerDivFocus ? 'enableFocus': ''">
          <ng-container *ngIf="!EditMode">
            <div class="leadMedia">
              <label style=" visibility:hidden"></label>
              <div class="dataField">
                <div class="leadimage fl wid100">
                  <div class="imageblock">
                    <div class="imagepreloader" *ngIf="!loaded">
                      <div class="a" style="--n: 5;">
                        <div class="dot dot1" style="--i: 0;"></div>
                        <div class="dot dot2" style="--i: 1;"></div>
                        <div class="dot dot3" style="--i: 2;"></div>
                        <div class="dot dot4" style="--i: 3;"></div>
                      </div>
                    </div>
                    <img [style.visibility]="loaded ? 'visible' : 'hidden'"
                      [src]="(cardData.image !== null && cardData.image.images !== null) ? sharedService.getImageOnPriority(cardData.image.images, '960x540') : null"
                      (load)="imgLoaded($event)" alt="">
                  </div>
                  <div class="editimage fl100 spImg_story">
                    <span class="fieldValidation"
                    *ngIf="captionRestrictionEnabled && sharedService.checkIfRestrictedCharactersArePresent(tempCardData.caption, 'caption')">
                    Please remove ((") ! ^ * [] {{'{}'}})</span>
                    <label [innerHTML]="cardData.image.caption"></label>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="EditMode">

            <ng-container *ngIf="!editCardFlag">
              <div class="leadMedia" (mouseenter)="hoverEnter()" (mouseleave)="hoverLeave()">
                <label style="visibility:hidden">Gif Media</label>
                <div class="dataField bdrfill">
                  <div class="leadimage fl wid100">
                    <div class="imageblock">
                      <div class="imagepreloader" *ngIf="!loaded">
                        <div class="a" style="--n: 5;">
                          <div class="dot dot1" style="--i: 0;"></div>
                          <div class="dot dot2" style="--i: 1;"></div>
                          <div class="dot dot3" style="--i: 2;"></div>
                          <div class="dot dot4" style="--i: 3;"></div>
                        </div>
                      </div>
                      <img [style.visibility]="loaded ? 'visible' : 'hidden'"
                        [src]="(cardData.image !== null && cardData.image.images !== null) ? sharedService.getImageOnPriority(cardData.image.images, '960x540') : null"
                        (load)="imgLoaded($event)" alt="">
                    </div>
                    <div class="editimage fl100">
                      <span class="fieldValidation"
                      *ngIf="captionRestrictionEnabled
                      && sharedService.checkIfRestrictedCharactersArePresent(tempCardData.caption, 'caption')">
                      Please remove ((") ! ^ * [] {{'{}'}})</span>
                      <label [innerHTML]="cardData.image.caption">pppppp</label>aaaaaa
                      <ng-container *ngIf="nestedElement">
                        <div #nestedOptions>
                          <span class="threedots"
                            (click)="showOptions = !showOptions"><span></span><span></span><span></span></span>
                          <div class="revertStoryBlock" [style.display]="showOptions ? 'block': 'none'">
                            <ul *ngIf="showOptions">
                              <li *ngIf="!photoStoryType">
                                <button (click)="triggerReplace()">Replace</button>
                              </li>
                              <li>
                                <button (click)="onelementFocus()">Edit</button>
                              </li>
                              <li *ngIf="!photoStoryType">
                                <button (click)="deleteElement()">Delete</button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
                <div class="storyaction">
                  <ng-container *ngIf="!nestedElement">
                    <span class="handle sortpara" *ngIf="!hideDragger"><i class="icon-move"></i></span>
                    <span class="editBtn" (click)="onelementFocus()"><i class="icon-pickup"></i></span>
                    <span class="cropimage" (click)="startCropping()"><i class="icon-crop"></i></span>
                    <span class="deleteHeadline" (click)="deleteElement()"><i class="icon-delete"></i></span>
                  </ng-container>
                </div>

              </div>
            </ng-container>
            <ng-container *ngIf="editCardFlag">
              <div class="leadMedia" (mouseenter)="hoverEnter()" (mouseleave)="hoverLeave()">
                <label></label>
                <div class="dataField bdrfill">
                  <div class="leadimage fl wid100">
                    <div class="imageblock">
                      <div class="imagepreloader" *ngIf="!loaded">
                        <div class="a" style="--n: 5;">
                          <div class="dot dot1" style="--i: 0;"></div>
                          <div class="dot dot2" style="--i: 1;"></div>
                          <div class="dot dot3" style="--i: 2;"></div>
                          <div class="dot dot4" style="--i: 3;"></div>
                        </div>
                      </div>
                      <img [style.visibility]="loaded ? 'visible' : 'hidden'"
                        [src]="(cardData.image !== null && cardData.image.images !== null) ? sharedService.getImageOnPriority(cardData.image.images, '960x540') : null"
                        (load)="imgLoaded($event)" alt="">
                    </div>
                    <div class="editimage">
                      <ul class="wid100 fl leadimageform">
                        <li #captionEl>
                          <label>Caption <i class="mandate">*</i></label>
                          <div id="addCaptionForImage" class="dataField">
                            <span class="fieldValidation"
                            *ngIf="captionRestrictionEnabled
                            && sharedService.checkIfRestrictedCharactersArePresent(tempCardData.caption, 'caption')">
                            Please remove ((") ! ^ * [] {{'{}'}})</span>
                            <ng-container *ngIf="isCKEditorEnabled">
                              <div (keydown)="captionKeyDownEventCk($event)">
                                <ckeditor #editorCaption [editor]="ckEditor"  id="{{id}}"
                                [(ngModel)]="tempCardData.caption"
                                [config]="ckconfig"
                                [tabindex]="0"
                                (ready)="ckchanges($event, 'ready', 'caption','caption')"
                                (change)="ckchanges($event, 'change', 'caption','caption')"
                                (blur)="ckchanges($event, 'blur', 'caption','caption')"
                                (focus)="ckchanges($event, 'focus', 'caption','caption')"
                                (error)="ckchanges($event, 'error', 'caption','caption')"
                                ></ckeditor>
                              </div>
                            </ng-container>

                          </div>
                        </li>

                        <li *ngIf="!photoStoryType">
                          <label>Title </label>
                          <div class="dataField">
                            <input id="addTitleForImage" type="text" class="textBox" [(ngModel)]="tempCardData.title"
                              placeholder="Add Title here">
                          </div>
                        </li>
                        <li *ngIf="!photoStoryType">
                          <div class="wid50 fl padr20">
                            <label>Name</label>
                            <div class="dataField">
                              <input id="addNameForImage" type="text" class="textBox" [(ngModel)]="tempCardData.name"
                                placeholder="Add Name here">
                            </div>
                          </div>
                          <div class="wid50 fr">
                            <label>Source</label>
                            <div class="dataField">
                              <input type="text" class="textBox" [(ngModel)]="tempCardData.source"
                                placeholder="Add Name here">
                            </div>
                          </div>
                        </li>
                        <li *ngIf="!photoStoryType">
                          <label>Tags</label>
                          <div class="dataField">
                            <tags-creator [broadInput]="true" [data]="tempCardData.tags" [displayText]="'enter tags'"
                              (changefn)="tempCardData.tags = $event"></tags-creator>
                          </div>
                        </li>
                        <li>
                          <label>URL</label>
                          <div class="dataField">
                            <input id="addUrlForImage" type="text" class="textBox" [(ngModel)]="tempCardData.imageUrl"
                            #url="ngModel"
                          pattern="[Hh][Tt][Tt][Pp][Ss]?:\/\/(?:(?:[a-zA-Z\u00a1-\uffff0-9]+-?)*[a-zA-Z\u00a1-\uffff0-9]+)(?:\.(?:[a-zA-Z\u00a1-\uffff0-9]+-?)*[a-zA-Z\u00a1-\uffff0-9]+)*(?:\.(?:[a-zA-Z\u00a1-\uffff]{2,}))(?::\d{2,5})?(?:\/[^\s]*)?"
                              placeholder="Add URL here">
                          </div>
                        <div *ngIf="url.touched">
                        <p *ngIf="url.errors?.pattern" style="color:red">Please enter a valid url.</p>
                      </div>
                        </li>
                        <li>
                          <label *ngIf="enableVerticalFlag">Vertical Image
                            <input type="checkbox" (click)="toggleVerticalSwitch()" [checked]="tempCardData.verticalImage">
                            <span class="checkmark"></span>
                          </label>
                        </li>
                        <div *ngIf="enableAmazonMeta">
                          <li *ngIf="tempCardData.hasOwnProperty('amazonMeta')
                          && tempCardData.hasOwnProperty('amazonTitle')
                          && tempCardData.hasOwnProperty('amazonAds')
                          && tempCardData.amazonAds.length>0" class="selectlead">
                            <label>Amazon Meta</label>
                            <div class="dataField">
                              <label class="switch">
                                <input type="checkbox" (click)="setThisAmazonMeta(elementId,$event)"
                                  [checked]="tempCardData.amazonMeta">
                                <span class="slider round"></span> </label>
                            </div>
                          </li>
                          <div class="dataField amazon-detail-box" *ngIf="tempCardData.hasOwnProperty('amazonMeta')
                          && tempCardData.hasOwnProperty('amazonTitle')
                          && tempCardData.hasOwnProperty('amazonAds')
                          && tempCardData.amazonAds.length>0
                          && tempCardData.amazonMeta">
                            <div *ngIf="
                            tempCardData.hasOwnProperty('amazonCheckedItem')
                            && !tempCardData.amazonCheckedItem">
                              <li>
                                <label>Add Amazon Custom Ads</label>
                                <div class="dataField">
                                  <input type="text" class="textBox" [(ngModel)]="tempCardData.amazonTitle"
                                  placeholder="Enter Ad title here">
                                </div>
                              </li>
                              <li>
                                <div class="dataField" style="margin-top: 1rem;">
                                  <input type="text" class="textBox" [(ngModel)]="tempCardData.amazonAds[0].key"
                                  placeholder="Enter Ad Name here">
                                </div>
                              </li>
                              <li>
                                <div class="dataField"  style="margin-top: 1rem;">
                                  <input type="text" class="textBox" [(ngModel)]="tempCardData.amazonAds[0].value"
                                  placeholder="Enter Ad Embed here">
                                </div>
                              </li>
                            </div>
                            <div *ngIf="tempCardData.hasOwnProperty('amazonCheckedItem')
                             &&tempCardData.amazonCheckedItem">
                              <h6>{{tempCardData.amazonTitle}}</h6>
                              <span>{{tempCardData.amazonAds[0].key}}:</span>
                              <span>{{tempCardData.amazonAds[0].value}}</span>
                              <span *ngIf="!tempCardData.amazonAds[0].isPresent">❌</span>
                              <span *ngIf="tempCardData.amazonAds[0].isPresent">✅</span>
                            </div>

                                  <li>
                                <button *ngIf="tempCardData.hasOwnProperty('amazonCheckedItem')
                                    &&!tempCardData.amazonCheckedItem"  tabindex="0" type="button" name="saveStory" class="createStory blue mtb15 ml10 mr30"
                                (click)="checkItemsAmazonMeta()" [class]="'save blue'" style="margin-left: 0;margin-top: 1rem;">Add</button>
                                <button *ngIf="tempCardData.hasOwnProperty('amazonCheckedItem')
                                &&tempCardData.amazonCheckedItem" tabindex="0" type="button" name="saveStory" class="createStory blue mtb15 ml10 mr30"
                                (click)="editAmazonData()" [class]="'save blue'"  style="margin-left: 0;margin-top: 1rem;">Edit</button>
                                  </li>
                          </div>
                        </div>
                        <!-- <li>
                          <label>Link</label>
                          <div class="dataField">
                            <input type="text" class="textBox" [(ngModel)]="tempCardData.link"
                            placeholder="Add Link Url here">
                          </div>
                        </li> -->
                        <!-- <li class="selectlead" *ngIf="showToggle">
                          <label>Set as Lead Media</label>
                          <div class="dataField">
                            <label class="switch">
                              <input type="checkbox" (click)="setThisAsLeadMedia()" [checked]="leadMediaId && (id === leadMediaId)">
                              <span class="slider round"></span> </label>
                          </div>
                        </li> -->
                      </ul>
                      <div class="fr wid100 right">
                        <button type="button" name="revertCard" class="createCard gray mtb15 ml10"
                          (click)="discardMetaChanges(false)" >Revert</button>
                        <button id="captionSubmitButton" type="button" name="saveStory" class="createStory blue mtb15 ml10 mr30"
                          (click)="setChangesMeta()" [class]="'save blue'">Done</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="storyaction">
                  <ng-container *ngIf="!nestedElement">
                    <span class="handle sortpara" *ngIf="!hideDragger"><i class="icon-move"></i></span>
                    <span class="deleteHeadline" (click)="deleteElement()"><i class="icon-delete"></i></span>
                  </ng-container>
                </div>

              </div>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'image'">
      <ng-container *ngIf="ogImage == true">
        <div #imageEl tabindex="0" (focus)="outerDivFocus = true" (blur)="outerDivFocus = false"
        [class]="outerDivFocus ? 'enableFocus': ''">
        <ng-container *ngIf="!EditMode">
          <div class="leadMedia">
            <label style=" visibility:hidden"></label>
            <div class="dataField">
              <div class="leadimage fl wid100">
                <div class="imageblock">
                  <div class="imagepreloader" *ngIf="!loaded">
                    <div class="a" style="--n: 5;">
                      <div class="dot dot1" style="--i: 0;"></div>
                      <div class="dot dot2" style="--i: 1;"></div>
                      <div class="dot dot3" style="--i: 2;"></div>
                      <div class="dot dot4" style="--i: 3;"></div>
                    </div>
                  </div>
                  <img [style.visibility]="loaded ? 'visible' : 'hidden'"
                    [src]="(cardData.image !== null && cardData.image.images !== null) ? sharedService.getImageOnPriority(cardData.image.images, '960x540') : null"
                    (load)="imgLoaded($event)" alt="">
                </div>
                <!--div class="editimage fl100 spImg_story">
                  <span class="fieldValidation"
                  *ngIf="captionRestrictionEnabled
                  && sharedService.checkIfRestrictedCharactersArePresent(tempCardData.caption, 'caption')">
                  Please remove ((") ! ^ * [] {{'{}'}})</span>
                  <label [innerHTML]="cardData.image.caption"></label>
                </div-->
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="EditMode">

          <ng-container>
            <div [class]="'leadMedia'" (mouseenter)="hoverEnter()" (mouseleave)="hoverLeave()">
              <label style="visibility:hidden">OG Media</label>
              <div class="dataField bdrfill">
                <div class="leadimage fl wid100">
                  <div class="imageblock">
                    <div class="imagepreloader" *ngIf="!loaded">
                      <div class="a" style="--n: 5;">
                        <div class="dot dot1" style="--i: 0;"></div>
                        <div class="dot dot2" style="--i: 1;"></div>
                        <div class="dot dot3" style="--i: 2;"></div>
                        <div class="dot dot4" style="--i: 3;"></div>
                      </div>
                    </div>
                    <img [style.visibility]="loaded ? 'visible' : 'hidden'"
                      [src]="viewImage"
                      (load)="imgLoaded($event)" alt="">
                  </div>
                  <!--div class="editimage fl100">
                    <span class="fieldValidation"
                    *ngIf="captionRestrictionEnabled
                    && sharedService.checkIfRestrictedCharactersArePresent(tempCardData.caption, 'caption')">
                    Please remove ((") ! ^ * [] {{'{}'}})</span>
                    <label class="wrap1" [innerHTML]="cardData.image.caption"></label>
                    <label class="wrapDiv" *ngIf="cardData.image.imageCredit">({{cardData.image.imageCredit}})</label>
                  </div-->
                </div>
              </div>
              <div class="storyaction">
                <ng-container *ngIf="!nestedElement">
                  <span id="icon-move" class="handle sortpara" *ngIf="!hideDragger"><i class="icon-move"></i></span>
                  <!--span id="buttonEditForImage" class="editBtn" (click)="onelementFocus()"><i class="icon-pickup"></i></span-->
                  <span id="" class="cropimage" (click)="startCropping()"><i class="icon-crop"></i></span>
                  <span class="deleteHeadline" (click)="deleteElement()"><i class="icon-delete"></i></span>
                </ng-container>
              </div>

            </div>
          </ng-container>
          <!--ng-container *ngIf="editCardFlag">
            <div class="leadMedia" (mouseenter)="hoverEnter()" (mouseleave)="hoverLeave()">
              <label></label>
              <div class="dataField bdrfill">
                <div class="leadimage fl wid100">
                  <div class="imageblock">
                    <div class="imagepreloader" *ngIf="!loaded">
                      <div class="a" style="--n: 5;">
                        <div class="dot dot1" style="--i: 0;"></div>
                        <div class="dot dot2" style="--i: 1;"></div>
                        <div class="dot dot3" style="--i: 2;"></div>
                        <div class="dot dot4" style="--i: 3;"></div>
                      </div>
                    </div>
                    <img [style.visibility]="loaded ? 'visible' : 'hidden'"
                      [src]="(cardData.image !== null && cardData.image.images !== null) ? sharedService.getImageOnPriority(cardData.image.images, '960x540') : null"
                      (load)="imgLoaded($event)" alt="">
                  </div>
                  <div class="editimage">
                    <ul class="wid100 fl leadimageform">
                      <li #captionEl>
                        <label>Caption <i class="mandate">*</i></label>
                        <div id="addCaptionForImage" class="dataField">
                          <span class="fieldValidation"
                          *ngIf="captionRestrictionEnabled
                          && sharedService.checkIfRestrictedCharactersArePresent(tempCardData.caption, 'caption')">
                          Please remove ((") ! ^ * [] {{'{}'}})</span>
                          <ng-container class="withoutHyperlink" *ngIf="!isImageCaptionHyperlink">
                            <textarea appTextareaAutoresize type="text" class="textBox" id="{{id}}" [(ngModel)]="tempCardData.caption"></textarea>
                          </ng-container>
                          <ng-container *ngIf="isCKEditorEnabled && isImageCaptionHyperlink">
                            <div (keydown)="captionKeyDownEventCk($event)">
                              <ckeditor [editor]="ckEditor"  id="{{id}}"
                              [(ngModel)]="tempCardData.caption"
                              [config]="ckconfig"
                              [tabindex]="0"
                              (ready)="ckchanges($event, 'ready', 'caption')"

                              (blur)="ckchanges($event, 'blur', 'caption')"
                              (focus)="ckchanges($event, 'focus', 'caption')"
                              (error)="ckchanges($event, 'error', 'caption')"
                              ></ckeditor>
                            </div>
                          </ng-container>
                          <ng-container  *ngIf="!isCKEditorEnabled">
                            <div (keydown)="captionKeyDownEventQuill($event)">
                              <quill-editor id="headline" [(ngModel)]="tempCardData.caption" [theme]="'snow'"
                                [modules]="captionToolbar" [placeholder]="'Add Caption here'"
                                (onContentChanged)="onEditorChange($event)"
                                (onSelectionChanged)="onEditorSelection($event, 'caption')"
                                (onEditorCreated)="editorCreated($event, 'caption')" [tabindex]="0">
                              </quill-editor>
                            </div>
                          </ng-container>
                        </div>
                      </li>
                      <li>
                        <label>Title</label>
                        <div class="dataField">
                          <input type="text" class="textBox" [(ngModel)]="tempCardData.title"
                            placeholder="Add Title here">
                        </div>
                      </li>
                      <li>
                        <div class="wid50 fl padr20">
                          <label>Name</label>
                          <div class="dataField">
                            <input type="text" class="textBox" [(ngModel)]="tempCardData.name"
                              placeholder="Add Name here">
                          </div>
                        </div>
                        <div class="wid50 fr">
                          <label>Source</label>
                          <div class="dataField">
                            <input type="text" class="textBox" [(ngModel)]="tempCardData.source"
                              placeholder="Add Name here">
                          </div>
                        </div>
                      </li>
                      <li>
                        <label>Tags</label>
                        <div class="dataField">
                          <tags-creator [broadInput]="true" [data]="tempCardData.tags" [displayText]="'enter tags'"
                            (changefn)="tempCardData.tags = $event"></tags-creator>
                        </div>
                      </li>
                      <li>
                        <label>URL</label>
                        <div class="dataField">
                          <input id="addUrlForImage" type="text" class="textBox" [(ngModel)]="tempCardData.imageUrl"
                          #url="ngModel"
                        pattern="[Hh][Tt][Tt][Pp][Ss]?:\/\/(?:(?:[a-zA-Z\u00a1-\uffff0-9]+-?)*[a-zA-Z\u00a1-\uffff0-9]+)(?:\.(?:[a-zA-Z\u00a1-\uffff0-9]+-?)*[a-zA-Z\u00a1-\uffff0-9]+)*(?:\.(?:[a-zA-Z\u00a1-\uffff]{2,}))(?::\d{2,5})?(?:\/[^\s]*)?"
                            placeholder="Add URL here">
                        </div>
                      <div *ngIf="url.touched">
                      <p *ngIf="url.errors?.pattern" style="color:red">Please enter a valid url.</p>
                    </div>
                      </li>


                      <li>
                        <label *ngIf="enableVerticalFlag">Vertical Image
                          <input type="checkbox" (click)="toggleVerticalSwitch()" [checked]="tempCardData.verticalImage">
                          <span class="checkmark"></span>
                        </label>
                      </li>


                    </ul>
                    <div class="fr wid100 right">
                      <button type="button" name="revertCard" class="createCard gray mtb15 ml10"
                        (click)="discardMetaChanges(false)" >Revert</button>
                      <button type="button" name="saveStory" class="createStory blue mtb15 ml10 mr30"
                        (click)="setChangesImageCaption()" [class]="'save blue'">Done</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="storyaction">
                <ng-container *ngIf="!nestedElement">
                  <span class="handle sortpara" *ngIf="!hideDragger"><i class="icon-move"></i></span>
                  <span class="deleteHeadline" (click)="deleteElement()"><i class="icon-delete"></i></span>
                </ng-container>
              </div>

            </div>
          </ng-container-->

        </ng-container>
        </div>
      </ng-container>
      <ng-container *ngIf="storytype !== 'photostory' && storytype !== 'gallery' && !sampleImage && ogImage != true">
        <div #imageEl tabindex="0" (focus)="outerDivFocus = true" (blur)="outerDivFocus = false"
          [class]="outerDivFocus ? 'enableFocus': ''">
          <ng-container *ngIf="!EditMode">
            <div class="leadMedia">
              <label style=" visibility:hidden"></label>
              <div class="dataField">
                <div class="leadimage fl wid100">
                  <div class="imageblock">
                    <div class="imagepreloader" *ngIf="!loaded">
                      <div class="a" style="--n: 5;">
                        <div class="dot dot1" style="--i: 0;"></div>
                        <div class="dot dot2" style="--i: 1;"></div>
                        <div class="dot dot3" style="--i: 2;"></div>
                        <div class="dot dot4" style="--i: 3;"></div>
                      </div>
                    </div>
                    <img [style.visibility]="loaded ? 'visible' : 'hidden'"
                      [src]="(cardData.image !== null && cardData.image.images !== null) ? sharedService.getImageOnPriority(cardData.image.images, '960x540') : null"
                      (load)="imgLoaded($event)" alt="">
                  </div>
                  <div class="editimage fl100 spImg_story">
                    <span class="fieldValidation"
                    *ngIf="captionRestrictionEnabled
                    && sharedService.checkIfRestrictedCharactersArePresent(tempCardData.caption, 'caption')">
                    Please remove ((") ! ^ * [] {{'{}'}})</span>
                    <label [innerHTML]="cardData.image.caption"></label>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="EditMode">

            <ng-container *ngIf="!editCardFlag">
              <div [class]="ifCroppedDomain()?'leadMedia':'leadMedia mandatoryImage'" (mouseenter)="hoverEnter()" (mouseleave)="hoverLeave()">
                <label style="visibility:hidden">Lead Media</label>
                <div class="dataField bdrfill">
                  <div class="leadimage fl wid100">
                    <div class="imageblock">
                      <div class="imagepreloader" *ngIf="!loaded">
                        <div class="a" style="--n: 5;">
                          <div class="dot dot1" style="--i: 0;"></div>
                          <div class="dot dot2" style="--i: 1;"></div>
                          <div class="dot dot3" style="--i: 2;"></div>
                          <div class="dot dot4" style="--i: 3;"></div>
                        </div>
                      </div>
                      <img [style.visibility]="loaded ? 'visible' : 'hidden'"
                        [src]="viewImage"
                        (load)="imgLoaded($event)" alt="">
                    </div>
                    <div class="editimage fl100">
                      <span class="fieldValidation"
                      *ngIf="captionRestrictionEnabled
                      && sharedService.checkIfRestrictedCharactersArePresent(tempCardData.caption, 'caption')">
                      Please remove ((") ! ^ * [] {{'{}'}})</span>
                      <label class="wrap1" [innerHTML]="cardData.image.caption"></label>
                      <label class="wrapDiv" *ngIf="cardData.image.imageCredit">({{cardData.image.imageCredit}})</label>
                      <ng-container *ngIf="nestedElement && !sampleImage">
                        <div #nestedOptions>
                          <span class="threedots"
                            (click)="showOptions = !showOptions"><span></span><span></span><span></span></span>
                          <div class="revertStoryBlock" [style.display]="showOptions ? 'block': 'none'">
                            <ul *ngIf="showOptions">
                              <li *ngIf="!photoStoryType">
                                <button (click)="triggerReplace()">Replace</button>
                              </li>
                              <li *ngIf="photoStoryType && !checkTempImage()">
                                <button (click)="triggerReplacePhotoStory()">Replace</button>
                              </li>
                              <li>
                                <button (click)="onelementFocus()">Edit</button>
                              </li>
                              <li *ngIf="photoStoryType">
                                <button (click)="startCropping()">Crop</button>
                              </li>
                              <li *ngIf="liveblogPostImage && sharedService.isdomainConfig('story','isLiveblogCrop')">
                                <button (click)="startCropping()">Crop</button>
                              </li>
                              <li *ngIf="!photoStoryType">
                                <button (click)="deleteElement()">Delete</button>
                              </li>
                              <li *ngIf="photoStoryType && checkTempImage()">
                                <button (click)="deleteTempImage()">Remove</button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
                <div class="storyaction">
                  <ng-container *ngIf="!nestedElement">
                    <span id="icon-move" class="handle sortpara" *ngIf="!hideDragger"><i class="icon-move"></i></span>
                    <span id="buttonEditForImage" class="editBtn" (click)="onelementFocus()"><i class="icon-pickup"></i></span>
                    <span id="" class="cropimage" (click)="startCropping()"><i class="icon-crop"></i></span>
                    <span class="deleteHeadline" (click)="deleteElement()"><i class="icon-delete"></i></span>
                    <span class="deleteHeadline infoIcon" [title]="returnAlertsForImages()" ></span>
                  </ng-container>
                </div>

              </div>
            </ng-container>
            <ng-container *ngIf="editCardFlag">
              <div class="leadMedia" (mouseenter)="hoverEnter()" (mouseleave)="hoverLeave()">
                <label></label>
                <div class="dataField bdrfill">
                  <div class="leadimage fl wid100">
                    <div class="imageblock">
                      <div class="imagepreloader" *ngIf="!loaded">
                        <div class="a" style="--n: 5;">
                          <div class="dot dot1" style="--i: 0;"></div>
                          <div class="dot dot2" style="--i: 1;"></div>
                          <div class="dot dot3" style="--i: 2;"></div>
                          <div class="dot dot4" style="--i: 3;"></div>
                        </div>
                      </div>
                      <img [style.visibility]="loaded ? 'visible' : 'hidden'"
                        [src]="(cardData.image !== null && cardData.image.images !== null) ? sharedService.getImageOnPriority(cardData.image.images, '960x540') : null"
                        (load)="imgLoaded($event)" alt="">
                    </div>
                    <div class="editimage">
                      <ul class="wid100 fl leadimageform">
                        <li #captionEl>
                          <label>Caption <i class="mandate">*</i></label>
                          <div id="addCaptionForImage" class="dataField">
                            <span class="fieldValidation"
                            *ngIf="captionRestrictionEnabled
                            && sharedService.checkIfRestrictedCharactersArePresent(tempCardData.caption, 'caption')">
                            Please remove ((") ! ^ * [] {{'{}'}})</span>
                            <ng-container class="withoutHyperlink" *ngIf="!isImageCaptionHyperlink">
                              <textarea appTextareaAutoresize type="text" class="textBox" id="{{id}}" [(ngModel)]="tempCardData.caption"></textarea>
                            </ng-container>
                            <ng-container *ngIf="isCKEditorEnabled && isImageCaptionHyperlink">
                              <div (keydown)="captionKeyDownEventCk($event)">
                                <ckeditor #editorCaption [editor]="ckEditor"  id="{{id}}"
                                [(ngModel)]="tempCardData.caption"
                                [config]="ckconfig"
                                [tabindex]="0"
                                (ready)="ckchanges($event, 'ready', 'caption','caption')"
                                (change)="ckchanges($event, 'change', 'caption','caption')"
                                (blur)="ckchanges($event, 'blur', 'caption','caption')"
                                (focus)="ckchanges($event, 'focus', 'caption','caption')"
                                (error)="ckchanges($event, 'error', 'caption','caption')"
                                ></ckeditor>
                                <!--  (change)="ckchanges($event, 'change', 'caption')" -->
                              </div>
                            </ng-container>
                            <ng-container  *ngIf="!isCKEditorEnabled">
                              <div (keydown)="captionKeyDownEventQuill($event)">
                                <quill-editor id="headline" [(ngModel)]="tempCardData.caption" [theme]="'snow'"
                                  [modules]="captionToolbar" [placeholder]="'Add Caption here'"
                                  (onContentChanged)="onEditorChange($event)"
                                  (onSelectionChanged)="onEditorSelection($event, 'caption')"
                                  (onEditorCreated)="editorCreated($event, 'caption')" [tabindex]="0">
                                </quill-editor>
                              </div>
                            </ng-container>
                          </div>
                        </li>
                        <li *ngIf="!photoStoryType">
                          <label>Title</label>
                          <div class="dataField">
                            <input type="text" class="textBox" [(ngModel)]="tempCardData.title"
                              placeholder="Add Title here">
                          </div>
                          <div *ngIf="!tempCardData.title || tempCardData.title.length === 0" class="validation_msg">* Title should not be empty.</div>
                          <div *ngIf="tempCardData.caption === tempCardData.title"class="validation_msg">* Title is the same as caption</div>
                        </li>
                        <li *ngIf="!photoStoryType">
                          <div class="wid50 fl padr20">
                            <label>Name</label>
                            <div class="dataField">
                              <input type="text" class="textBox" [(ngModel)]="tempCardData.name"
                                placeholder="Add Name here">
                            </div>
                          </div>
                          <div class="wid50 fr">
                            <label>Source</label>
                            <div class="dataField">
                              <input type="text" class="textBox" [(ngModel)]="tempCardData.source"
                                placeholder="Add Name here">
                            </div>
                          </div>
                        </li>
                        <li *ngIf="!photoStoryType">
                          <label>Tags</label>
                          <div class="dataField">
                            <tags-creator [broadInput]="true" [data]="tempCardData.tags" [displayText]="'enter tags'"
                              (changefn)="tempCardData.tags = $event"></tags-creator>
                          </div>
                        </li>
                        <li>
                          <label>URL</label>
                          <div class="dataField">
                            <input id="addUrlForImage" type="text" class="textBox" [(ngModel)]="tempCardData.imageUrl"
                            #url="ngModel"
                          pattern="[Hh][Tt][Tt][Pp][Ss]?:\/\/(?:(?:[a-zA-Z\u00a1-\uffff0-9]+-?)*[a-zA-Z\u00a1-\uffff0-9]+)(?:\.(?:[a-zA-Z\u00a1-\uffff0-9]+-?)*[a-zA-Z\u00a1-\uffff0-9]+)*(?:\.(?:[a-zA-Z\u00a1-\uffff]{2,}))(?::\d{2,5})?(?:\/[^\s]*)?"
                              placeholder="Add URL here">
                          </div>
                        <div *ngIf="url.touched">
                        <p *ngIf="url.errors?.pattern" style="color:red">Please enter a valid url.</p>
                      </div>
                        </li>
                        <!-- storytype=='story' || storytype=='liveblog' || storytype=='listicle' -->
                        <li class="summary relatedstories imageRelatedStories body" *ngIf="enableRelatedStoryInlineImage.indexOf(storytype)>-1">
                          <label>Related Stories
                            <div class="related_icon spImg_story" (click)="openRelatedStoryForImageTypeModal('single')" id="buttonRelatedStory">
                            <span class="tooltip">Add/Replace Related Story</span>
                          </div>
                        </label>
                          <div class="dataField">
                            <ng-container *ngFor="let story of cardData.relatedStories;let i = index">
                              <div #relatedStoryRef class="related-story-view" [arrayIndex]="i" [storyId]="story" [relatedStoryType]="relatedStoryType"
                              (receivedRelatedStoryHeadline)="receivedRelatedStoryHeadline($event)">
                                <input type="text" class="textBox" readonly [(ngModel)]="tempCardData.relatedStoryHeadline" placeholder="add related story">
                              </div>
                            </ng-container>
                          </div>
                        </li>
                        <li class="summary relatedstories imageRelatedStories body" *ngIf="enableRelatedVideoStoryInlineImage.indexOf(storytype)>-1">
                          <label>Related Video Stories
                            <div class="related_icon spImg_story" (click)="openRelatedStoryForVideoTypeModal('single')" id="buttonRelatedVideoStory">
                            <span class="tooltip leftAlign">Add/Replace Related Video Story</span>
                          </div>
                        </label>
                          <div class="dataField">
                            <ng-container *ngFor="let story of cardData.relatedVideoStories;let i = index">
                              <div #relatedStoryRef class="related-story-view" [arrayIndex]="i" [storyId]="story" [relatedStoryType]="'video'"
                              (receivedRelatedStoryHeadline)="receivedRelatedStoryHeadline($event)">
                                <input type="text" class="textBox" readonly [(ngModel)]="tempCardData.relatedStoryHeadline" placeholder="add related video story">
                              </div>
                            </ng-container>
                          </div>
                        </li>
                        <!-- <li>
                          <label>Related Stories:</label>{{photoStoryType}}
                          <div class="dataField">
                            <input type="text" class="textBox" readonly [(ngModel)]="cardData.image.alternateText"
                              placeholder="Add Title here">
                          </div>
                        </li> -->

                        <!-- <li>
                          <label>Link</label>
                          <div class="dataField">
                            <input type="text" class="textBox" [(ngModel)]="tempCardData.link"
                            placeholder="Add Link Url here">
                          </div>
                        </li> -->
                        <li class="selectlead" *ngIf="showToggle">
                          <label>Set as Lead Media</label>
                          <div class="dataField">
                            <label class="switch">
                              <input type="checkbox" (click)="setThisAsLeadMedia()" [checked]="leadMediaId && (id === leadMediaId)">
                              <span class="slider round"></span> </label>
                          </div>
                        </li>
                        <li>
                          <label *ngIf="enableVerticalFlag">Vertical Image
                            <input type="checkbox" (click)="toggleVerticalSwitch()" [checked]="tempCardData.verticalImage">
                            <span class="checkmark"></span>
                          </label>
                        </li>
                        <div *ngIf="enableAmazonMeta">
                          <li *ngIf="tempCardData.hasOwnProperty('amazonMeta')
                          && tempCardData.hasOwnProperty('amazonTitle')
                          && tempCardData.hasOwnProperty('amazonAds')
                          && tempCardData.amazonAds.length>0" class="selectlead">
                            <label>Amazon Meta</label>
                            <div class="dataField">
                              <label class="switch">
                                <input type="checkbox" (click)="setThisAmazonMeta(elementId,$event)"
                                  [checked]="tempCardData.amazonMeta">
                                <span class="slider round"></span> </label>
                            </div>
                          </li>
                          <div class="dataField amazon-detail-box" *ngIf="tempCardData.hasOwnProperty('amazonMeta')
                          && tempCardData.hasOwnProperty('amazonTitle')
                          && tempCardData.hasOwnProperty('amazonAds')
                          && tempCardData.amazonAds.length>0
                          && tempCardData.amazonMeta">
                            <div *ngIf="
                            tempCardData.hasOwnProperty('amazonCheckedItem')
                            && !tempCardData.amazonCheckedItem">
                              <li>
                                <label>Add Amazon Custom Ads</label>
                                <div class="dataField">
                                  <input type="text" class="textBox" [(ngModel)]="tempCardData.amazonTitle"
                                  placeholder="Enter Ad title here">
                                </div>
                              </li>
                              <li>
                                <div class="dataField" style="margin-top: 1rem;">
                                  <input type="text" class="textBox" [(ngModel)]="tempCardData.amazonAds[0].key"
                                  placeholder="Enter Ad Name here">
                                </div>
                              </li>
                              <li>
                                <div class="dataField"  style="margin-top: 1rem;">
                                  <input type="text" class="textBox" [(ngModel)]="tempCardData.amazonAds[0].value"
                                  placeholder="Enter Ad Embed here">
                                </div>
                              </li>
                            </div>
                            <div *ngIf="tempCardData.hasOwnProperty('amazonCheckedItem')
                             &&tempCardData.amazonCheckedItem">
                              <h6>{{tempCardData.amazonTitle}}</h6>
                              <span>{{tempCardData.amazonAds[0].key}}:</span>
                              <span>{{tempCardData.amazonAds[0].value}}</span>
                              <span *ngIf="!tempCardData.amazonAds[0].isPresent">❌</span>
                              <span *ngIf="tempCardData.amazonAds[0].isPresent">✅</span>
                            </div>
                                  <li>
                                <button *ngIf="tempCardData.hasOwnProperty('amazonCheckedItem')
                                    &&!tempCardData.amazonCheckedItem"  tabindex="0" type="button" name="saveStory" class="createStory blue mtb15 ml10 mr30"
                                (click)="checkItemsAmazonMeta()" [class]="'save blue'" style="margin-left: 0;margin-top: 1rem;">Add</button>
                                <button *ngIf="tempCardData.hasOwnProperty('amazonCheckedItem')
                                &&tempCardData.amazonCheckedItem" tabindex="0" type="button" name="saveStory" class="createStory blue mtb15 ml10 mr30"
                                (click)="editAmazonData()" [class]="'save blue'"  style="margin-left: 0;margin-top: 1rem;">Edit</button>
                                  </li>
                          </div>
                        </div>

                        <li>
                          <div class="dataField caption-position">
                            <span class="switch-button-caption">Caption Position</span>
                            <button class="switch-button button-margin" (click)="captionPosition(true)" [ngClass]="{'switch-button-active':this.tempCardData.overImage}">Over Image</button>
                            <button class="switch-button" (click)="captionPosition(false)" [ngClass]="{'switch-button-active':!this.tempCardData.overImage}">Below Image</button>
                          </div>
                        </li>
                      </ul>
                      <div class="fr wid100 right">
                        <button type="button" name="revertCard" class="createCard gray mtb15 ml10"
                          (click)="discardMetaChanges(false)" >Revert</button>
                        <button type="button" name="saveStory" class="createStory blue mtb15 ml10 mr30"
                          (click)="setChangesImageCaption()" [class]="'save blue'">Done</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="storyaction">
                  <ng-container *ngIf="!nestedElement">
                    <span class="handle sortpara" *ngIf="!hideDragger"><i class="icon-move"></i></span>
                    <span class="deleteHeadline" (click)="deleteElement()"><i class="icon-delete"></i></span>
                  </ng-container>
                </div>

              </div>
            </ng-container>

          </ng-container>
        </div>
      </ng-container>
      <!-- photogallery new design -->
      <ng-container *ngIf="storytype === 'gallery' && ogImage != true">
        <div #imageEl tabindex="0" (focus)="outerDivFocus = true" (blur)="outerDivFocus = false"
          [class]="outerDivFocus ? 'enableFocus': ''">
          <ng-container *ngIf="!EditMode">
            <div class="leadMedia">
              <label style=" visibility:hidden"></label>
              <div class="dataField">
                <div class="leadimage fl wid100">
                  <div class="imageblock">
                    <div class="imagepreloader" *ngIf="!loaded">
                      <div class="a" style="--n: 5;">
                        <div class="dot dot1" style="--i: 0;"></div>
                        <div class="dot dot2" style="--i: 1;"></div>
                        <div class="dot dot3" style="--i: 2;"></div>
                        <div class="dot dot4" style="--i: 3;"></div>
                      </div>
                    </div>
                    <img [style.visibility]="loaded ? 'visible' : 'hidden'"
                      [src]="(cardData.image !== null && cardData.image.images !== null) ? sharedService.getImageOnPriority(cardData.image.images, '960x540') : null"
                      (load)="imgLoaded($event)" alt="">
                  </div>
                  <div class="editimage fl100 spImg_story">
                    <span class="fieldValidation"
                    *ngIf="captionRestrictionEnabled
                    && sharedService.checkIfRestrictedCharactersArePresent(tempCardData.caption, 'caption')">
                    Please remove ((") ! ^ * [] {{'{}'}})</span>
                    <label [innerHTML]="cardData.image.caption"></label>

                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="EditMode">

            <ng-container *ngIf="!editCardFlag">
              <div [class]="ifCroppedDomain()?'leadMedia':'leadMedia mandatoryImage'" (mouseenter)="hoverEnter()" (mouseleave)="hoverLeave()">
                <label style="visibility:hidden">Lead Media</label>
                <div class="dataField bdrfill">
                  <div class="leadimage fl wid100 photoGallery_new">
                    <div class="imageblock">
                      <div class="imagepreloader" *ngIf="!loaded">
                        <div class="a" style="--n: 5;">
                          <div class="dot dot1" style="--i: 0;"></div>
                          <div class="dot dot2" style="--i: 1;"></div>
                          <div class="dot dot3" style="--i: 2;"></div>
                          <div class="dot dot4" style="--i: 3;"></div>
                        </div>
                      </div>
                      <img [style.visibility]="loaded ? 'visible' : 'hidden'"
                        [src]="viewImage"
                        (load)="imgLoaded($event)" alt="">
                    </div>
                    <div class="editimage fl100">
                      <span class="fieldValidation"
                      *ngIf="captionRestrictionEnabled
                      && sharedService.checkIfRestrictedCharactersArePresent(tempCardData.caption, 'caption')">
                      Please remove ((") ! ^ * [] {{'{}'}})</span>
                      <!-- <label class="wrap1" [innerHTML]="cardData.image.caption"></label> -->
                      <div class="dataField">
                        <label>Caption <i class="mandate">*</i></label>
                        <input type="text" class="textBox" [ngModel]="htmlToPlaintext(cardData.image.caption)"
                          placeholder="Edit to add caption here" readonly>
                      </div>
                      <div class="dataField">
                        <label>Source</label>
                        <input type="text" class="textBox" [ngModel]="cardData.image.imageCredit"
                          placeholder="Edit to add source here" readonly>
                      </div>
                      <!-- <label class="wrapDiv" *ngIf="cardData.image.imageCredit">({{cardData.image.imageCredit}})</label> -->
                      <ng-container *ngIf="nestedElement">
                        <div #nestedOptions>
                          <span class="threedots"
                            (click)="showOptions = !showOptions"><span></span><span></span><span></span></span>
                          <div class="revertStoryBlock" [style.display]="showOptions ? 'block': 'none'">
                            <ul *ngIf="showOptions">
                              <li *ngIf="!photoStoryType">
                                <button (click)="triggerReplace()">Replace</button>
                              </li>
                              <li *ngIf="photoStoryType && !checkTempImage()">
                                <button (click)="triggerReplacePhotoStory()">Replace</button>
                              </li>
                              <li>
                                <button (click)="onelementFocus()">Edit</button>
                              </li>
                              <li *ngIf="photoStoryType">
                                <button (click)="startCropping()">Crop</button>
                              </li>
                              <li *ngIf="liveblogPostImage && sharedService.isdomainConfig('story','isLiveblogCrop')">
                                <button (click)="startCropping()">Crop</button>
                              </li>
                              <li *ngIf="!photoStoryType">
                                <button (click)="deleteElement()">Delete</button>
                              </li>
                              <li *ngIf="photoStoryType && checkTempImage()">
                                <button (click)="deleteTempImage()">Remove</button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
                <div class="storyaction">
                  <ng-container *ngIf="!nestedElement">
                    <span id="icon-move" class="handle sortpara" *ngIf="!hideDragger"><i class="icon-move"></i></span>
                    <span id="buttonEditForImage" class="editBtn" (click)="onelementFocus()"><i class="icon-pickup"></i></span>
                    <span id="" class="cropimage" (click)="startCropping()"><i class="icon-crop"></i></span>
                    <span class="deleteHeadline" (click)="deleteElement()"><i class="icon-delete"></i></span>
                    <span *ngIf="leadMediaId && (id === leadMediaId)" class="deleteHeadline  leadMediaNew">L</span>

                  </ng-container>
                </div>

              </div>
            </ng-container>
            <ng-container *ngIf="editCardFlag">
              <div class="leadMedia" (mouseenter)="hoverEnter()" (mouseleave)="hoverLeave()">
                <label></label>
                <div class="dataField bdrfill">
                  <div class="leadimage fl wid100">
                    <div class="imageblock">
                      <div class="imagepreloader" *ngIf="!loaded">
                        <div class="a" style="--n: 5;">
                          <div class="dot dot1" style="--i: 0;"></div>
                          <div class="dot dot2" style="--i: 1;"></div>
                          <div class="dot dot3" style="--i: 2;"></div>
                          <div class="dot dot4" style="--i: 3;"></div>
                        </div>
                      </div>
                      <img [style.visibility]="loaded ? 'visible' : 'hidden'"
                        [src]="(cardData.image !== null && cardData.image.images !== null) ? sharedService.getImageOnPriority(cardData.image.images, '960x540') : null"
                        (load)="imgLoaded($event)" alt="">
                    </div>
                    <div class="editimage">
                      <ul class="wid100 fl leadimageform">
                        <li #captionEl>
                          <label>Caption <i class="mandate">*</i></label>
                          <div id="addCaptionForImage" class="dataField">
                            <span class="fieldValidation"
                            *ngIf="captionRestrictionEnabled
                            && sharedService.checkIfRestrictedCharactersArePresent(tempCardData.caption, 'caption')">
                            Please remove ((") ! ^ * [] {{'{}'}})</span>
                            <ng-container *ngIf="isCKEditorEnabled">
                              <div (keydown)="captionKeyDownEventCk($event)">
                                <ckeditor #editorCaption [editor]="ckEditor"  id="{{id}}"
                                [(ngModel)]="tempCardData.caption"
                                [config]="ckconfig"
                                [tabindex]="0"
                                (ready)="ckchanges($event, 'ready', 'caption','caption')"
                                (change)="ckchanges($event, 'change', 'caption','caption')"
                                (blur)="ckchanges($event, 'blur', 'caption','caption')"
                                (focus)="ckchanges($event, 'focus', 'caption','caption')"
                                (error)="ckchanges($event, 'error', 'caption','caption')"
                                ></ckeditor>
                              </div>
                            </ng-container>

                          </div>
                        </li>
                        <li *ngIf="!photoStoryType">
                          <label>Title</label>
                          <div class="dataField">
                            <input type="text" class="textBox" [(ngModel)]="tempCardData.title"
                              placeholder="Add Title here">
                          </div>
                        </li>
                        <li *ngIf="!photoStoryType">
                          <div class="wid50 fl padr20">
                            <label>Name</label>
                            <div class="dataField">
                              <input type="text" class="textBox" [(ngModel)]="tempCardData.name"
                                placeholder="Add Name here">
                            </div>
                          </div>
                          <div class="wid50 fr">
                            <label>Source</label>
                            <div class="dataField">
                              <input type="text" class="textBox" [(ngModel)]="tempCardData.source"
                                placeholder="Add Name here">
                            </div>
                          </div>
                        </li>
                        <li *ngIf="!photoStoryType">
                          <label>Tags</label>
                          <div class="dataField">
                            <tags-creator [broadInput]="true" [data]="tempCardData.tags" [displayText]="'enter tags'"
                              (changefn)="tempCardData.tags = $event"></tags-creator>
                          </div>
                        </li>
                        <li>
                          <label>URL</label>
                          <div class="dataField">
                            <input id="addUrlForImage" type="text" class="textBox" [(ngModel)]="tempCardData.imageUrl"
                            #url="ngModel"
                          pattern="[Hh][Tt][Tt][Pp][Ss]?:\/\/(?:(?:[a-zA-Z\u00a1-\uffff0-9]+-?)*[a-zA-Z\u00a1-\uffff0-9]+)(?:\.(?:[a-zA-Z\u00a1-\uffff0-9]+-?)*[a-zA-Z\u00a1-\uffff0-9]+)*(?:\.(?:[a-zA-Z\u00a1-\uffff]{2,}))(?::\d{2,5})?(?:\/[^\s]*)?"
                              placeholder="Add URL here">
                          </div>
                        <div *ngIf="url.touched">
                        <p *ngIf="url.errors?.pattern" style="color:red">Please enter a valid url.</p>
                      </div>
                        </li>
                        <!-- storytype=='story' || storytype=='liveblog' || storytype=='listicle' -->
                        <li class="summary relatedstories imageRelatedStories body" *ngIf="enableRelatedStoryInlineImage.indexOf(storytype)>-1">
                          <label>Related Stories
                            <div class="related_icon spImg_story" (click)="openRelatedStoryForImageTypeModal('single')" id="buttonRelatedStory">
                            <span class="tooltip">Add/Replace Related Story</span>
                          </div>
                        </label>
                          <div class="dataField">
                            <ng-container *ngFor="let story of cardData.relatedStories;let i = index">
                              <div #relatedStoryRef class="related-story-view" [arrayIndex]="i" [storyId]="story" [relatedStoryType]="relatedStoryType"
                              (receivedRelatedStoryHeadline)="receivedRelatedStoryHeadline($event)">
                                <input type="text" class="textBox" readonly [(ngModel)]="tempCardData.relatedStoryHeadline" placeholder="add related story">
                              </div>
                            </ng-container>
                          </div>
                        </li>
                        <li class="summary relatedstories imageRelatedStories body" *ngIf="enableRelatedVideoStoryInlineImage.indexOf(storytype)>-1">
                          <label>Related Video Stories
                            <div class="related_icon spImg_story" (click)="openRelatedStoryForVideoTypeModal('single')" id="buttonRelatedVideoStory">
                            <span class="tooltip">Add/Replace Related Video Story</span>
                          </div>
                        </label>
                          <div class="dataField">
                            <ng-container *ngFor="let story of cardData.relatedVideoStories;let i = index">
                              <div #relatedStoryRef class="related-story-view" [arrayIndex]="i" [storyId]="story" [relatedStoryType]="'video'"
                              (receivedRelatedStoryHeadline)="receivedRelatedStoryHeadline($event)">
                                <input type="text" class="textBox" readonly [(ngModel)]="tempCardData.relatedStoryHeadline" placeholder="add related video story">
                              </div>
                            </ng-container>
                          </div>
                        </li>
                        <!-- <li>
                          <label>Related Stories:</label>{{photoStoryType}}
                          <div class="dataField">
                            <input type="text" class="textBox" readonly [(ngModel)]="cardData.image.alternateText"
                              placeholder="Add Title here">
                          </div>
                        </li> -->

                        <!-- <li>
                          <label>Link</label>
                          <div class="dataField">
                            <input type="text" class="textBox" [(ngModel)]="tempCardData.link"
                            placeholder="Add Link Url here">
                          </div>
                        </li> -->
                        <li class="selectlead" *ngIf="showToggle">
                          <label>Set as Lead Media</label>
                          <div class="dataField">
                            <label class="switch">
                              <input type="checkbox" (click)="setThisAsLeadMedia()" [checked]="leadMediaId && (id === leadMediaId)">
                              <span class="slider round"></span> </label>
                          </div>
                        </li>
                        <li>
                          <label *ngIf="enableVerticalFlag">Vertical Image
                            <input type="checkbox" (click)="toggleVerticalSwitch()" [checked]="tempCardData.verticalImage">
                            <span class="checkmark"></span>
                          </label>
                        </li>
                        <div *ngIf="enableAmazonMeta">
                          <li *ngIf="tempCardData.hasOwnProperty('amazonMeta')
                          && tempCardData.hasOwnProperty('amazonTitle')
                          && tempCardData.hasOwnProperty('amazonAds')
                          && tempCardData.amazonAds.length>0" class="selectlead">
                            <label>Amazon Meta</label>
                            <div class="dataField">
                              <label class="switch">
                                <input type="checkbox" (click)="setThisAmazonMeta(elementId,$event)"
                                  [checked]="tempCardData.amazonMeta">
                                <span class="slider round"></span> </label>
                            </div>
                          </li>
                          <div class="dataField amazon-detail-box" *ngIf="tempCardData.hasOwnProperty('amazonMeta')
                          && tempCardData.hasOwnProperty('amazonTitle')
                          && tempCardData.hasOwnProperty('amazonAds')
                          && tempCardData.amazonAds.length>0
                          && tempCardData.amazonMeta">
                            <div *ngIf="
                            tempCardData.hasOwnProperty('amazonCheckedItem')
                            && !tempCardData.amazonCheckedItem">
                              <li>
                                <label>Add Amazon Custom Ads</label>
                                <div class="dataField">
                                  <input type="text" class="textBox" [(ngModel)]="tempCardData.amazonTitle"
                                  placeholder="Enter Ad title here">
                                </div>
                              </li>
                              <li>
                                <div class="dataField" style="margin-top: 1rem;">
                                  <input type="text" class="textBox" [(ngModel)]="tempCardData.amazonAds[0].key"
                                  placeholder="Enter Ad Name here">
                                </div>
                              </li>
                              <li>
                                <div class="dataField"  style="margin-top: 1rem;">
                                  <input type="text" class="textBox" [(ngModel)]="tempCardData.amazonAds[0].value"
                                  placeholder="Enter Ad Embed here">
                                </div>
                              </li>
                            </div>
                            <div *ngIf="tempCardData.hasOwnProperty('amazonCheckedItem')
                             &&tempCardData.amazonCheckedItem">
                              <h6>{{tempCardData.amazonTitle}}</h6>
                              <span>{{tempCardData.amazonAds[0].key}}:</span>
                              <span>{{tempCardData.amazonAds[0].value}}</span>
                              <span *ngIf="!tempCardData.amazonAds[0].isPresent">❌</span>
                              <span *ngIf="tempCardData.amazonAds[0].isPresent">✅</span>
                            </div>
                                  <li>
                                <button *ngIf="tempCardData.hasOwnProperty('amazonCheckedItem')
                                    &&!tempCardData.amazonCheckedItem"  tabindex="0" type="button" name="saveStory" class="createStory blue mtb15 ml10 mr30"
                                (click)="checkItemsAmazonMeta()" [class]="'save blue'" style="margin-left: 0;margin-top: 1rem;">Add</button>
                                <button *ngIf="tempCardData.hasOwnProperty('amazonCheckedItem')
                                &&tempCardData.amazonCheckedItem" tabindex="0" type="button" name="saveStory" class="createStory blue mtb15 ml10 mr30"
                                (click)="editAmazonData()" [class]="'save blue'"  style="margin-left: 0;margin-top: 1rem;">Edit</button>
                                  </li>
                          </div>
                        </div>
                      </ul>
                      <div class="fr wid100 right">
                        <button type="button" name="revertCard" class="createCard gray mtb15 ml10"
                          (click)="discardMetaChanges(false)" >Revert</button>
                        <button type="button" name="saveStory" class="createStory blue mtb15 ml10 mr30"
                          (click)="setChangesMeta()" [class]="'save blue'">Done</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="storyaction">
                  <ng-container *ngIf="!nestedElement">
                    <span class="handle sortpara" *ngIf="!hideDragger"><i class="icon-move"></i></span>
                    <span class="deleteHeadline" (click)="deleteElement()"><i class="icon-delete"></i></span>
                  </ng-container>
                </div>

              </div>
            </ng-container>

          </ng-container>
        </div>
      </ng-container>
      <ng-container *ngIf="storytype === 'photostory' && ogImage != true">
        <div tabindex="0" (focus)="outerDivFocus = true" (blur)="outerDivFocus = false"
          [class]="outerDivFocus ? 'enableFocus blockShow': 'blockShow'" (mouseenter)="hoverEnter()" (mouseleave)="hoverLeave()" (click)="editorClick('desc')">
          <ul class="listicleBlock storyuL bdrfillN">
            <ng-container *ngIf="isSlideTitleEnabled">
              <li class="headline">
                <label [style.visibility]="(setCheckForErrorIndication('slideTitle')) ? 'visible' : 'hidden'">
                  Slide Title
                  <i class="mandate">*</i>
                  <span>{{htmlToPlaintext(cardData.title)?.length}}/{{200}} char'</span>
                </label>
                <ng-container *ngIf="sharedService.isdomainConfig('story','isStoryListingEnabled')">
                  <button id="backlinkID" class="story_link" *ngIf="showHyperlinkIcon" (click)="hyperlinkStoryList($event, 'desc')">
                    <i class="icomoon icon-link icon-info" data-title="Hyperlink StoryList"></i></button>
                </ng-container>
                <div class="dataField">
                  <ng-container *ngIf="isCKEditorEnabled">
                    <div id="editor" (keyup)="titleKeyUpEvent($event)" (keydown)="titleKeyDownEventCk($event)">
                      <ckeditor #editorTitle [editor]="ckEditor"  id="{{id}}"
                      [(ngModel)]="cardData.title"
                      [config]="ckplainconfig"
                      [tabindex]="0"
                      (ready)="ckchanges($event, 'ready', 'title','title')"
                      (change)="ckchanges($event, 'change', 'title','title')"
                      (blur)="ckchanges($event, 'blur', 'title','title')"
                      (focus)="ckchanges($event, 'focus', 'title','title')"
                      (error)="ckchanges($event, 'error', 'title','title')"
                      ></ckeditor>
                    </div>
                  </ng-container>

                </div>
              </li>
            </ng-container>

            <li class="leadMedia" id="leadMedia">
              <ng-container  *ngIf="!cardData.id && checkTempImage()">
                <div class="element-module" #photoPhotoStory  [EditMode]="EditMode" [id]="tempImage"
                  [cardId]="tempImage" (deleteCardfn)="deleteImageCardEmit($event)"
                  (sendWordCountToStory)="getWordCount($event)" [nestedElement]="true" [hideDragger]="true"
                  (previousFocusEmit)="focusOnElement($event, 'up')" [showToggle]="false" (setPhotoStoryLeadMedia)="updatePhotoStoryLeadMedia($event)"
                  (updateContentOnParent)="resgisterDataChangeToParent($event)" [photoStoryType]='true'
                  (nextFocusEmit)="focusOnElement($event, 'down')" (outputEmbedSourceUrl)=getEmbedSourceUrl($event)
                  [leadMediaId]="leadMediaId">
                </div>
              </ng-container>
              <ng-container  *ngIf="cardData.id && cardData.image.images">
                <div class="element-module" #photoPhotoStory  [EditMode]="EditMode" [id]="cardData.id"
                  [cardId]="cardData.id" (deleteCardfn)="deleteImageCardEmit($event)"
                  [showToggle]="true" [photoStoryType]='true' (setPhotoStoryLeadMedia)="updatePhotoStoryLeadMedia($event)"
                  (sendWordCountToStory)="getWordCount($event)" [nestedElement]="true" [hideDragger]="true"
                  (previousFocusEmit)="focusOnElement($event, 'up')"
                  (updateContentOnParent)="resgisterDataChangeToParent($event)"
                  (nextFocusEmit)="focusOnElement($event, 'down')" (outputEmbedSourceUrl)=getEmbedSourceUrl($event)
                  [leadMediaId]="leadMediaId">
                </div>
              </ng-container>
              <ng-container *ngIf="uploadImageInProgress">
                <div class="imagepreloader">
                  <div class="a" style="--n: 5;">
                    <div class="dot dot1" style="--i: 0;"></div>
                    <div class="dot dot2" style="--i: 1;"></div>
                    <div class="dot dot3" style="--i: 2;"></div>
                    <div class="dot dot4" style="--i: 3;"></div>
                  </div>
                </div>
              </ng-container>
              <!-- <ng-container *ngIf="!cardData.photoStory.inlineElementId && EditMode && !uploadImageInProgress"> -->
                <ng-container *ngIf="!cardData.id && !checkTempImage() && EditMode && !uploadImageInProgress ">
                <label [style.visibility]="focusOnLeadMedia ? 'visible' : 'hidden'">Lead Media</label>
                <div class="dataField" tabindex="3">
                  <ul [ngClass]="{'z-high': leadMediaImageToggle}" class="leadMediaIcon">
                    <li class="spImg_story" #innerLeadel>
                      <span class="i_image" [ngClass]="{'active' : leadMediaImageToggle}" (click)="listClick($event,1)"><i
                          class="icon-image" id="iconForImageUpload"></i></span>
                      <div [class]="'imageAction' +  (leadMediaImageToggle ? ' block' : '') ">
                        <div class="blockContain">
                          <div class="uploadimage"><i class="icon-upload"></i>
                            <div class="upload-btn-wrapper">
                              <span class="btn">Upload a new Image</span>
                              <input type="file" accept="image/*" name="myfile" (change)="onFileChange($event, 'elements')" />
                            </div>
                          </div>
                          <div class="pickimage"><i class="icon-image-library"></i>
                            <span (click)="showGallery()" id="imagePicFromLib" class="pickimageBtn">Pick from Image Library</span>
                            <div class="lightBox block" *ngIf="isLightbox">
                              <div class="headerLight">
                                <div class="close fl spImg" (click)="disableshowGallery()"></div>
                              </div>
                              <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="getLeadMediaId($event, true)"
                                *ngIf="isPhotopopup"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>

                  </ul>
                </div>
              </ng-container>
            </li>
            <li class="summary">
              <label style="visibility:hidden">Detail
                <span>{{(cardData.paragraph.body ? htmlToPlaintext(cardData.paragraph.body).length : '0')}}/80 char</span>
              </label>
               <ng-container *ngIf="sharedService.isdomainConfig('story','isStoryListingEnabled')">
                <button id="backlinkID" class="story_link" *ngIf="showHyperlinkIcon" (click)="hyperlinkStoryList($event, 'desc')">
                  <i class="icomoon icon-link icon-info" data-title="Hyperlink StoryList"></i></button>
              </ng-container>
              <div class="dataField" #descEl>
                <!-- <textarea type="text" class="textBox" placeholder="Point 1 description" onkeyup="auto_grow(this)"></textarea> -->
                <ng-container *ngIf="isCKEditorEnabled">
                  <div id="editor" (keyup)="descriptionKeyUpEvent($event)" (keydown)="descriptionKeyDownEventCk($event)">
                    <ckeditor #editorPara [editor]="ckEditor2"  id="{{id}}"
                    placeholder="Post's description"
                    [(ngModel)]="cardData.paragraph.body"
                    [config]="getEditorConfig()"
                    [tabindex]="0"
                    (ready)="ckchanges($event, 'ready', 'desc','parabody')"
                    (change)="ckchanges($event, 'change', 'desc','parabody')"
                    (blur)="ckchanges($event, 'blur', 'desc','parabody')"
                    (focus)="ckchanges($event, 'focus', 'desc','parabody')"
                    (error)="ckchanges($event, 'error', 'desc','parabody')"
                    ></ckeditor>
                  </div>
                </ng-container>

              </div>
            </li>
          </ul>
          <div class="storyaction" *ngIf="EditMode && (id !== 'newPhotostoryElement')">
            <span class="handle sortpara" *ngIf="!hideDragger"><i class="icon-move"></i></span>
            <span class="deleteHeadline" (click)="deleteElement()"><i class="icon-delete"></i></span>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="sampleImage">
        <img style="width: 100%;height: 95px;"
          [src]="(cardData.image !== null && cardData.image.images !== null) ? sharedService.getImageOnPriority(cardData.image.images, 'thumbnail') : null"
          (load)="imgLoaded($event)" alt="">

      </ng-container>
      <ng-container *ngIf="storytype === 'story' && cardData.image.ausScore > minAusScore && !cardData.image.feedback">
        <div>
        <div class="goodImage">
          <p> As per our algo, this is a good quality image. Do you agree?</p>
          <button class="blue marginL0" (click)="setFeedback('YES')">YES </button>
          <button class="green" (click)="setFeedback('NO')">NO </button>
        </div>
      </div>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'video'">
      <!-- <label></label> -->
      <div #videoEl tabindex="0" (focus)="outerDivFocus = true" (blur)="outerDivFocus = false"
        [class]="outerDivFocus ? 'enableFocus videoComponent': 'videoComponent'" (mouseenter)="hoverEnter()" (mouseleave)="hoverLeave()" id="videoComponentOnStoryPage">
        <label [class]="leadMedia ? 'leadMedia displayLabel' : 'leadMedia nonDisplayLabel'"> &nbsp;</label>
        <div class="dataField bdrfill">
          <ng-container *ngIf="video_iframe_html !== null">
            <div class="respVideo" [innerHtml]="video_iframe_html"></div>
            <ng-container class="videocaption" *ngIf="enableLeadVideoCaption && leadVideoThumbnail">
            <div class="videoPropBlock">
              <label class="vedeoCaption">{{cardData.video['caption']}}</label>
              <span class="btnAction" (click)="editVideoCaption()"><i class="icon-pickup"></i></span>
            </div>
            <div class="videoPropBlock" *ngIf="iseditVideCaptionClick || !cardData.video['caption']">
              <div class="videoEntryBlock" #captionEl>
                <label>Caption <i class="mandate">*</i></label>
                <div class="dataField">
                  <span class="fieldValidation"
                  *ngIf="captionRestrictionEnabled
                  && sharedService.checkIfRestrictedCharactersArePresent(tempCardData.caption, 'caption')">
                  Please remove ((") ! ^ * [] {{'{}'}})</span>
                  <ng-container *ngIf="isCKEditorEnabled">
                    <div>
                      <ckeditor #editorCaption [editor]="ckEditor"  id="{{id}}"
                      [(ngModel)]="tempCardData.caption"
                      (ready)="ckchanges($event, 'ready', 'caption','caption')"
                      (blur)="ckchanges($event, 'blur', 'caption','caption')"
                      (focus)="ckchanges($event, 'focus', 'caption','caption')"
                      (change)="ckchanges($event, 'change', 'caption','caption')"
                      [config]="ckconfig"
                      [tabindex]="0"
                      ></ckeditor>
                    </div>
                  </ng-container>
                </div>
              </div>
              <div class="fr wid100 right">
                <!-- <button class="createCard gray mtb15 ml10" name="revertCard" type="button" (click)="revertVideoCaption()">Revert</button> -->
                <button class="save blue" name="saveStory" type="button" (click)="addVideoCaption()">Done</button>
              </div>

            </div>
            </ng-container>
            <div class="videoImage" *ngIf="enableLeadVideoPreview && leadVideoThumbnail">
              <img
                      [src]="(cardData.video !== null && cardData.video.image !== null && cardData.video.image.images !== null) ? sharedService.getImageOnPriority(cardData.video.image.images, '960x540') : null"
                      (load)="imgLoaded($event)" alt="">
                    </div>
                    <ng-container class="videocaption" *ngIf="enableLeadVideoImageCaption && leadVideoThumbnail && cardData.video.image !== null && (cardData.video.image.images | json) != '{}'">
                      <div class="videoPropBlock">
                        <label class="vedeoCaption">{{cardData.video['image']['caption']}}</label>
                        <span class="btnAction" (click)="editVideoImageCaption()"><i class="icon-pickup"></i></span>
                      </div>
                      <div class="videoPropBlock" *ngIf="iseditVideImageCaptionClick || !cardData.video['image']['caption']">
                        <div class="videoEntryBlock" #captionEl>
                          <label>Caption <i class="mandate">*</i></label>
                          <div class="dataField">
                            <span class="fieldValidation"
                            *ngIf="captionRestrictionEnabled
                            && sharedService.checkIfRestrictedCharactersArePresent(tempCardData.videoImageCaption, 'caption')">
                            Please remove ((") ! ^ * [] {{'{}'}})</span>
                            <ng-container *ngIf="isCKEditorEnabled">
                              <div>
                                <ckeditor #editorVideoCaption [editor]="ckEditor"  id="{{id}}"
                                [(ngModel)]="tempCardData.videoImageCaption"
                                (ready)="ckchanges($event, 'ready', 'videoImageCaption','videoImageCaption')"
                                [config]="ckconfig"
                                [tabindex]="0"
                                ></ckeditor>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                        <div class="fr wid100 right">
                          <!-- <button class="createCard gray mtb15 ml10" name="revertCard" type="button" (click)="revertVideoCaption()">Revert</button> -->
                          <button class="save blue" name="saveStory" type="button" (click)="addVideoImageCaption()">Done</button>
                        </div>

                      </div>
                      </ng-container>
          </ng-container>
        </div>
        <div class="storyaction">
          <span *ngIf="EditMode && !hideDragger && ( isPage || (storytype && (storytype === 'story' || storytype ==='mediagallery' || storytype ==='liveblog')))" class="handle sortpara"><i class="icon-move"></i></span>
          <span class="deleteHeadline" (click)="copyVideoIframe()"><i class="icon-cards"></i></span>
          <span *ngIf="EditMode && (!storytype || (storytype !== 'story' && storytype !=='mediagallery' && storytype !=='liveblog'))" (click)="openVideoOptions()"><i class="icon-delete" id="deleteButtonOnVideoComponentOnStoryPage"></i>
            <div [class]="videoOptions ? 'videoStoryOption block' : 'videoStoryOption'" id="deleteVideoComponentBlock">
              <ul>
                <li>
                  <button (click)="changeVideoUrl()">Insert Video Embed</button>
                </li>
                <li>
                  <button (click)="showVideoGallery()" id="pickUpStoryButton">Pick from Library</button>
                </li>
              </ul>
            </div>
          </span>
  <!-- video replacing thumbnail  -->
             <span *ngIf="enableReplaceVideoThumbnail && leadVideoThumbnail" class="i_image" [ngClass]="{'active' : leadMediaImageToggle}" (click)="videoImageChange($event,1)">
              <i class="icon-image"></i></span>
            <div [class]="'imageAction leadVideo' + (leadMediaImageToggle ? ' block' : '')">
              <div class="blockContain">
                <div class="uploadimage" #innerLeadel><i class="icon-upload"></i>
                  <div class="upload-btn-wrapper">
                    <span class="btn">Upload a new Video Image</span>
                    <input type="file" accept="image/*" name="myfile" (change)="onFileChangeSingleThumbnail($event, 'addCustomVideoThumbnail')" />
                  </div>
                </div>
                <div class="pickimage" (click)="showGallery()" ><i class="icon-image-library"></i>
                  <span class="pickimageBtn">Pick from Video Image Library</span>
                </div>
              </div>
            </div>
          <span *ngIf="EditMode && (storytype && (storytype === 'story' || storytype ==='mediagallery' || storytype ==='liveblog'))" (click)="deleteElement()"><i class="icon-delete"></i></span>
        </div>
        <div class="lightBox block" *ngIf="isLightbox && enableReplaceVideoThumbnail && leadVideoThumbnail">
          <div class="headerLight">
            <div class="close fl spImg" (click)="disableshowGallery()"></div>
          </div>
          <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="addWireImageForReplaceVideoThumbnail($event)" *ngIf="isPhotopopup"></div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'embed'">
      <!-- <label></label> -->
      <div #embedEl tabindex="0" (focus)="outerDivFocus = true" (blur)="outerDivFocus = false"
        [class]="outerDivFocus ? 'enableFocus embeddcode': 'embeddcode'" (mouseenter)="hoverEnter()"
        (mouseleave)="hoverLeave()">
        <label [style.visibility]="(isCursorHovering ? 'visible' : 'hidden')">
          Embed Code
        </label>
        <div class="dataField bdrfill">
          <b>{{cardData.embed.title}}</b> <br><br>
          <ng-container *ngIf="cardData.amazonAds && cardData.amazonAds.length > 0">

            <ng-container *ngFor="let amazonAd of cardData.amazonAds">
              <span>{{amazonAd.key}}</span> : <span>{{amazonAd.value}} </span>
              <span *ngIf="amazonAd.isPresent !=undefined && amazonAd.isPresent==false; else presentBlock">❌</span>
              <ng-template #presentBlock>
                <span>✅</span>
              </ng-template>
              <br><br>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="cardData.snapdealAds && cardData.snapdealAds.length > 0">
            <!-- <b>{{cardData.embed.title}}</b> <br><br> -->
            <ng-container *ngFor="let snapdealAd of cardData.snapdealAds">
              <span>{{snapdealAd.key}}</span> : <span>{{snapdealAd.value}} </span>
              <!-- <span *ngIf="snapdealAd.isPresent !=undefined && snapdealAd.isPresent==false; else presentBlock">❌</span> -->
              <!-- <ng-template #presentBlock>
                <span>✅</span>
              </ng-template> -->
              <br><br>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="cardData.cromaAds && cardData.cromaAds.length > 0">
            <!-- <b>{{cardData.embed.title}}</b> <br><br> -->
            <ng-container *ngFor="let cromaAd of cardData.cromaAds">
              <span>{{cromaAd.key}}</span> : <span>{{cromaAd.value}} </span>
              <br><br>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="cardData.flipkartAds && cardData.flipkartAds.length > 0">
            <!-- <b>{{cardData.embed.title}}</b> <br><br> -->
            <ng-container *ngFor="let flipkartAd of cardData.flipkartAds">
              <span>{{flipkartAd.key}}</span> : <span>{{flipkartAd.value}} </span>
              <br><br>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="cardData.affiliateMeta">
            <b>Product Name : {{cardData.affiliate.name}}</b> <br><br>
              <span style="font-weight:bold">Original Selling Price</span> : <span>{{cardData.affiliate.osp}} </span>
              <br><br>
              <span style="font-weight:bold" *ngIf="cardData.affiliate.curr_sell_price">Current Selling Price</span> : <span *ngIf="cardData.affiliate.curr_sell_price">{{cardData.affiliate.curr_sell_price? cardData.affiliate.curr_sell_price : 'N/A'}} </span>
              <br><br>
              <span style="font-weight:bold" *ngIf="cardData.affiliate.discount_perc">Discount Percentage</span> : <span *ngIf="cardData.affiliate.discount_perc">{{cardData.affiliate.discount_perc? cardData.affiliate.discount_perc : 'N/A'}} </span>
              <br><br>
              <span style="font-weight:bold">URL</span> : <span *ngIf="cardData.affiliate.url">{{cardData.affiliate.url? cardData.affiliate.url : 'N/A'}} </span>
              <br><br>
              <span style="font-weight:bold">Logo</span> : <span>{{cardData.affiliate.logo}} </span>
              <br><br>
              <span style="font-weight:bold">Product Image</span> : <span>{{cardData.affiliate.images? cardData.affiliate.images[0] : 'null'}} </span>
              <br><br>
          </ng-container>

          <ng-container *ngIf="(cardData.embed.body.indexOf('facebook.com') === -1 &&
            cardData.embed.body.indexOf('youtube.com') === -1 &&
            cardData.embed.body.indexOf('https://twitter.com') === -1 &&
            cardData.embed.body.indexOf('jwplayer') === -1 &&
            cardData.embed.body.indexOf('https://www.instagram.com') === -1
            ) || !trustedHTML">
            <p>
              {{cardData.embed.body}}
            </p>
          </ng-container>
          <ng-container *ngIf="trustedHTML && ((cardData.embed.body.indexOf('facebook.com') > -1 ||
            cardData.embed.body.indexOf('youtube.com') > -1 ||
            cardData.embed.body.indexOf('https://twitter.com') > -1 ||
            cardData.embed.body.indexOf('jwplayer') > -1 ||
            cardData.embed.body.indexOf('https://www.instagram.com') > -1
            ))">
            <div [class]="(cardData.embed.body.indexOf('https://twitter.com') > -1 || cardData.embed.body.indexOf('facebook.com') > -1) ? 'twitterEmbed'
              : ((cardData.embed.body.indexOf('https://www.instagram.com') > -1) ? 'instagramEmbed' : 'respVideo')"
              [innerHtml]="trustedHTML"></div>
          </ng-container>
          <!-- <div class="repsonsiveiframe"> -->
          <!-- <div [innerHTML]="trustedHTML"></div> -->
          <!-- </div> -->
          <!-- <div [innerHTML]="cardData.embed.body | safeHTML"></div> -->
          <ng-container *ngIf="EditMode && nestedElement">
            <div class="relative embeddropblock" #nestedOptions>
              <span id="ellipsis" class="threedots"
                (click)="showOptions = !showOptions"><span></span><span></span><span></span></span>
              <div class="revertStoryBlock" [style.display]="showOptions ? 'block': 'none'">
                <ul *ngIf="showOptions">
                  <li>
                    <button (click)="onelementFocus()">Edit</button>
                  </li>
                  <li>
                    <button (click)="deleteElement()">Delete</button>
                  </li>
                </ul>
              </div>
            </div>
          </ng-container>
        </div>

        <div class="storyaction" *ngIf="EditMode && !nestedElement">
          <span class="handle sortpara" *ngIf="!hideDragger"><i class="icon-move"></i></span>
          <span class="editBtn" (click)="onelementFocus()"><i class="icon-pickup"></i></span>
          <span class="deleteHeadline" (click)="deleteElement()"><i class="icon-delete"></i></span>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'listicleElement'">
      <div #embedEl tabindex="0" (focus)="outerDivFocus = true" (blur)="outerDivFocus = false"
        [class]="outerDivFocus ? 'enableFocus faqStoryBlock': 'faqStoryBlock'" (mouseenter)="hoverEnter()"
        (mouseleave)="hoverLeave()">
        <label [style.visibility]="(isCursorHovering ? 'visible' : 'hidden')">
          Listicle
        </label>
        <div class="dataField bdrfill">

          <ng-container>
            <div class="heading">Heading of the Listicle : {{cardData.listicleHeadline}}</div>
            <ng-container *ngFor="let listicle of cardData.listicleArray;let i = index">
              <div class="faqQueAns">
              <p class="faqQuestion"><span>Title :</span> {{listicle.key}}</p>
              <p class="faqQuestion"><span>Caption :</span> {{listicle.value}}</p>
              <ng-container *ngIf="enableUrlInListicle">
                <p class="faqQuestion"><span>Url :</span> {{listicle.url}}</p>
              </ng-container>
              <p class="faqQuestion"><span>Media :</span> </p>
              <div *ngIf="listicle.mediaType==='image'">
                <img width="300px" *ngIf="listicle.mediaType==='image'" src="{{listicle.media.image.images.original}}">
              </div>
              <div *ngIf="listicle.mediaType==='video'" class="respVideo" [innerHtml]="listicle.media.video.body | noSanitize">
              </div>
              <div #embedEl>
              <div *ngIf="listicle.mediaType==='embed'" [innerHtml]="listicle.media.embedCode | noSanitize">
              </div> </div>
            </div>
            </ng-container>
          </ng-container>
        </div>

        <div class="storyaction" *ngIf="EditMode && !nestedElement">
          <span class="editBtn" (click)="onelementFocus()"><i class="icon-pickup"></i></span>
          <span class="deleteHeadline" (click)="deleteElement()"><i class="icon-delete"></i></span>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'faq'">
      <div #embedEl tabindex="0" (focus)="outerDivFocus = true" (blur)="outerDivFocus = false"
        [class]="outerDivFocus ? 'enableFocus faqStoryBlock': 'faqStoryBlock'" (mouseenter)="hoverEnter()"
        (mouseleave)="hoverLeave()">
        <label [style.visibility]="(isCursorHovering ? 'visible' : 'hidden')">
          FAQ
          <span>{{cardData.metadata ? cardData.metadata.wordCount : ''}} words</span>
        </label>
        <div class="dataField bdrfill">

          <ng-container>
            <div class="heading">Heading of the Faq section : {{cardData.faqSectionHeading}}</div>
            <ng-container *ngFor="let faq of cardData.faqs;let i = index">
            <div class="faqQueAns">
              <p class="faqQuestion"><span>Question :</span> {{faq.key}}</p>
              <p class="faqQuestion" *ngIf="faq.mediaTypeKey"><span>Question Media :</span> </p>
              <div *ngIf="faq.mediaTypeKey==='image'">
                <img width="300px" *ngIf="faq.mediaTypeKey==='image'" src="{{faq.mediaKey.image.images.original}}">
              </div>
              <!-- <div *ngIf="faq.mediaTypeKey==='video'" class="respVideo" [innerHtml]="faq.mediaKey.video.body | noSanitize"></div> -->
              <div *ngIf="faq.mediaTypeKey === 'video'" class="respVideo">
                <div *ngIf="faq.mediaKey.video.saranyuEmbedBody">
                 <div [innerHtml]="faq.mediaKey.video.saranyuEmbedBody | noSanitize"></div>
                </div>
                <div *ngIf="!faq.mediaKey.video.saranyuEmbedBody">
                  <div [innerHtml]="faq.mediaKey.video.body | noSanitize"></div>
                </div>
              </div>
              <div #embedEl>
                <div *ngIf="faq.mediaTypeKey==='embed'" [innerHtml]="faq.mediaKey.embedCode | noSanitize"></div>
              </div>
              <p class="faqQuestion"><span>Answer :</span> {{faq.value}}</p>
              <p class="faqQuestion" *ngIf="faq.mediaTypeValue"><span>Answer Media :</span> </p>
              <div *ngIf="faq.mediaTypeValue==='image'">
                <img width="300px" *ngIf="faq.mediaTypeValue==='image'" src="{{faq.mediaValue.image.images.original}}">
              </div>
              <!-- <div *ngIf="faq.mediaTypeValue==='video'" class="respVideo" [innerHtml]="faq.mediaValue.video.body | noSanitize"></div> -->
                <div *ngIf="faq.mediaTypeValue === 'video'" class="respVideo">
                  <div *ngIf="faq.mediaValue.video.saranyuEmbedBody">
                   <div [innerHtml]="faq.mediaValue.video.saranyuEmbedBody | noSanitize"></div>
                  </div>
                  <div *ngIf="!faq.mediaValue.video.saranyuEmbedBody">
                    <div [innerHtml]="faq.mediaValue.video.body | noSanitize"></div>
                  </div>
                </div>
              <div #embedEl>
              <div *ngIf="faq.mediaTypeValue==='embed'" [innerHtml]="faq.mediaValue.embedCode | noSanitize"></div>
              </div>
            </div>
            </ng-container>
          </ng-container>

          <!-- <ng-container *ngIf="EditMode && nestedElement">
            <div class="relative embeddropblock" #nestedOptions>
              <span class="threedots"
                (click)="showOptions = !showOptions"><span></span><span></span><span></span></span>
              <div class="revertStoryBlock" [style.display]="showOptions ? 'block': 'none'">
                <ul *ngIf="showOptions">
                  <li>
                    <button (click)="onelementFocus()">Edit</button>
                  </li>
                  <li>
                    <button (click)="deleteElement()">Delete</button>
                  </li>
                </ul>
              </div>
            </div>
          </ng-container> -->
        </div>

        <div class="storyaction" *ngIf="EditMode && !nestedElement">
          <span class="handle sortpara" *ngIf="!hideDragger"><i class="icon-move"></i></span>
          <span class="editBtn" (click)="onelementFocus()"><i class="icon-pickup"></i></span>
          <span class="deleteHeadline" (click)="deleteElement()"><i class="icon-delete"></i></span>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'label'">
      <div #embedEl tabindex="0" (focus)="outerDivFocus = true" (blur)="outerDivFocus = false"
        [class]="outerDivFocus ? 'enableFocus faqStoryBlock': 'faqStoryBlock'" (mouseenter)="hoverEnter()"
        (mouseleave)="hoverLeave()">
        <label [style.visibility]="(isCursorHovering ? 'visible' : 'hidden')">
          Label
        </label>
        <div class="dataField bdrfill">

          <ng-container>
            <div class="heading">Label : {{cardData.label}}</div>
          </ng-container>
        </div>

        <div class="storyaction" *ngIf="EditMode && !nestedElement">
          <span class="handle sortpara" *ngIf="!hideDragger"><i class="icon-move"></i></span>
          <span class="editBtn" (click)="onelementFocus()"><i class="icon-pickup"></i></span>
          <span class="deleteHeadline" (click)="deleteElement()"><i class="icon-delete"></i></span>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'separator'">
      <div #embedEl tabindex="0" (focus)="outerDivFocus = true" (blur)="outerDivFocus = false"
        [class]="outerDivFocus ? 'enableFocus faqStoryBlock': 'faqStoryBlock'" (mouseenter)="hoverEnter()"
        (mouseleave)="hoverLeave()">
        <label [style.visibility]="(isCursorHovering ? 'visible' : 'hidden')">
          Separator
        </label>
        <div class="dataField bdrfill">

          <ng-container>
            <div class="heading">Separator : {{cardData.separator}}</div>
          </ng-container>
        </div>

        <div class="storyaction" *ngIf="EditMode && !nestedElement">
          <span class="handle sortpara" *ngIf="!hideDragger"><i class="icon-move"></i></span>
          <span class="editBtn" (click)="onelementFocus()"><i class="icon-pickup"></i></span>
          <span class="deleteHeadline" (click)="deleteElement()"><i class="icon-delete"></i></span>
        </div>
      </div>
    </ng-container>


    <ng-container *ngSwitchCase="'howToSteps'">
      <div #embedEl tabindex="0" (focus)="outerDivFocus = true" (blur)="outerDivFocus = false"
        [class]="outerDivFocus ? 'enableFocus howToStepBlock': 'howToStepBlock'" (mouseenter)="hoverEnter()"
        (mouseleave)="hoverLeave()">
        <label [style.visibility]="(isCursorHovering ? 'visible' : 'hidden')">
          How To Steps
          <span>{{cardData.metadata ? cardData.metadata.wordCount : ''}} words</span>
        </label>
        <div class="dataField bdrfill">

          <ng-container>
            <div class="heading">Heading : {{cardData.heading}}</div>
            <!-- cardData.timeToComplete !== 0 &&  -->
            <div class="heading" *ngIf="cardData.timeToComplete !== ''">Time To Complete - {{cardData.timeToCompleteinHrs}} {{'hr :'}} {{cardData.timeToComplete}} {{'min'}}</div>
            <!-- <div class="heading" *ngIf="cardData.timeToCompleteinHrs !== 0 && cardData.timeToCompleteinHrs !== ''">Time To Complete(Hr) : {{cardData.timeToCompleteinHrs}}</div>  -->
            <div class="heading">Tools : </div>
            <ng-container *ngFor="let tool of cardData.tools">
              <div>{{tool}}</div>
            </ng-container>
            <div class="heading">Supplies : </div>
            <ng-container *ngFor="let supplies of cardData.supplies">
              <div>{{supplies}}</div>
            </ng-container>
            <div class="heading">Steps : </div>
            <ng-container *ngFor="let step of cardData.steps">
              <div class="stepQueAns">
              <div id="disableEditorId" class="stepQuestion"><span>Step :</span>
                  <ckeditor [editor]="ckEditor"
                  [tabindex]="0"
                  (ready)="ckchanges($event,'ready','step','disable')"
                  (change)="ckchanges($event,'change','step','disable')"
                  [data]="step.step">
                  </ckeditor>
              </div>
              <div class="stepAnswer" *ngIf="(step.stepImage !== null && step.stepImage.images !== null && step.stepImage.images['90x90'] !== null)"><span>Image :</span> {{step.stepImage.images['90x90']}}</div>
              </div>
            </ng-container>
          </ng-container>
        </div>

        <div class="storyaction" *ngIf="EditMode && !nestedElement">
          <span class="handle sortpara" *ngIf="!hideDragger"><i class="icon-move"></i></span>
          <span class="editBtn" (click)="onelementFocus()"><i class="icon-pickup"></i></span>
          <span class="deleteHeadline" (click)="deleteElement()"><i class="icon-delete"></i></span>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'podcast'">
      <div #embedEl tabindex="0" (focus)="outerDivFocus = true" (blur)="outerDivFocus = false"
        [class]="outerDivFocus ? 'enableFocus podcastBlock': 'podcastBlock'" (mouseenter)="hoverEnter()"
        (mouseleave)="hoverLeave()">
        <label [style.visibility]="(isCursorHovering ? 'visible' : 'hidden')">
          Podcast
        </label>
        <div class="dataField bdrfill">

          <ng-container>
            <div class="podcastInfo"><div class="heading">Podcast Title </div> <div class="headingInfo">{{cardData.podcast.podcastTitle}}</div></div>
            <div class="podcastInfo"><div class="heading">Podcast Content </div> <div class="headingInfo">{{cardData.podcast.podcastContent}} </div></div>
            <div class="podcastInfo"><div class="heading">Podcast Image </div> <div class="headingInfo"> {{cardData.podcast.podcastImage}}</div></div>
            <div class="podcastInfo"><div class="heading">Podcast Link </div> <div class="headingInfo"> {{cardData.podcast.podcastUrl}}</div></div>
            <div class="podcastInfo"><div class="heading">Podcast Audio </div> <div class="headingInfo">
              <audio controls id="podcastAudio">
                <source [src]="cardData.podcast.podcastMp3Url" type="audio/mpeg">
                Your browser does not support the audio element.
              </audio>
            </div>
            </div>

          </ng-container>
        </div>

        <div class="storyaction" *ngIf="EditMode && !nestedElement">
          <span class="handle sortpara" *ngIf="!hideDragger"><i class="icon-move"></i></span>
          <span class="editBtn" (click)="onelementFocus()"><i class="icon-pickup"></i></span>
          <span class="deleteHeadline" (click)="deleteElement()"><i class="icon-delete"></i></span>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'recipe'">
      <div #embedEl tabindex="0" (focus)="outerDivFocus = true" (blur)="outerDivFocus = false"
        [class]="outerDivFocus ? 'enableFocus howToStepBlock': 'howToStepBlock'" (mouseenter)="hoverEnter()"
        (mouseleave)="hoverLeave()">
        <label (click)="showRecipe()" [style.visibility]="(isCursorHovering ? 'visible' : 'hidden')">
          Recipe
          <span>{{cardData.metadata ? cardData.metadata.wordCount : ''}} words</span>
        </label>
        <div class="dataField bdrfill">

          <ng-container>
            <div class="heading">Recipe Name : {{cardData.recipe.recipeName}}</div>
            <div class="heading">Description : {{cardData.recipe.description}}</div>
            <div class="heading">Recipe Yield : {{cardData.recipe.recipeYield}}</div>
            <!-- cardData.timeToComplete !== 0 &&  -->
            <div class="heading" *ngIf="cardData.recipe.preparationTimeHr !== ''">Preparation Time - {{cardData.recipe.preparationTimeHr}} {{'hr :'}} {{cardData.recipe.preparationTimeMinute}} {{'min'}}</div>
            <div class="heading" *ngIf="cardData.recipe.cookingTimeHr !== ''">Cooking Time - {{cardData.recipe.cookingTimeHr}} {{'hr :'}} {{cardData.recipe.cookingTimeMinute}} {{'min'}}</div>
            <div class="heading" *ngIf="cardData.recipe.totalTimeHr !== ''">Total Time - {{cardData.recipe.totalTimeHr}} {{'hr :'}} {{cardData.recipe.totalTimeMinute}} {{'min'}}</div>

            <!-- <div class="heading" *ngIf="cardData.timeToCompleteinHrs !== 0 && cardData.timeToCompleteinHrs !== ''">Time To Complete(Hr) : {{cardData.timeToCompleteinHrs}}</div>  -->
            <div class="heading">Keywords : </div>
            <ng-container *ngFor="let keyword of cardData.recipe.keywords">
              <div>{{keyword}}</div>
            </ng-container>
            <div class="heading">Recipe Cuisine : {{cardData.recipe.recipeCuisine}}</div>
            <div class="heading">Recipe Category : {{cardData.recipe.recipeCategory}}</div>
            <div class="heading">Ingredients : </div>
            <ng-container *ngFor="let ingredient of cardData.recipe.ingredients">
              <div>{{ingredient}}</div>
            </ng-container>
            <div class="heading">Steps : </div>
            <ng-container *ngFor="let step of cardData.recipe.steps">
              <div class="stepQueAns">
              <div id="disableEditorId" class="stepQuestion"><span>Step :</span>
                  <ckeditor [editor]="ckEditor"
                  [tabindex]="0"
                  (ready)="ckchanges($event,'ready','recipe','disable')"
                  [data]="step.step">
                  </ckeditor>
              </div>
              <div class="stepAnswer" *ngIf="(step.stepImage !== null && step.stepImage.images !== null && step.stepImage.images['90x90'] !== null)"><span>Image :</span> {{step.stepImage.images['90x90']}}</div>
              </div>
            </ng-container>
          </ng-container>
        </div>

        <div class="storyaction" *ngIf="EditMode && !nestedElement">
          <span class="handle sortpara" *ngIf="!hideDragger"><i class="icon-move"></i></span>
          <span class="editBtn" (click)="onelementFocus()"><i class="icon-pickup"></i></span>
          <span class="deleteHeadline" (click)="deleteElement()"><i class="icon-delete"></i></span>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'market'">
      <div #embedEl tabindex="0" (focus)="outerDivFocus = true" (blur)="outerDivFocus = false"
        [class]="outerDivFocus ? 'enableFocus embeddcode': 'embeddcode'" (mouseenter)="hoverEnter()"
        (mouseleave)="hoverLeave()">
        <label [style.visibility]="(isCursorHovering ? 'visible' : 'hidden')">
          Market Code
        </label>
        <div class="dataField bdrfill">
          <ng-container *ngIf="cardData.indice && cardData.indice.type && cardData.indice.type !== 'MF' ">
            <p>
              Index / Company - {{cardData.indice.name}}
            </p>
          </ng-container>
          <ng-container *ngIf="cardData.indice && cardData.indice.type && cardData.indice.type === 'MF' ">
            <p>
              Mutual Fund - {{cardData.indice.name}}
            </p>
          </ng-container>
          <ng-container *ngIf="cardData.indicesNew && cardData.indicesNew.type && (cardData.indicesList.length<=0) ">
            <p>
             New Index / Company - {{cardData.indicesNew.name}}
            </p>
          </ng-container>
          <ng-container *ngIf="cardData.indicesList && cardData.indicesList.length > 0">
            New Index / Company - <br>
            <p *ngFor="let i of cardData.indicesList">
             {{i.name}}
            </p>
          </ng-container>
          <ng-container *ngIf="EditMode && nestedElement">
            <div class="relative embeddropblock" #nestedOptions>
              <span class="threedots"
                (click)="showOptions = !showOptions"><span></span><span></span><span></span></span>
              <div class="revertStoryBlock" [style.display]="showOptions ? 'block': 'none'">
                <ul *ngIf="showOptions">
                  <li>
                    <button (click)="onelementFocus()">Edit</button>
                  </li>
                  <li>
                    <button (click)="deleteElement()">Delete</button>
                  </li>
                </ul>
              </div>
            </div>
          </ng-container>
        </div>


        <div class="storyaction" *ngIf="EditMode && !nestedElement">
          <span class="handle sortpara" *ngIf="!hideDragger"><i class="icon-move"></i></span>
          <span class="editBtn" (click)="onelementFocus()"><i class="icon-pickup"></i></span>
          <span class="deleteHeadline" (click)="deleteElement()"><i class="icon-delete"></i></span>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'productElement'">
      <div #embedEl tabindex="0" (focus)="outerDivFocus = true" (blur)="outerDivFocus = false"
        [class]="outerDivFocus ? 'enableFocus embeddcode': 'embeddcode'" (mouseenter)="hoverEnter()"
        (mouseleave)="hoverLeave()">
        <label [style.visibility]="(isCursorHovering ? 'visible' : 'hidden')">
          Brand & Model
        </label>
        <div class="dataField bdrfill">
          <ng-container *ngIf="cardData.product.categoryName">
            <p>
              Category - {{cardData.product.categoryName}}
            </p>
          </ng-container>
          <ng-container *ngIf="cardData.product.brandName">
            <p>
              Brand - {{cardData.product.brandName}}
            </p>
          </ng-container>
          <ng-container *ngIf="cardData.product.modelName">
            <p>
              Model - {{cardData.product.modelName}}
            </p>
          </ng-container>
          <ng-container *ngIf="EditMode && nestedElement">
            <div class="relative embeddropblock" #nestedOptions>
              <span class="threedots"
                (click)="showOptions = !showOptions"><span></span><span></span><span></span></span>
              <div class="revertStoryBlock" [style.display]="showOptions ? 'block': 'none'">
                <ul *ngIf="showOptions">
                  <li>
                    <button (click)="onelementFocus()">Edit</button>
                  </li>
                  <li>
                    <button (click)="deleteElement()">Delete</button>
                  </li>
                </ul>
              </div>
            </div>
          </ng-container>
        </div>


        <div class="storyaction" *ngIf="EditMode && !nestedElement">
          <span class="handle sortpara" *ngIf="!hideDragger"><i class="icon-move"></i></span>
          <span class="editBtn" (click)="onelementFocus()"><i class="icon-pickup"></i></span>
          <span class="deleteHeadline" (click)="deleteElement()"><i class="icon-delete"></i></span>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'cricket'">
      <div #embedEl tabindex="0" (focus)="outerDivFocus = true" (blur)="outerDivFocus = false"
        [class]="outerDivFocus ? 'enableFocus embeddcode': 'embeddcode'" (mouseenter)="hoverEnter()"
        (mouseleave)="hoverLeave()">
        <label [style.visibility]="(isCursorHovering ? 'visible' : 'hidden')">
          Cricket Card
        </label>
        <div class="dataField bdrfill">
          <p>
            {{cardData.match.seriesName}} : {{cardData.match.matchNameWithDate}}
          </p>
          <ng-container *ngIf="EditMode && nestedElement">
            <div class="relative embeddropblock" #nestedOptions>
              <span class="threedots"
                (click)="showOptions = !showOptions"><span></span><span></span><span></span></span>
              <div class="revertStoryBlock" [style.display]="showOptions ? 'block': 'none'">
                <ul *ngIf="showOptions">
                  <li>
                    <button (click)="onelementFocus()">Edit</button>
                  </li>
                  <li>
                    <button (click)="deleteElement()">Delete</button>
                  </li>
                </ul>
              </div>
            </div>
          </ng-container>
        </div>


        <div class="storyaction" *ngIf="EditMode && !nestedElement">
          <span class="handle sortpara" *ngIf="!hideDragger"><i class="icon-move"></i></span>
          <span class="editBtn" (click)="onelementFocus()"><i class="icon-pickup"></i></span>
          <span class="deleteHeadline" (click)="deleteElement()"><i class="icon-delete"></i></span>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="cardType === 'listicle' || cardType === 'highlights' ? cardType : ''">
      <div #listicleEl tabindex="0" (focus)="outerDivFocus = true" (blur)="outerDivFocus = false"
        [class]="outerDivFocus ? 'enableFocus blockShow': 'blockShow'" (mouseenter)="hoverEnter()" (mouseleave)="hoverLeave()" (click)="editorClick('desc')">
        <ul class="listicleBlock storyuL bdrfillN" (click)="editorClick('desc')" *ngIf="cardType === 'highlights'" >
          <!-- <li class="headline">
        <label style="visibility:hidden">Title {{index}}
          <span>{{cardData.title ? htmlToPlaintext(cardData.title).length : '0'}}/80 char</span>
        </label>
        <div class="dataField">
          <quill-editor [id]="'title' + index" [(ngModel)]="cardData.title" [theme]="'snow'" [modules]="headlineToolbar"
           [readOnly]="!editCardFlag" [placeholder]="'Point ' + index + ' title'"
           (onSelectionChanged)="onEditorSelection($event, 'title')" (onEditorCreated)="editorCreated($event, 'title')">
          </quill-editor>
        </div>

      </li> -->
          <!-- <li class="leadMedia" id="leadMedia" >
        <ng-container *ngIf="(cardData.listicle.inlineElementId)">
          <div class="element-module" #listicleLeadEl [EditMode]="EditMode" [id]="cardData.listicle.inlineElementId" [cardId]="cardData.listicle.inlineElementId"
            (deleteCardfn)="deleteImageCardEmit($event)" (sendWordCountToStory)="getWordCount($event)" [nestedElement]="true"
            [hideDragger]="true" (replaceImageEmit)="innerReplace()" (updateContentOnParent)="resgisterDataChangeToParent($event)"
            (previousFocusEmit)="focusOnElement($event, 'up')" (nextFocusEmit)="focusOnElement($event, 'down')">
          </div>
        </ng-container>
        <ng-container *ngIf="!cardData.listicle.inlineElementId && EditMode">
          <label [style.visibility]="focusOnLeadMedia ? 'visible' : 'hidden'">Lead Media</label>
          <div class="dataField" tabindex="3">
            <ul [ngClass]="{'z-high': leadMediaImageToggle}" class="leadMediaIcon">
              <li>
                <span class="i_image" [ngClass]="{'active' : leadMediaImageToggle}" (click)="listClick($event,1)"><i class="icon-image"></i></span>
                <div [class]="'imageAction' +  (leadMediaImageToggle ? ' block' : '') ">
                  <div class="blockContain">
                    <div class="uploadimage"><i class="icon-upload"></i>
                      <div class="upload-btn-wrapper">
                        <span class="btn">Upload a new Image</span>
                        <input type="file" name="myfile" (change)="onFileChange($event, 'elements')" />
                      </div>
                    </div>
                    <div class="pickimage"><i class="icon-image-library"></i>
                      <span (click)="showGallery()" class="pickimageBtn">Pick from Image Library</span>
                      <div  class="lightBox block" *ngIf="isLightbox">
                        <div class="headerLight">
                          <div class="close fl spImg" (click)="disableshowGallery()"></div>
                        </div>
                        <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="getLeadMediaId($event)" *ngIf="isPhotopopup"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </ng-container>
      </li> -->
          <li class="summary">

            <label style="visibility:hidden">Detail
              <span>{{(cardData.listicle && cardData.listicle.body ? htmlToPlaintext(cardData.listicle.body).length : '0')}}/80 char</span>
            </label>
             <ng-container *ngIf="sharedService.isdomainConfig('story','isStoryListingEnabled')">
              <button id="backlinkID" class="story_link" *ngIf="showHyperlinkIcon" (click)="hyperlinkStoryList($event, 'desc')">
                <i class="icomoon icon-link icon-info" data-title="Hyperlink StoryList"></i></button>
            </ng-container>
            <div class="dataField" #descEl>
              <!-- <textarea type="text" class="textBox"
                placeholder="Point 1 description" onkeyup="auto_grow(this)">
              </textarea> -->
              <ng-container *ngIf="isCKEditorEnabled">
                <div id="editor" (keyup)="descriptionKeyUpEvent($event)" (keydown)="descriptionKeyDownEventCk($event)">
                  <ckeditor #editorListicle [editor]="ckEditor"  id="{{id}}"
                  [(ngModel)]="cardData.listicle.body"
                  [config]="getEditorConfig()"
                  [tabindex]="0"
                  (ready)="ckchanges($event, 'ready', 'desc','listiclebody')"
                  (change)="ckchanges($event, 'change', 'desc','listiclebody')"
                  (blur)="ckchanges($event, 'blur', 'desc','listiclebody')"
                  (focus)="ckchanges($event, 'focus', 'desc','listiclebody')"
                  (error)="ckchanges($event, 'error', 'desc','listiclebody')"
                  ></ckeditor>
                </div>
              </ng-container>

            </div>
          </li>
        </ul>

        <ul class="listicleBlock storyuL bdrfillN listi" *ngIf="cardType === 'listicle'">
          <!-- <li class="headline">
        <label style="visibility:hidden">Title {{index}}
          <span>{{cardData.title ? htmlToPlaintext(cardData.title).length : '0'}}/80 char</span>
        </label>
        <div class="dataField">
          <quill-editor [id]="'title' + index" [(ngModel)]="cardData.title" [theme]="'snow'" [modules]="headlineToolbar"
           [readOnly]="!editCardFlag" [placeholder]="'Point ' + index + ' title'"
           (onSelectionChanged)="onEditorSelection($event, 'title')" (onEditorCreated)="editorCreated($event, 'title')">
          </quill-editor>
        </div>

      </li> -->
          <!-- <li class="leadMedia" id="leadMedia" >
        <ng-container *ngIf="(cardData.listicle.inlineElementId)">
          <div class="element-module" #listicleLeadEl [EditMode]="EditMode" [id]="cardData.listicle.inlineElementId" [cardId]="cardData.listicle.inlineElementId"
            (deleteCardfn)="deleteImageCardEmit($event)" (sendWordCountToStory)="getWordCount($event)" [nestedElement]="true"
            [hideDragger]="true" (replaceImageEmit)="innerReplace()" (updateContentOnParent)="resgisterDataChangeToParent($event)"
            (previousFocusEmit)="focusOnElement($event, 'up')" (nextFocusEmit)="focusOnElement($event, 'down')">
          </div>
        </ng-container>
        <ng-container *ngIf="!cardData.listicle.inlineElementId && EditMode">
          <label [style.visibility]="focusOnLeadMedia ? 'visible' : 'hidden'">Lead Media</label>
          <div class="dataField" tabindex="3">
            <ul [ngClass]="{'z-high': leadMediaImageToggle}" class="leadMediaIcon">
              <li>
                <span class="i_image" [ngClass]="{'active' : leadMediaImageToggle}" (click)="listClick($event,1)"><i class="icon-image"></i></span>
                <div [class]="'imageAction' +  (leadMediaImageToggle ? ' block' : '') ">
                  <div class="blockContain">
                    <div class="uploadimage"><i class="icon-upload"></i>
                      <div class="upload-btn-wrapper">
                        <span class="btn">Upload a new Image</span>
                        <input type="file" name="myfile" (change)="onFileChange($event, 'elements')" />
                      </div>
                    </div>
                    <div class="pickimage"><i class="icon-image-library"></i>
                      <span (click)="showGallery()" class="pickimageBtn">Pick from Image Library</span>
                      <div  class="lightBox block" *ngIf="isLightbox">
                        <div class="headerLight">
                          <div class="close fl spImg" (click)="disableshowGallery()"></div>
                        </div>
                        <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="getLeadMediaId($event)" *ngIf="isPhotopopup"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </ng-container>
      </li> -->
      <li class="summary" *ngIf="cardData.listicle && cardData.listicle.title !== 'undefined' && enableListicleHeading">
        <label style="visibility:hidden">Title

        </label>
        <div class="dataField" #descEl>
          <!-- <textarea type="text" class="textBox"
            placeholder="Point 1 description" onkeyup="auto_grow(this)">
          </textarea> -->
          <ng-container *ngIf="isCKEditorEnabled">
            <div id="editor">
              <ckeditor #editorListicleTitle [editor]="ckEditor"  id="{{id}}"
              [(ngModel)]="cardData.listicle.title"
              [config]="getEditorConfig()"
              (ready)="ckchanges($event,'ready','listicletitle','listicletitle')"
              [tabindex]="0"
              ></ckeditor>
            </div>
          </ng-container>

        </div>
      </li>
      <ng-container *ngIf="sharedService.isdomainConfig('story','isStoryListingEnabled')">
        <button id="backlinkID" class="story_link" *ngIf="showHyperlinkIcon" (click)="hyperlinkStoryList($event, 'desc')">
          <i class="icomoon icon-link icon-info" data-title="Hyperlink StoryList"></i></button>
      </ng-container>
          <li class="summary">
            <label style="visibility:hidden">Detail
              <span>{{(cardData.listicle && cardData.listicle.body ? htmlToPlaintext(cardData.listicle.body).length : '0')}}/80 char</span>
            </label>
            <div class="dataField" #descEl>
              <!-- <textarea type="text" class="textBox"
                placeholder="Point 1 description" onkeyup="auto_grow(this)">
              </textarea> -->
              <ng-container *ngIf="isCKEditorEnabled">
                <div id="editor" (keyup)="descriptionKeyUpEvent($event)" (keydown)="descriptionKeyDownEventCk($event)">
                  <ckeditor #editorListicle [editor]="ckEditor"  id="{{id}}"
                  [(ngModel)]="cardData.listicle.body"
                  [config]="getEditorConfig()"
                  [tabindex]="0"
                  (ready)="ckchanges($event, 'ready', 'desc','listiclebody')"
                  (change)="ckchanges($event, 'change', 'desc','listiclebody')"
                  (blur)="ckchanges($event, 'blur', 'desc','listiclebody')"
                  (focus)="ckchanges($event, 'focus', 'desc','listiclebody')"
                  (error)="ckchanges($event, 'error', 'desc','listiclebody')"
                  ></ckeditor>
                </div>
              </ng-container>

            </div>
          </li>
          <li class="leadMedia" id="leadMedia">
            <!-- listicle product---------- -->
            <div tabindex="0" (focus)="outerDivFocus = true" (blur)="outerDivFocus = false"
            [class]="outerDivFocus ? 'enableFocus embeddcode': 'embeddcode'" (mouseenter)="hoverEnter()"
            (mouseleave)="hoverLeave()" *ngIf="cardData.listicle && cardData.listicle.product &&!!cardData.listicle.product.brandName">
            <label [style.visibility]="(isCursorHovering ? 'visible' : 'hidden')">
             Product Code
            </label>
            <div class="dataField bdrfill">
              <ng-container >
                <p>
                  Brand - {{cardData.listicle.product.brandName}}
                </p>
              </ng-container>
              <ng-container>
                <p>
                  Model - {{cardData.listicle.product.modelName}}
                </p>
              </ng-container>

            </div>

          </div>
            <ng-container *ngIf="cardData.listicle && cardData.listicle.product && !cardData.listicle.product.brandName && enableListicleProduct">
              <label [style.visibility]="focusOnLeadMedia ? 'visible' : 'hidden'">Lead Media</label>

              <div class="dataField" tabindex="3" >
                <ul [ngClass]="{'z-high': leadMediaImageToggle}" class="leadMediaIcon">
                  <li class="product_icon"
                 (click)="openlisticleProductPopup()">

                  <i class="icon-product"><img src="assets/images/product-icon.svg"></i>
                  <span class="tooltip">Insert Product</span>
                </li>
                </ul>
              </div>
            </ng-container>
          </li>
        </ul>
        <div class="storyaction" *ngIf="EditMode && (id !== 'newListElement')">
          <span class="handle sortpara" *ngIf="!hideDragger"><i class="icon-move"></i></span>
          <span class="deleteHeadline" (click)="deleteElement()"><i class="icon-delete"></i></span>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="cardType === 'liveblog' || cardType === 'newsroom' ? cardType : '' ">
      <div class="border_bddd relative" *ngIf="(id !== 'newLiveblogElement')">
        <span class="timeliveblog">{{cardData.firstPublishedDate && cardData.firstPublishedDate !== null ?
        getNewTypeDate(cardData.firstPublishedDate) : 'Not published.'}}</span>
      </div>
      <div #liveblogEl tabindex="0" (focus)="outerDivFocus = true" (blur)="outerDivFocus = false"
        [class]="outerDivFocus ? 'enableFocus blockShow': 'blockShow'" (mouseenter)="hoverEnter()" (mouseleave)="hoverLeave()">
        <ul class="listicleBlock storyuL bdrfillN">
          <li class="headline">
            <label style="visibility:hidden">Title {{index}}
              <span>{{cardData.title ? htmlToPlaintext(cardData.title).length : '0'}}/80 char</span>
            </label>
            <div class="dataField">
              <ng-container *ngIf="isCKEditorEnabled">
                <div id="editor" (keyup)="titleKeyUpEvent($event)" (keydown)="titleKeyDownEventCk($event)">
                  <ckeditor #editorTitle [editor]="ckEditor"  id="{{id}}"
                  [(ngModel)]="cardData.title"
                  [config]="ckplainconfig"
                  [tabindex]="0"
                  (ready)="ckchanges($event, 'ready', 'title','title')"
                  (change)="ckchanges($event, 'change', 'title','title')"
                  (blur)="ckchanges($event, 'blur', 'title','title')"
                  (focus)="ckchanges($event, 'focus', 'title','title')"
                  (error)="ckchanges($event, 'error', 'title','title')"
                  ></ckeditor>
                </div>
              </ng-container>

            </div>
          </li>

          <li *ngIf="liveBlogPostEdit || (id == 'newLiveblogElement')" class="leadMedia" id="leadMedia">
            <ng-container *ngIf="multipleElementLiveblog || (!(cardData.liveBlog.inlineElementId) && !uploadImageInProgress)">
              <label [style.visibility]="focusOnLeadMedia ? 'visible' : 'hidden'">Lead Media</label>
              <div class="dataField" tabindex="3">
                <ul [ngClass]="{'z-high': leadMediaImageToggle}" class="leadMediaIcon">
                  <li class="spImg_story" #innerLeadel>
                    <span class="i_image" [ngClass]="{'active' : leadMediaImageToggle}" (click)="listClick($event,1)"><i
                        class="icon-image"></i></span>
                    <div [class]="'imageAction' +  (leadMediaImageToggle ? ' block' : '') ">
                      <div class="blockContain">
                        <div class="uploadimage"><i class="icon-upload"></i>
                          <div class="upload-btn-wrapper">
                            <span class="btn">Upload a new Image</span>
                            <input type="file" accept="image/*" name="myfile" (change)="onFileChange($event, 'elements')" />
                          </div>
                        </div>
                        <div class="pickimage"><i class="icon-image-library"></i>
                          <span (click)="showGallery()" class="pickimageBtn">Pick from Image Library</span>
                          <div class="lightBox block" *ngIf="isLightbox">
                            <div class="headerLight">
                              <div class="close fl spImg" (click)="disableshowGallery()"></div>
                            </div>
                            <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="getLeadMediaId($event)"
                              *ngIf="isPhotopopup"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <span class="i_embed" (click)="addEmbedAsLead($event)">
                      <i class="icon-embed"></i>
                    </span>
                  </li>
                  <li *ngIf="domainConfig.elementsDisabled.indexOf('market') === -1" class="market_icon"
                 (click)="openMarketPopup()">
                  <i class="icon-market"></i>
                  <span class="tooltip">Insert Market</span>
                </li>
                <li *ngIf="domainConfig.elementsDisabled.indexOf('liveblogTable') === -1" class="table_icon spImg_story" (click)="createNewTable()">
                  <span class="tooltip">Insert table</span>
                  <i class="icon-table"></i>
                </li>
                <li class="scorecard_icon" *ngIf="domainConfig.elementsDisabled.indexOf('cricket') === -1"
                (click)="openMatchPopup()">
                 <i class="icon-scorecard"></i>
                 <span class="tooltip">Insert Scorecard</span>
                </li>
                <li class="pdf_icon"  *ngIf="domainConfig.elementsDisabled.indexOf('pdfFeature') === -1">
                  <i class="icon-pages"></i>
                  <div class="upload-btn-wrapper">
                    <input type="file" name="myfile" accept=".pdf" (change)="onFileChange($event, 'elements')"/>
                  </div>
                  <span class="tooltip">Insert Pdf</span>
                </li>
                <li class="relatedStory_icon" *ngIf="domainConfig.elementsDisabled.indexOf('relatedStory') === -1"
                (click)="openPostRelatedStoryModal('multiple')">
                <i class="icon-related"></i>
                  <span class="tooltip">Insert Related Story</span>
                </li>
                <!-- <li class="table_icon tooltipN" *ngIf="domainConfig.elementsDisabled.indexOf('newDesign') === -1">
                  <input type="checkbox" (click)="toggleNewLiveblog()" [checked]="cardData.liveBlog.newLiveBlogDesign">
                  <span  class="tooltip">New Design</span>
                </li> -->
                <!-- <li  class="table_icon tooltipN">
                <span class="tooltiptext">New Design</span>
                 <label _ngcontent-c7="" class="checkblock " tabindex="0">

                <input _ngcontent-c7="" type="checkbox">
                <span _ngcontent-c7="" class="checkmark"></span>
                </label>
              </li> -->
                </ul>
              </div>
            </ng-container>
            <ng-container *ngIf="(cardData.liveBlog.inlineElementId) && !uploadImageInProgress">
              <div class="element-module" #liveblogLeadEl [EditMode]="EditMode" [id]="cardData.liveBlog.inlineElementId"
                [cardId]="cardData.liveBlog.inlineElementId" (deleteCardfn)="deleteImageCardEmit($event)" [liveblogPostImage]="true"
                (sendWordCountToStory)="getWordCount($event)" [nestedElement]="true" [hideDragger]="true"
                (replaceImageEmit)="innerReplace()" (previousFocusEmit)="focusOnElement($event, 'up')"
                (updateContentOnParent)="resgisterDataChangeToParent($event)"
                (nextFocusEmit)="focusOnElement($event, 'down')" (outputEmbedSourceUrl)="getEmbedSourceUrl($event)">
              </div>
            </ng-container>
            <ng-container *ngIf="((cardData.liveBlog.inlineElementIdList && cardData.liveBlog.inlineElementIdList.length > 0) && !uploadImageInProgress)">
              <ng-container *ngFor="let el_id of cardData.liveBlog.inlineElementIdList">
                <div class="element-module" #liveblogLeadEl [EditMode]="EditMode" [id]="el_id"
                  [cardId]="el_id" (deleteCardfn)="deleteImageCardEmit($event)"
                  (sendWordCountToStory)="getWordCount($event)" [nestedElement]="true" [hideDragger]="true" [liveblogPostImage]="true"
                  (replaceImageEmit)="innerReplace()" (previousFocusEmit)="focusOnElement($event, 'up')"
                  (updateContentOnParent)="resgisterDataChangeToParent($event)"
                  (nextFocusEmit)="focusOnElement($event, 'down')" (outputEmbedSourceUrl)="getEmbedSourceUrl($event)" >
                </div>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="uploadImageInProgress">
              <div class="imagepreloader">
                <div class="a" style="--n: 5;">
                  <div class="dot dot1" style="--i: 0;"></div>
                  <div class="dot dot2" style="--i: 1;"></div>
                  <div class="dot dot3" style="--i: 2;"></div>
                  <div class="dot dot4" style="--i: 3;"></div>
                </div>
              </div>
            </ng-container>
          </li>
          <li *ngIf="liveBlogPostEdit || (id == 'newLiveblogElement')" class="summary"  (click)="editorClick('desc')">
            <label style="visibility:hidden">Detail
              <span>{{(cardData.liveBlog.body ? htmlToPlaintext(cardData.liveBlog.body).length : '0')}}/80 char</span>
            </label>
            <ng-container *ngIf="sharedService.isdomainConfig('story','isStoryListingEnabled')">
              <button id="backlinkID" class="story_link" *ngIf="showHyperlinkIcon " (click)="hyperlinkStoryList($event, 'desc')">
                <i class="icomoon icon-link icon-info" data-title="Hyperlink StoryList"></i></button>
            </ng-container>
            <div class="dataField" #descEl>
              <!-- <textarea type="text" class="textBox" placeholder="Point 1 description" onkeyup="auto_grow(this)"></textarea> -->
              <ng-container *ngIf="isCKEditorEnabled">
                <div id="editor" (keyup)="descriptionKeyUpEvent($event)" (keydown)="descriptionKeyDownEventCk($event)">
                  <ckeditor #editorLiveBlogBody [editor]="ckEditor2"  id="{{id}}"
                  placeholder="Post's description"
                  [(ngModel)]="cardData.liveBlog.body"
                  [config]="getEditorConfig()"
                  [tabindex]="0"
                  (ready)="ckchanges($event, 'ready', 'desc','liveblogbody')"
                  (change)="ckchanges($event, 'change', 'desc','liveblogbody')"
                  (blur)="ckchanges($event, 'blur', 'desc','liveblogbody')"
                  (focus)="ckchanges($event, 'focus', 'desc','liveblogbody')"
                  (error)="ckchanges($event, 'error', 'desc','liveblogbody')"
                  ></ckeditor>
                </div>
              </ng-container>

            </div>

            <button *ngIf="liveBlogPostEdit" type="button" name="saveStory" class="createStory blue mtb15 ml10 mr30"
            (click)="closeEditLiveBlogPost()" [class]="'save blue rightAlign'">Close</button>
            <div class="highlightC" *ngIf="liveBlogPostEdit">
              <label  class="checkblock" tabindex="0">
                Highlight
                <input  type="checkbox" (click)="toggleSwitch('highlight')" [checked]="cardData.metadata.highlight">
                <span  class="checkmark"></span>
              </label>
            </div>
          </li>

        </ul>

        <div class="storyaction" *ngIf="EditMode && (id !== 'newLiveblogElement')"><!--rohit-->

          <ng-container *ngIf="(activePin);then unPinData else pinData"></ng-container>
          <ng-template #unPinData>
            <span class="handle sortpara"><i class="icon-move"></i></span>
            <span class="deleteHeadline" (click)="deletePinElement()"><i class="icon-delete"></i></span>
            <span class="pinnedElement" (click)="unPinLiveBlogPost()"><i class="icon-pin"></i></span>
          </ng-template>
          <ng-template #pinData>
            <span *ngIf="!liveBlogPostEdit" id="buttonEditForImage" class="editBtn" (click)="editLiveBlogPost()"><i class="icon-pickup"></i></span>
            <span class="deleteHeadline" (click)="deleteElement()"><i class="icon-delete"></i></span>
            <span *ngIf="sharedService.isPinnedElementEnabled()" class="pinnedPost" (click)="pinLiveBlogPost()"><i class="icon-pin"></i></span>
          </ng-template>


        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'sampleimages'">
      <div tabindex="0" (focus)="outerDivFocus = true" (blur)="outerDivFocus = false"
        [class]="outerDivFocus ? 'enableFocus sampleImage': 'sampleImage'" (mouseenter)="hoverEnter()"
        (mouseleave)="hoverLeave()" >
        <label [style.visibility]="(isCursorHovering ? 'visible' : 'hidden')">
          Sample Image Element
        </label>
      <!-- <div class="sampleImage"> -->
        <div class="dataField bdrfill">
        <ul>
          <ng-container *ngFor="let sample of cardData.sampleImagesIdList;let i = index">
            <li>
                <div class="sampleimg">
                  <div class="element-module" #sampleImageEle [EditMode]="EditMode" [id]="sample"
                  [cardId]="sample" (deleteCardfn)="deleteImageCardEmit($event)"
                  (sendWordCountToStory)="getWordCount($event)" [nestedElement]="true" [hideDragger]="true" [liveblogPostImage]="true"
                  (replaceImageEmit)="innerReplace()" (previousFocusEmit)="focusOnElement($event, 'up')"
                  (updateContentOnParent)="resgisterDataChangeToParent($event)" [sampleImage]="true"
                  (nextFocusEmit)="focusOnElement($event, 'down')" (outputEmbedSourceUrl)="getEmbedSourceUrl($event)" >
                  </div>
                </div>
                <div class="sampleBtn">
                    <div class="sampleCrop">
                      <!-- <button class="samp" (click)="startSampleCropping(i)">Crop </button> -->
                      <span class="cropimage" (click)="startSampleCropping(i)"><i class="icon-crop"></i></span>
                    </div>
                    <div class="sampleIcon">
                      <!-- <button class="sampDel" (click)="deleteSample(sample)">Delete </button> -->
                      <span class="deleteHeadline" (click)="deleteSample(sample)"><i class="icon-delete"></i></span>
                    </div>
                </div>
            </li>
          </ng-container>


        </ul>
       </div>
       <div class="storyaction" *ngIf="EditMode && cardData.sampleImagesIdList && cardData.sampleImagesIdList.length>0">
        <span class="handle sortpara" *ngIf="!hideDragger"><i class="icon-move" id="dragAndDropForRelatedStoryIcon"></i></span>
        <!-- <span class="editBtn" (click)="openRelatedStoryModal('multiple')"><i class="icon-pickup" id="buttonRelatedStoryEditIcon"></i></span> -->
        <span class="deleteHeadline" (click)="deleteElement()"><i class="icon-delete"></i></span>
        <span class="deleteHeadline" *ngIf="cardData.sampleImagesIdList!==null && cardData.sampleImagesIdList.length>1" (click)="showViewImages()"><i class="icon-image-library"></i></span>
      </div>
      <!-- </div> -->
      </div>

    </ng-container>

      <div class="lightBox photogallerylist block" *ngIf="isLightbox && showViewImagePopup">
        <div class="headerLight">
          <div class="close fl spImg" (click)="cancelViewImages()"></div>
        </div>
       <div class="lightContent lightforView" >
        <div class="imagesView">
        <div class="listView">
        <ul [dragula]='"view-images-bag"' [dragulaModel]='viewImagesData'>
                <li class="imagesView_list"*ngFor="let image of viewImagesData; let i = index;"  title="Caption - {{image.image.caption ? image.image.caption : 'Caption Not Present'}} &#10;Filename - {{getImageFileName(image)}}" >
                  <img  width="100%" height="180px" [src]="image['image']['images']['382x214']?image['image']['images']['382x214']:image['image']['images']['original']">
                  </li>
          </ul>
        </div>
        </div>
        <div class="view-images-btn">
          <button (click)="updateDragViewImages()" class="green">Update</button>
          <button (click)="cancelViewImages()" class="blue">Cancel</button>
        </div>

       </div>
      </div>

    <ng-container *ngSwitchCase="'alsoread'">
      <div #relatedEl tabindex="0" (focus)="outerDivFocus = true" (blur)="outerDivFocus = false"
        [class]="outerDivFocus ? 'enableFocus': ''" (mouseenter)="hoverEnter()" (mouseleave)="hoverLeave()">
        <ul>
          <li class="summary relatedstories body">
            <label [style.visibility]="(isCursorHovering ? 'visible' : 'hidden')">Also Read Stories</label>
            <div class="dataField bdrfill">
              <ng-container *ngFor="let story of cardData.alsoReadStoryIdList;let i = index">
                <div #relatedStoryRef class="related-story-view" [arrayIndex]="i" [storyId]="story" [headline]="cardData.alsoReadStories[story]"
                  (deleteRelatedStoryfn)="deleteAlsoReadStory($event)" (updateAlsoReadHeadline)="updateAlsoReadHeadline($event)" [alsoRead]="true"
                  (replaceRelatedStoryfn)="replaceAlsoReadStory($event)" [editMode]="EditMode">
                </div>
              </ng-container>
            </div>
            <div class="storyaction" *ngIf="EditMode">
              <span class="handle sortpara" *ngIf="!hideDragger"><i class="icon-move" id="dragAndDropForRelatedStoryIcon"></i></span>
              <span class="editBtn" (click)="openAlsoReadStoryModal('multiple')"><i class="icon-pickup" id="buttonRelatedStoryEditIcon"></i></span>
              <span class="deleteHeadline" (click)="deleteElement()"><i class="icon-delete"></i></span>
            </div>
          </li>
        </ul>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'relatedstory'">
      <div #relatedEl tabindex="0" (focus)="outerDivFocus = true" (blur)="outerDivFocus = false"
        [class]="outerDivFocus ? 'enableFocus': ''" (mouseenter)="hoverEnter()" (mouseleave)="hoverLeave()">
        <ul>
          <li class="summary relatedstories body">
            <label [style.visibility]="(isCursorHovering ? 'visible' : 'hidden')">Related Stories</label>
            <div class="dataField bdrfill">
              <ng-container *ngFor="let story of cardData.relatedStories;let i = index">
                <div #relatedStoryRef class="related-story-view" [arrayIndex]="i" [storyId]="story"
                  (deleteRelatedStoryfn)="deleteRelatedStory($event)"
                  (replaceRelatedStoryfn)="replaceRelatedStory($event)" [editMode]="EditMode">
                </div>
              </ng-container>
            </div>
            <!--div *ngIf="EditMode && nestedElement" class="relative embeddropblock">
              <span class="threedots"
                (click)="showOptions = !showOptions"><span></span><span></span><span></span></span>
              <div class="revertStoryBlock" [style.display]="showOptions ? 'block': 'none'">
                <ul *ngIf="showOptions">
                  <li>
                    <button (click)="openRelatedStoryModal('multiple')">Edit</button>
                  </li>
                  <li>
                    <button (click)="deleteElement()">Delete</button>
                  </li>
                </ul>
              </div>
            </div-->
            <div class="storyaction" *ngIf="EditMode && !nestedElement">
              <span class="handle sortpara" *ngIf="!hideDragger"><i class="icon-move" id="dragAndDropForRelatedStoryIcon"></i></span>
              <span class="editBtn" (click)="openRelatedStoryModal('multiple')"><i class="icon-pickup" id="buttonRelatedStoryEditIcon"></i></span>
              <span class="deleteHeadline" (click)="deleteElement()"><i class="icon-delete"></i></span>
              <span *ngIf=" cardData.relatedStoryHtml" class="icon-cards" title="Preview" (click)="openRelatedStoryPreviewPopup()"></span>
            </div>
          </li>
        </ul>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'relatedstoryhowto'">
      <div #relatedElhowto tabindex="0" (focus)="outerDivFocus = true" (blur)="outerDivFocus = false"
        [class]="outerDivFocus ? 'enableFocus': ''" (mouseenter)="hoverEnter()" (mouseleave)="hoverLeave()">
        <ul>
          <li class="summary relatedstories body">
            <label [style.visibility]="(isCursorHovering ? 'visible' : 'hidden')">Related Stories Howto</label>
            <div class="dataField bdrfill">
              <ng-container *ngFor="let story of cardData.relatedStoriesHowTo;let i = index">
                <div #relatedStoryRef class="related-story-view" [arrayIndex]="i" [storyId]="story"
                  (deleteRelatedStoryfn)="deleteRelatedStoryHowto($event)"
                  (replaceRelatedStoryfn)="replaceRelatedStoryhowto($event)" [editMode]="EditMode">
                </div>
              </ng-container>
            </div>
            <div class="storyaction" *ngIf="EditMode">
              <span class="handle sortpara" *ngIf="!hideDragger"><i class="icon-move" id="dragAndDropForRelatedStoryIcon"></i></span>
              <span class="editBtn" (click)="openRelatedHowtoStoryModal('multiple')"><i class="icon-pickup" id="buttonRelatedStoryEditIcon"></i></span>
              <span class="deleteHeadline" (click)="deleteElement()"><i class="icon-delete"></i></span>
            </div>
          </li>
        </ul>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'table'">
        <div #tableEl tabindex="0" class="paragraph " *ngIf="cardData" (focus)="outerDivFocus = true" (blur)="outerDivFocus = false"
          (mouseenter)="hoverEnter()" (mouseleave)="hoverLeave()">

          <label [style.visibility]="(isCursorHovering ? 'visible' : 'hidden')">Table
            <!-- <span>{{cardData.metadata ? cardData.metadata.wordCount : ''}} words</span> -->
          </label>
          <div class="dataField bdrfill table" [innerHTML]="cardData.paragraph.body">

          </div>
          <!-- <span (click)="trigger($event)"></span> -->
          <ng-container *ngIf="EditMode && nestedElement">
            <div class="tableElementBlock" #nestedOptions>
          <div class="relative embeddropblock">
            <span class="threedots"
              (click)="showOptions = !showOptions"><span></span><span></span><span></span></span>
            <div class="revertStoryBlock" [style.display]="showOptions ? 'block': 'none'">
              <ul *ngIf="showOptions">
                <li>
                  <button (click)="editTable()">Edit</button>
                </li>
                <li>
                  <button (click)="deleteElement()">Delete</button>
                </li>
              </ul>
            </div>
          </div>
        </div>
        </ng-container>
          <div class="storyaction" *ngIf="EditMode && !nestedElement">
            <span class="handle sortpara" *ngIf="!hideDragger"><i class="icon-move"></i></span>
            <span class="editBtn" (click)="editTable()"><i class="icon-pickup"></i></span>
            <span class="deleteHeadline" (click)="deleteElement()"><i class="icon-delete"></i></span>
          </div>
        </div>
    </ng-container>
    <ng-container *ngSwitchCase="'quote'">
      <div #quoteEl tabindex="0" class="paragraph quoteBlock" *ngIf="cardData" (focus)="outerDivFocus = true" (blur)="outerDivFocus = false"
        (mouseenter)="hoverEnter()" (mouseleave)="hoverLeave()">
        <label [style.visibility]="(isCursorHovering ? 'visible' : 'hidden')">Quote</label>
        <div class="dataField bdrfill quoteField">
          <i class="icon-quote-active-top"></i>
          <span [innerHTML]="quoteHTML"></span>
          <i class="icon-quote-active-bot"></i>
        </div>
        <div class="storyaction" *ngIf="EditMode">
            <span class="handle sortpara" *ngIf="!hideDragger"><i class="icon-move"></i></span>
            <span class="editBtn" (click)="editQuote()"><i class="icon-pickup"></i></span>
            <span class="deleteHeadline" (click)="deleteElement()"><i class="icon-delete"></i></span>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'review'">
      <div #reviewEl tabindex="0" class="paragraph " *ngIf="cardData" (focus)="outerDivFocus = true" (blur)="outerDivFocus = false"
      (mouseenter)="hoverEnter()" (mouseleave)="hoverLeave()">
      <label [style.visibility]="(isCursorHovering ? 'visible' : 'hidden')">Review and Rating</label>
      <div class="dataField bdrfill table">
        <div class="review">
          <div class="ratingPriceBlock">
             <div class="rating">
                <div class="ratingLabel">Rating</div>
                <div class="ratingField">
                   <span *ngIf="isReviewEditable">
                     <input type="textbox" class="textBox" [(ngModel)]="tempReviewData.rating" appTwoDigitDecimaNumber
                   >/{{maxReviewRating}}</span>
                   <span *ngIf="!isReviewEditable">{{cardData.review.rating}}/{{maxReviewRating}}</span>
                  <div class="ratingr" #ratingEl><div [style.width]="applyStyles(cardData.review.rating,'rating')"> </div> </div>
                </div>
             </div>
             <div class="price">
                <div class="priceLabel">Price</div>
                <div class="priceField" *ngIf="isReviewEditable">
                  <input type="textbox" class="textBox"
                  [(ngModel)]="tempReviewData.price">/-</div>
                <div class="priceField" *ngIf="!isReviewEditable">{{cardData.review.price}}/-</div>
             </div>
          </div>
          <div class="ratingPriceBlock mt5">
            <div class="rating">
               <div class="ratingLabel" style="width:100%;">Product Name</div>
               <div class="addPros" style="margin-top:5px;    display: inline-block;width: 100%;">
                  <span *ngIf="isReviewEditable">
                    <input type="text" class="textBox reviewInput" [(ngModel)]="tempReviewData.productName"></span>
                  <span *ngIf="!isReviewEditable">{{cardData.review.productName}}</span>
               </div>
            </div>
            <div class="price">
               <div class="priceLabel" style="width:100%;">Brand Name</div>
               <div class="addPros" *ngIf="isReviewEditable"  style="margin-top:5px;    display: inline-block;width: 100%;">
                 <input type="text" class="textBox reviewInput" [(ngModel)]="tempReviewData.brandName"></div>
               <div class="priceField" *ngIf="!isReviewEditable">{{cardData.review.brandName}}</div>
            </div>
         </div>
          <div class="prosConsBlock">
             <div class="pros">
                <div class="prosHeading">Pros</div>
                <span *ngIf="isReviewEditable" class="addPros">
                  <input type="text" [(ngModel)]="reviewPros" class="textBox reviewInput" placeholder="Add Pros">
                  <i class="icon-add" (click)="addProductReviewDetails('pros')"></i></span>
                <div class="prosList edit" *ngIf="isReviewEditable && cardData.review.pros.length > 0">
                   <ul>
                      <li *ngFor="let item of tempReviewData.pros;let i=index; trackBy:trackByFn">
                        <span class="txtSection">
                        <input type="text" [(ngModel)]="tempReviewData.pros[i]" class="textBox" placeholder=""></span><span class="deleteHeadline">
                          <i class="icon-delete" (click)="deleteProsCons(i, 'pros')"></i></span>
                      </li>
                    </ul>
                </div>
                <div class="prosList" *ngIf="!isReviewEditable && cardData.review.pros.length > 0">
                  <ul><li *ngFor="let item of cardData.review.pros"><span>{{item}}</span></li></ul>
               </div>
             </div>
             <div class="cons">
                <div class="consHeading">Cons</div>
                <span *ngIf="isReviewEditable"  class="addCons"><input type="text" [(ngModel)]="reviewCons" class="textBox reviewInput" placeholder="Add Cons">
                  <i class="icon-add" (click)="addProductReviewDetails('cons')"></i></span>
                <div class="consList edit" *ngIf="isReviewEditable && cardData.review.cons.length > 0">
                   <ul><li *ngFor="let item of tempReviewData.cons;let i=index; trackBy:trackByFn"><span class="txtSection">
                     <input type="text" class="textBox" [(ngModel)]="tempReviewData.cons[i]" placeholder=""></span>
                     <span class="deleteHeadline"><i class="icon-delete" (click)="deleteProsCons(i, 'cons')"></i></span></li>
                   </ul>
                </div>
                <div class="consList" *ngIf="!isReviewEditable && cardData.review.cons.length > 0">
                  <ul><li *ngFor="let item of cardData.review.cons"><span>{{item}}</span></li></ul>
               </div>
             </div>
          </div>
          <div class="specificationBlock">
             <div class="specHeading">Specification</div>
             <div class="specList">
                <ul *ngIf="isReviewEditable">
                  <li class="editSpec" >
                      <div class="heading"><input type="text" [(ngModel)]="specHeading" class="textBox specInput" placeholder="Add Heading"></div>
                      <div class="description">
                        <input type="text" [(ngModel)]="specDescription" class="textBox specInput" placeholder="Add Description">
                        <i class="icon-add" (click)="addProductReviewDetails('spec')"></i>
                      </div>
                  </li>
                  <li class="editSpec" *ngFor="let item of cardData.review.specification; let i = index">
                    <div class="heading"><input type="text" [(ngModel)]="item.key" class="textBox specInput" placeholder="Add Heading"></div>
                    <div class="description">
                      <input type="text" [(ngModel)]="item.value" class="textBox specInput" placeholder="Add Description">
                      <span class="deleteHeadline"><i class="icon-delete" (click)="deleteProsCons(i, 'spec')"></i></span>
                    </div>
                </li>
                </ul>
                <ul *ngIf="!isReviewEditable">
                   <li *ngFor="let item of cardData.review.specification">
                      <div class="heading">{{item.key}}</div>
                      <div class="description">{{item.value}}</div>
                   </li>
                </ul>
             </div>
          </div>
           <div *ngIf="enableVerdict" class="verdictBox">
               <div class="specHeading">Short Verdict</div>
               <div class="addVerdict">
                  <span *ngIf="isReviewEditable">
                  <ckeditor #editorShortVerdict *ngIf="!textDifferenceCase" [editor]="ckEditor"  id="verdictBox" [(ngModel)]="tempReviewData.shortVerdict" (ready)="ckchanges($event, 'ready', 'shortVerdict','shortVerdict')"
                  type="text" class="textBox verdictInput" [config]="getEditorConfig()"></ckeditor>
                    <!--input type="text" class="textBox reviewInput" [(ngModel)]="tempReviewData.productName"-->
                    </span>
                  <span *ngIf="!isReviewEditable">{{htmlToPlaintext(cardData.review.shortVerdict)}}</span>
               </div>
            </div>
            <div>
              <div class="ratingPriceBlockCar">
                <div class="rating">
                   <div class="ratingLabel">CAR</div>
                </div>
                <div class="price">
                   <div class="priceLabel">BIKE</div>
                </div>
             </div>
              <div class="ratingPriceBlock">
                <div class="rating">
                   <div class="ratingLabel">Performance</div>
                   <div class="ratingField">
                      <span *ngIf="isReviewEditable">
                        <input type="textbox" class="textBox" [(ngModel)]="tempReviewData.carPerformance" appTwoDigitDecimaNumber
                      >/{{maxReviewRating}}</span>
                      <span *ngIf="!isReviewEditable">{{cardData.review.carPerformance}}/{{maxReviewRating}}</span>
                     <div class="ratingr" #ratingEl><div [style.width]="applyStyles(cardData.review.carPerformance,'carPerformance')"> </div> </div>
                   </div>
                </div>
                <div class="price">
                   <div class="priceLabel">Styling</div>
                   <div class="ratingField">
                    <span *ngIf="isReviewEditable">
                      <input type="textbox" class="textBox" [(ngModel)]="tempReviewData.bikeStyling" appTwoDigitDecimaNumber
                    >/{{maxReviewRating}}</span>
                    <span *ngIf="!isReviewEditable">{{cardData.review.bikeStyling}}/{{maxReviewRating}}</span>
                   <div class="ratingr" #ratingEl><div [style.width]="applyStyles(cardData.review.bikeStyling,'bikeStyling')"> </div> </div>
                 </div>                
                </div>
             </div>
             <div class="ratingPriceBlock">
              <div class="rating">
                 <div class="ratingLabel">Safety</div>
                 <div class="ratingField">
                    <span *ngIf="isReviewEditable">
                      <input type="textbox" class="textBox" [(ngModel)]="tempReviewData.carSafety" appTwoDigitDecimaNumber
                    >/{{maxReviewRating}}</span>
                    <span *ngIf="!isReviewEditable">{{cardData.review.carSafety}}/{{maxReviewRating}}</span>
                   <div class="ratingr" #ratingEl><div [style.width]="applyStyles(cardData.review.carSafety,'carSafety')"> </div> </div>
                 </div>
              </div>
              <div class="price">
                 <div class="priceLabel">Ride and Handling</div>
                 <div class="ratingField">
                  <span *ngIf="isReviewEditable">
                    <input type="textbox" class="textBox" [(ngModel)]="tempReviewData.bikeRide" appTwoDigitDecimaNumber
                  >/{{maxReviewRating}}</span>
                  <span *ngIf="!isReviewEditable">{{cardData.review.bikeRide}}/{{maxReviewRating}}</span>
                 <div class="ratingr" #ratingEl><div [style.width]="applyStyles(cardData.review.bikeRide,'bikeRide')"> </div> </div>
               </div>
              </div>
           </div>
           <div class="ratingPriceBlock">
            <div class="rating">
               <div class="ratingLabel">Design</div>
               <div class="ratingField">
                  <span *ngIf="isReviewEditable">
                    <input type="textbox" class="textBox" [(ngModel)]="tempReviewData.carDesign" appTwoDigitDecimaNumber
                  >/{{maxReviewRating}}</span>
                  <span *ngIf="!isReviewEditable">{{cardData.review.carDesign}}/{{maxReviewRating}}</span>
                 <div class="ratingr" #ratingEl><div [style.width]="applyStyles(cardData.review.carDesign,'carDesign')"> </div> </div>
               </div>
            </div>
            <div class="price">
               <div class="priceLabel">Cost</div>
               <div class="ratingField">
                <span *ngIf="isReviewEditable">
                  <input type="textbox" class="textBox" [(ngModel)]="tempReviewData.bikeCost" appTwoDigitDecimaNumber
                >/{{maxReviewRating}}</span>
                <span *ngIf="!isReviewEditable">{{cardData.review.bikeCost}}/{{maxReviewRating}}</span>
               <div class="ratingr" #ratingEl><div [style.width]="applyStyles(cardData.review.bikeCost,'bikeCost')"> </div> </div>
             </div>
            </div>
         </div>
         <div class="ratingPriceBlock">
          <div class="rating">
             <div class="ratingLabel">Features</div>
             <div class="ratingField">
                <span *ngIf="isReviewEditable">
                  <input type="textbox" class="textBox" [(ngModel)]="tempReviewData.carFeature" appTwoDigitDecimaNumber
                >/{{maxReviewRating}}</span>
                <span *ngIf="!isReviewEditable">{{cardData.review.carFeature}}/{{maxReviewRating}}</span>
               <div class="ratingr" #ratingEl><div [style.width]="applyStyles(cardData.review.carFeature,'carFeature')"> </div> </div>
             </div>
          </div>
          <div class="price">
             <div class="priceLabel">Mileage/Range</div>
             <div class="ratingField">
              <span *ngIf="isReviewEditable">
                <input type="textbox" class="textBox" [(ngModel)]="tempReviewData.bikeMileage" appTwoDigitDecimaNumber
              >/{{maxReviewRating}}</span>
              <span *ngIf="!isReviewEditable">{{cardData.review.bikeMileage}}/{{maxReviewRating}}</span>
             <div class="ratingr" #ratingEl><div [style.width]="applyStyles(cardData.review.bikeMileage,'bikeMileage')"> </div> </div>
           </div>
          </div>
       </div>
       <div class="ratingPriceBlock">
        <div class="rating">
           <div class="ratingLabel">Comfort</div>
           <div class="ratingField">
              <span *ngIf="isReviewEditable">
                <input type="textbox" class="textBox" [(ngModel)]="tempReviewData.carComfort" appTwoDigitDecimaNumber
              >/{{maxReviewRating}}</span>
              <span *ngIf="!isReviewEditable">{{cardData.review.carComfort}}/{{maxReviewRating}}</span>
             <div class="ratingr" #ratingEl><div [style.width]="applyStyles(cardData.review.carComfort,'carComfort')"> </div> </div>
           </div>
        </div>
     </div>
            </div>
           
       </div>
       <div *ngIf="isReviewEditable">
        <button type="button" name="cancel" tabindex="0" (click)="cancelReviewEditing()"
        class="cancel gray ml10">Cancel</button>
        <button type="button" name="unlock" tabindex="0" (click)="finishReviewEditing()"
        class="add blue ml10">Done</button>
       </div>
      </div>
      <!-- <span (click)="trigger($event)"></span> -->
      <div class="storyaction" *ngIf="EditMode">
          <span class="handle sortpara" *ngIf="!hideDragger && !isReviewEditable"><i class="icon-move"></i></span>
          <span class="editBtn" *ngIf="!isReviewEditable" (click)="editReview()"><i class="icon-pickup"></i></span>
          <span class="deleteHeadline" (click)="deleteElement()"><i class="icon-delete"></i></span>
      </div>
    </div>
    </ng-container>

    <ng-container *ngSwitchCase="'movie-review'">
      <div #reviewEl tabindex="0" class="paragraph " *ngIf="cardData" (focus)="outerDivFocus = true" (blur)="outerDivFocus = false"
      (mouseenter)="hoverEnter()" (mouseleave)="hoverLeave()">
      <label [style.visibility]="(isCursorHovering ? 'visible' : 'hidden')">Movie Rating</label>
      <div class="dataField bdrfill table">
        <div class="review">
          <div class="ratingPriceBlock">
             <div class="rating">
                <div class="ratingLabel">Rating</div>
                <div class="ratingField">
                   <span *ngIf="isReviewEditable">
                     <input type="textbox" class="textBox rate" [(ngModel)]="tempMovieReviewData.rating" appTwoDigitDecimaNumber
                   >/{{maxReviewRating}}</span>
                   <span *ngIf="!isReviewEditable">{{cardData.movieReview.rating}}/{{maxReviewRating}}</span>
                  <div class="ratingr" #ratingEl><div [style.width]="applyStyles(cardData.movieReview.rating,'movieReview')"> </div> </div>
                </div>
             </div>
          </div>
          <div class="ratingPriceBlock mt5">
            <div class="rating">
               <div class="ratingLabel" style="width:100%;">Movie Name</div>
               <div class="addPros" style="margin-top:5px;    display: inline-block;width: 100%;">
                  <span *ngIf="isReviewEditable">
                    <input type="text" class="textBox reviewInput" [(ngModel)]="tempMovieReviewData.name"></span>
                  <span *ngIf="!isReviewEditable">{{cardData.movieReview.name}}</span>
               </div>
            </div>
         </div>
         <div class="ratingPriceBlock mt5">
          <div class="rating newrate">
            <div class="ratingLabel" style="width:100%; float: none; margin-bottom: 10px;">Movie Image</div>
          <div *ngIf="isReviewEditable" class="custom_img">
             <div class="uploadimage"><i class="icon-upload"></i>
              <div class="upload-btn-wrapper">
                <span class="btn">Upload a new Image</span> 
                <input type="file" name="myfile" accept="image/*" (change)="movieImageUplaod($event)" />
              </div> 
             </div> 

            <div class="pickimage"><i class="icon-image-library"></i>
              <span (click)="showGallery()" class="pickimageBtn">Pick from Image Library</span>
              <div class="lightBox block" *ngIf="isLightbox">
                <div class="headerLight">
                  <div class="close fl spImg" (click)="disableshowGallery()"></div>
                </div>
                <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="setMovieImage($event)"
                  *ngIf="isPhotopopup"></div>
              </div>
            </div>
          </div>
            <div class="sampleimg" *ngIf = "cardData.movieReview.image &&
            cardData.movieReview.image.images && cardData.movieReview.image.images.original">
              <div class="top imagePage">
                <img alt="" style="width: 100%;height: 100%;"
                  src="{{cardData.movieReview.image.images.original}}">
                <div class="sampleIcon" *ngIf="isReviewEditable">
                  <span class="deleteHeadline" (click)="deleteMovieImage()"><i class="icon-delete"></i></span>
                </div>
              </div>
            </div>
        </div>
         </div>
          <div class="verdictBox">
              <div class="specHeading">Movie Description</div>
              <div class="addVerdict">
                <span *ngIf="isReviewEditable">
                <ckeditor #editorMovieDescription *ngIf="!textDifferenceCase" [editor]="ckEditor"
                id="movieDescription"
                [(ngModel)]="tempMovieReviewData.description"
                (ready)="ckchanges($event, 'ready', 'movieDescription','movieDescription')"
                type="text" class="textBox verdictInput" [config]="getEditorConfig()"></ckeditor>
                  </span>
                  <p *ngIf="!isReviewEditable" [innerHtml]="cardData.movieReview.description"></p>
                </div>
          </div>
          <div class="verdictBox">
            <div class="specHeading">Movie Review</div>
            <div class="addVerdict">
                <span *ngIf="isReviewEditable">
                <ckeditor #editorMovieReview *ngIf="!textDifferenceCase" [editor]="ckEditor"
                id="movieReview"
                [(ngModel)]="tempMovieReviewData.review"
                (ready)="ckchanges($event, 'ready', 'movieReview','movieReview')"
                type="text" class="textBox verdictInput" [config]="getEditorConfig()"></ckeditor>
                  </span>
                <p *ngIf="!isReviewEditable" [innerHtml]="cardData.movieReview.review"></p>
            </div>
          </div>
       </div>
       <div *ngIf="isReviewEditable">
        <button type="button" name="cancel" tabindex="0" (click)="cancelMovieReviewEditing()"
        class="cancel gray ml10">Cancel</button>
        <button type="button" name="unlock" tabindex="0" (click)="finishMovieReviewEditing()"
        class="add blue ml10">Done</button>
       </div>
      </div>
      <!-- <span (click)="trigger($event)"></span> -->
      <div class="storyaction" *ngIf="EditMode">
          <span class="handle sortpara" *ngIf="!hideDragger && !isReviewEditable"><i class="icon-move"></i></span>
          <span class="editBtn" *ngIf="!isReviewEditable" (click)="editMovieReview()"><i class="icon-pickup"></i></span>
          <span class="deleteHeadline" (click)="deleteElement()"><i class="icon-delete"></i></span>
      </div>
    </div>
    </ng-container>
    <ng-container *ngSwitchCase="'mintlite'">

      <div #liveblogEl tabindex="0" (focus)="outerDivFocus = true" (blur)="outerDivFocus = false"
        [class]="outerDivFocus ? 'enableFocus blockShow': 'blockShow'" (mouseenter)="hoverEnter()" (mouseleave)="hoverLeave()" (click)="editorClick('desc')">
        <ul class="listicleBlock storyuL bdrfillN">
          <li class="headline">
            <label style="visibility:hidden">Title {{index}}
              <span>{{cardData.title ? htmlToPlaintext(cardData.title).length : '0'}}/80 char</span>
            </label>
            <div class="dataField">
              <ng-container *ngIf="isCKEditorEnabled">
                <div id="editor" (keyup)="titleKeyUpEvent($event)" (keydown)="titleKeyDownEventCk($event)">
                  <ckeditor #editorTitle [editor]="ckEditor"  id="{{id}}"
                  [(ngModel)]="cardData.title"
                  [config]="ckplainconfig"
                  [tabindex]="0"
                  (ready)="ckchanges($event, 'ready', 'title','title')"
                  (change)="ckchanges($event,'change', 'title','title')"
                  (blur)="ckchanges($event, 'blur', 'title','title')"
                  (focus)="ckchanges($event, 'focus', 'title','title')"
                  (error)="ckchanges($event, 'error', 'title','title')"
                  ></ckeditor>
                </div>
              </ng-container>

            </div>
          </li>

          <li class="leadMedia" id="leadMedia">
            <ng-container *ngIf="(cardData.liveBlog.inlineElementId) && !uploadImageInProgress">
              <div class="element-module" #liveblogLeadEl [EditMode]="EditMode" [id]="cardData.liveBlog.inlineElementId"
                [cardId]="cardData.liveBlog.inlineElementId" (deleteCardfn)="deleteImageCardEmit($event)"
                (sendWordCountToStory)="getWordCount($event)" [nestedElement]="true" [hideDragger]="true"
                (replaceImageEmit)="innerReplace()" (previousFocusEmit)="focusOnElement($event, 'up')"
                (nextFocusEmit)="focusOnElement($event, 'down')" (outputEmbedSourceUrl)=getEmbedSourceUrl($event)>
              </div>
            </ng-container>
            <ng-container *ngIf="uploadImageInProgress">
              <div class="imagepreloader">
                <div class="a" style="--n: 5;">
                  <div class="dot dot1" style="--i: 0;"></div>
                  <div class="dot dot2" style="--i: 1;"></div>
                  <div class="dot dot3" style="--i: 2;"></div>
                  <div class="dot dot4" style="--i: 3;"></div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="!cardData.liveBlog.inlineElementId && EditMode && !uploadImageInProgress">
              <label [style.visibility]="focusOnLeadMedia ? 'visible' : 'hidden'">Lead Media</label>
              <div class="dataField" tabindex="3">
                <ul [ngClass]="{'z-high': leadMediaImageToggle}" class="leadMediaIcon">
                  <li class="spImg_story" #innerLeadel>
                    <span class="i_image" [ngClass]="{'active' : leadMediaImageToggle}" (click)="listClick($event,1)"><i
                        class="icon-image"></i></span>
                    <div [class]="'imageAction' +  (leadMediaImageToggle ? ' block' : '') ">
                      <div class="blockContain">
                        <div class="uploadimage"><i class="icon-upload"></i>
                          <div class="upload-btn-wrapper">
                            <span class="btn">Upload a new Image</span>
                            <input type="file" accept="image/*" name="myfile" (change)="onFileChange($event, 'elements')" />
                          </div>
                        </div>
                        <div class="pickimage"><i class="icon-image-library"></i>
                          <span (click)="showGallery()" class="pickimageBtn">Pick from Image Library</span>
                          <div class="lightBox block" *ngIf="isLightbox">
                            <div class="headerLight">
                              <div class="close fl spImg" (click)="disableshowGallery()"></div>
                            </div>
                            <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="getLeadMediaId($event)"
                              *ngIf="isPhotopopup"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <span class="i_embed" (click)="addEmbedAsLead($event)">
                      <i class="icon-embed"></i>
                    </span>
                  </li>
                </ul>
              </div>
            </ng-container>
          </li>
          <li class="summary">
            <label style="visibility:hidden">Detail
              <span>{{(cardData.liveBlog.body ? htmlToPlaintext(cardData.liveBlog.body).length : '0')}}/80 char</span>
            </label>
            <ng-container *ngIf="sharedService.isdomainConfig('story','isStoryListingEnabled')">
              <button id="backlinkID" class="story_link" *ngIf="showHyperlinkIcon " (click)="hyperlinkStoryList($event, 'desc')">
                <i class="icomoon icon-link icon-info" data-title="Hyperlink StoryList"></i></button>
            </ng-container>
            <div class="dataField" #descEl>
              <!-- <textarea type="text" class="textBox" placeholder="Point 1 description" onkeyup="auto_grow(this)"></textarea> -->
              <ng-container *ngIf="isCKEditorEnabled">
                <div id="editor" (keyup)="descriptionKeyUpEvent($event)" (keydown)="descriptionKeyDownEventCk($event)">
                  <ckeditor #editorLiveBlogBody [editor]="ckEditor2"  id="{{id}}"
                  placeholder="Cards's description"
                  [(ngModel)]="cardData.liveBlog.body"
                  [config]="getEditorConfig()"
                  [tabindex]="0"
                  (ready)="ckchanges($event, 'ready', 'desc','liveblogbody')"
                  (change)="ckchanges($event, 'change', 'desc','liveblogbody')"
                  (blur)="ckchanges($event, 'blur', 'desc','liveblogbody')"
                  (focus)="ckchanges($event, 'focus', 'desc','liveblogbody')"
                  (error)="ckchanges($event, 'error', 'desc','liveblogbody')"
                  ></ckeditor>
                </div>
              </ng-container>

            </div>
          </li>
        </ul>
        <div class="storyaction" *ngIf="EditMode && (id !== 'newLiveblogElement')">
          <span class="deleteHeadline" (click)="deleteElement()"><i class="icon-delete"></i></span>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'chart'">
      <div #chartEl tabindex="0" class="paragraph " *ngIf="cardData" (focus)="outerDivFocus = true" (blur)="outerDivFocus = false"
        (mouseenter)="hoverEnter()" (mouseleave)="hoverLeave()">


        <div class="leadMedia">
          <label [style.visibility]="(isCursorHovering ? 'visible' : 'hidden')">Chart</label>
          <div class="dataField bdrfill">
            <div class="leadimage fl wid100">
              <div class="imageblock">
                <div class="imagepreloader" *ngIf="!loaded">
                  <div class="a" style="--n: 5;">
                    <div class="dot dot1" style="--i: 0;"></div>
                    <div class="dot dot2" style="--i: 1;"></div>
                    <div class="dot dot3" style="--i: 2;"></div>
                    <div class="dot dot4" style="--i: 3;"></div>
                  </div>
                </div>
                <img [style.visibility]="loaded ? 'visible' : 'hidden'"
                  [src]="(cardData.chart && cardData.chart.images && cardData.chart.images.original) ? cardData.chart.images.original : null"
                  (load)="imgLoaded($event)" alt="">
              </div>
            </div>
          </div>
          <div class="storyaction">
            <span class="handle sortpara" *ngIf="!hideDragger"><i class="icon-move"></i></span>
            <span class="deleteHeadline" (click)="deleteElement()"><i class="icon-delete"></i></span>
          </div>
        </div>


      </div>
  </ng-container>
  <ng-container *ngSwitchCase="'poll'">
    <div #embedEl tabindex="0" (focus)="outerDivFocus = true" (blur)="outerDivFocus = false"
      [class]="outerDivFocus ? 'enableFocus faqStoryBlock': 'faqStoryBlock'" (mouseenter)="hoverEnter()"
      (mouseleave)="hoverLeave()">
      <label [style.visibility]="(isCursorHovering ? 'visible' : 'hidden')">
        Poll
        <!--span>{{cardData.metadata ? cardData.metadata.wordCount : ''}} words</span-->
      </label>
      <div class="dataField bdrfill">

        <ng-container>
          <div class="heading">Heading of the Poll section : {{cardData.poll.heading}}</div>
          <ng-container *ngIf="cardData.poll != null && cardData.poll !== undefined">
          <div class="faqQueAns">
            <p class="faqQuestion"><span>Question :</span> {{cardData.poll.key}}</p>
            <p class="faqQuestion" *ngIf="cardData.poll.mediaTypeKey"><span>Question Media :</span> </p>
            <div *ngIf="cardData.poll.mediaTypeKey==='image'">
              <img width="300px" *ngIf="cardData.poll.mediaTypeKey==='image'" src="{{cardData.poll.mediaKey.image.images.original}}">
            </div>
            <div *ngIf="cardData.poll.mediaTypeKey==='video'" class="respVideo" [innerHtml]="cardData.poll.mediaKey.video.body | noSanitize"></div>
            <!--div #embedEl>
              <div *ngIf="faq.mediaTypeKey==='embed'" [innerHtml]="faq.mediaKey.embedCode | noSanitize"></div>
            </div-->
            <ng-container *ngFor="let faq of cardData.poll.ansArray;let i = index">
            <p class="faqQuestion"><span>Answer {{i+1}} :</span> {{faq.value}}</p>
            <p class="faqQuestion" *ngIf="faq.mediaTypeValue"><span>Answer Media :</span> </p>
            <div *ngIf="faq.mediaTypeValue==='image'">
              <img width="300px" *ngIf="faq.mediaTypeValue==='image'" src="{{faq.mediaValue.image.images.original}}">
            </div>
            <div *ngIf="faq.mediaTypeValue==='video'" class="respVideo" [innerHtml]="faq.mediaValue.video.body | noSanitize">
            </div>
            </ng-container>
            <!--div #embedEl>
            <div *ngIf="faq.mediaTypeValue==='embed'" [innerHtml]="faq.mediaValue.embedCode | noSanitize"></div>
            </div-->
          </div>
          </ng-container>
        </ng-container>
      </div>

      <div class="storyaction" *ngIf="EditMode && !nestedElement">
        <span class="handle sortpara" *ngIf="!hideDragger"><i class="icon-move"></i></span>
        <span class="editBtn" (click)="onelementFocus()"><i class="icon-pickup"></i></span>
        <span class="deleteHeadline" (click)="deleteElement()"><i class="icon-delete"></i></span>
      </div>
    </div>
  </ng-container>
    <div *ngSwitchDefault></div>
  </ng-container>
  </ng-container>
</div>

<ng-template #loading>
  <div style="text-align: center; display: inline-block; width: 100%">
    <img src="/assets/images/loading.gif" />
  </div>
</ng-template>

<div class="lightBox videoblock block" *ngIf="videoUrlPopup">
  <div class="unlockStory">
    <div class="wid100 pad30">
      <h3>Add Video Embed</h3>
      <textarea type="text" class="textBox" [(ngModel)]="videoUrl" placeholder="Enter Video Embed here…"
        tabindex="0"></textarea>
        <label>Add video duration</label>
        <input type="text" class="textBox"
        placeholder="Add duration here" nuberInput maxLength="isHomepageOptionsEnabled()"
        [(ngModel)]="videoDuration">
    </div>
    <div class="fr wid100 right padlr30 ptb15">
      <button type="button" name="cancel" tabindex="0" (click)="cancelChangeVideo()"
        class="cancel gray ml10">Cancel</button>
      <button type="button" name="unlock" tabindex="0" (click)="finishChangeVideo()" class="add blue ml10"
        [disabled]="videoUrl.trim() === ''">Done</button>
    </div>
  </div>
</div>


<div class="lightBox embeddblock block" *ngIf="embedPopup">
  <div class="unlockStory">
    <div class="wid100 pad30 embedScrollBlock">
      <h3>Edit Embed</h3>
      <li *ngIf="amazonAdDisplay===true">
        <!-- <div class="amazonAds">
        <label>Amazon Meta</label>
        <div class="dataField">
          <label class="switch" tabindex="0">
            <input type="checkbox" (click)="toggleSwitch('amazonMeta')"     [checked]="showAmazonMeta || (cardData.amazonAds.length > 0)">
            <span class="slider round"></span>
          </label>
        </div>
        </div> -->
      </li>
      <ng-container *ngIf="cardData.affiliateMeta">
          <!-- <div class="amazonAds"><label>Add Other Affiliate Embed</label> -->
            <form [formGroup]="tempOtherAffiliateData">
              <div class="stepScroll">
                <label>( * is compulsary )</label>
                <li>
                  <div class="">
                  <label>Product Name *</label>
                  <div class="dataField">
                      <textarea class="textBoxSmall" formControlName="productName" placeholder="Enter the Product Name" tabindex="0" type="text"></textarea>
                      <span class="requiredField" *ngIf="tempOtherAffiliateData.get('productName').touched && !tempOtherAffiliateData.get('productName').valid &&
                      tempOtherAffiliateData.get('productName').errors?.required">Product Name is required</span>
                  </div>
                  </div>
                </li>
                <li>
                  <div class="">
                  <label>Original Selling Price *</label>
                  <div class="dataField">
                    <textarea class="textBoxSmall" formControlName="osp" (keydown)="validateKeyPressForNumberOnlyField($event)" placeholder="Enter the Original Selling Price" tabindex="0" type="text"></textarea>
                      <span class="requiredField" *ngIf="tempOtherAffiliateData.get('osp').touched && !tempOtherAffiliateData.get('osp').valid &&
                      tempOtherAffiliateData.get('osp').errors?.required">Original Selling Price is required</span>
                  </div>
                  </div>
                </li>
                <li>
                  <div class="">
                  <label>Current Selling Price</label>
                  <div class="dataField">
                    <textarea class="textBoxSmall" formControlName="curr_sell_price" placeholder="Enter the Current Selling Price" tabindex="0" type="text" (keydown)="validateKeyPressForNumberOnlyField($event)" ></textarea>
                  </div>
                  </div>
                </li>
                <li>
                  <div class="">
                  <label>Discount Percentage</label>
                  <div class="dataField">
                    <textarea maxlength="3" class="textBoxSmall" formControlName="discount_perc" placeholder="Enter the Discount Percentage" tabindex="0" type="text" (keydown)="validateKeyPressForNumberOnlyField($event)"></textarea>
                  </div>
                  </div>
                </li>
                <li>
                  <div class="">
                  <label>URL</label>
                  <div class="dataField">
                    <textarea class="textBoxSmall" formControlName="url" placeholder="Enter the URL" tabindex="0" type="text" ></textarea>
                  </div>
                  </div>
                </li>
                <li>
                  <div class="">
                    <ng-container *ngIf="tempOtherAffiliateData.get('logo').value === null || tempOtherAffiliateData.get('logo').value === ''">
                      <label>Upload Logo of the Affiliate Partner *</label>
                      <div class="dataField">
                        <div class="stepsDropBlock">
                          <div class="imageInsert">
                            <span>Upload from file</span>
                            <input type="file" name="myfile" accept="image/*" (change)="onFileChangeSingle($event, 'affiliateLogo')" />
                          </div>
                          <div class="imageLibrary" (click)="addLogoGallery()">
                            <span>Pick from Library</span>
                          </div>
                          </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="tempOtherAffiliateData.get('logo').value != null && tempOtherAffiliateData.get('logo').value != ''">
                      <label>Logo of the Affiliate Partner *</label>
                      <div class="dataField">
                        <div class="stepsDropBlock imageNameView">
                      {{tempOtherAffiliateData.get('logo').value}}

                      <span (click)="removeAffiliateImage('logo')" style="cursor: pointer;">( Remove Image )</span>
                    </div>
                    </div>
                    </ng-container>
                  </div>
                </li>
                <li>
                  <div class="">
                    <ng-container *ngIf="tempOtherAffiliateProductImage === null">
                      <label>Upload Product Image *</label>
                      <div class="dataField">
                        <div class="stepsDropBlock">
                          <div class="imageInsert">
                            <span>Upload from file</span>
                            <input type="file" name="myfile" accept="image/*" (change)="onFileChangeSingle($event, 'productImage')" />
                          </div>
                          <div class="imageLibrary" (click)="addProductImageGallery()">
                            <span>Pick from Library</span>
                          </div>
                          </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="tempOtherAffiliateProductImage">
                      <label>Product Image *</label>
                      <div class="dataField">
                        <div class="stepsDropBlock imageNameView">
                      {{tempOtherAffiliateProductImage[0]}}

                      <span (click)="removeAffiliateImage('product')" style="cursor: pointer;">( Remove Image )</span>
                    </div>
                    </div>
                    </ng-container>
                  </div>
                </li>
              </div>
            </form>
          <!-- </div> -->
      </ng-container>


      <ng-container *ngIf="!cardData.affiliateMeta">
          <ng-container *ngIf="showAmazonMeta != true && showSnapdealMeta != true && showCromaMeta!= true && showFlipkartMeta!=true">
          <label>{{getEmbedPopupTitle()}}</label>
          <textarea type="text" class="textBox" [(ngModel)]="embedCode"
            placeholder="Enter for the Facebook, tweet, etc here…" tabindex="0"></textarea>
            <label>Source URL</label>
            <textarea type="text" class="textBoxSmall" [(ngModel)]="embedSourceUrl" placeholder="Enter Source url here" tabindex="0"></textarea>
            <label>Subtype</label>
            <textarea type="text" class="textBoxSmall" [(ngModel)]="embedSubType" placeholder="Enter Subtype here" tabindex="0"></textarea>
          </ng-container>
          <div  *ngIf="showAmazonMeta || showCromaMeta || showSnapdealMeta || showFlipkartMeta">
          <label>Title</label>
          <textarea type="text" class="textBoxSmall marBot10" [(ngModel)]="cardData.embed.title" placeholder="Enter Ad title here" tabindex="0"></textarea>
          </div>
          <ng-container *ngIf="showAmazonMeta===true">
            <div class="amazonAds">
            <label>Add Amazon Custom Ads</label>
            <span id="headline1" class="plusHeadline" (click)="addAmazonMeta()">
              <i class="icon-add-headline"></i>
            </span>
            </div>

            <ng-container *ngIf="amazonNewAd">
              <br/>
              <textarea type="text" class="textBoxSmall marBot10" [(ngModel)]="newAmazonAdName" placeholder="Enter Ad Name here" tabindex="0"></textarea>
              <textarea type="text" class="textBoxSmall" [(ngModel)]="newAmazonAdEmbed" placeholder="Enter Ad Embed here" tabindex="0"></textarea>
              <button type="button" tabindex="0" name="unlock" (click)="saveAmazonEmbed()" class="add blue ml10 amazonAddSpace">Add</button>
            </ng-container>
            <div [dragula]="'new-bag1'" [(dragulaModel)]='cardData.amazonAds'>
            <ng-container *ngFor="let amazonAd of amazonAds; let i =index">
              <div class="container embedCallBlock" >
              <textarea type="text" class="textBoxSmall marBot10" [(ngModel)]="amazonAd.key" placeholder="Enter ad name here..." tabindex="0"></textarea>
              <textarea type="text" class="textBoxSmall" [(ngModel)]="amazonAd.value" placeholder="Enter Custom {{amazonAd.key}} here" tabindex="0"></textarea>
              <span class="deleteHeadline amazonAddSpace" id="headline2" (click)="deleteAmazonAd(i)">
                <i class="icon-delete"></i>
              </span>
              <!-- <span class="handle sortpara1" *ngIf="amazonAds.length > 1"><i class="icon-move affiMove"></i></span> -->
            </div>
            </ng-container>
          </div>
          </ng-container>
          <ng-container *ngIf="showSnapdealMeta===true">
            <br/>
            <!-- <label>Title</label> -->
            <!-- <textarea type="text" class="textBoxSmall marBot10" [(ngModel)]="cardData.embed.title" placeholder="Enter Ad title here" tabindex="0"></textarea> -->
            <div class="amazonAds">
            <label>Add Snapdeal Custom Ads</label>
            <span id="headline1" class="plusHeadline" (click)="addSnapdealMeta()">
              <i class="icon-add-headline"></i>
            </span>
            </div>

            <ng-container *ngIf="snapdealNewAd">
              <textarea type="text" class="textBoxSmall marBot10" [(ngModel)]="newSnapdealAdName" placeholder="Enter Ad Name here" tabindex="0"></textarea>
              <textarea type="text" class="textBoxSmall" [(ngModel)]="newSnapdealAdEmbed" placeholder="Enter Ad Embed here" tabindex="0"></textarea>
              <button type="button" tabindex="0" name="unlock" (click)="saveSnapdealEmbed()" class="add blue ml10 amazonAddSpace">Add</button>
            </ng-container>
            <div [dragula]="'new-bag1'" [(dragulaModel)]='cardData.snapdealAds'>
            <ng-container *ngFor="let amazonAd of snapdealAds; let i =index">
              <div class="container embedCallBlock" >
              <textarea type="text" class="textBoxSmall marBot10" [(ngModel)]="amazonAd.key" placeholder="Enter ad name here..." tabindex="0"></textarea>
              <textarea type="text" class="textBoxSmall" [(ngModel)]="amazonAd.value" placeholder="Enter Custom {{amazonAd.key}} here" tabindex="0"></textarea>
              <span class="deleteHeadline amazonAddSpace" id="headline2" (click)="deleteSnapdealAd(i)">
                <i class="icon-delete"></i>
              </span>
              <!-- <span class="handle sortpara1" *ngIf="amazonAds.length > 1"><i class="icon-move affiMove"></i></span> -->
            </div>
            </ng-container>
          </div>
          </ng-container>
          <ng-container *ngIf="showCromaMeta===true">
            <br/>
            <!-- <label>Title</label> -->
            <!-- <textarea type="text" class="textBoxSmall marBot10" [(ngModel)]="cardData.embed.title" placeholder="Enter Ad title here" tabindex="0"></textarea> -->
            <div class="amazonAds">
            <label>Add Croma Custom Ads</label>
            <span id="headline1" class="plusHeadline" (click)="addCromaMeta()">
              <i class="icon-add-headline"></i>
            </span>
            </div>

            <ng-container *ngIf="cromaNewAd">
              <textarea type="text" class="textBoxSmall marBot10" [(ngModel)]="newCromaAdName" placeholder="Enter Ad Name here" tabindex="0"></textarea>
              <textarea type="text" class="textBoxSmall" [(ngModel)]="newCromaAdEmbed" placeholder="Enter Ad Embed here" tabindex="0"></textarea>
              <button type="button" tabindex="0" name="unlock" (click)="saveCromaEmbed()" class="add blue ml10 amazonAddSpace">Add</button>
            </ng-container>
            <ng-container *ngFor="let cromaAd of cromaAds; let i =index">
              <div class="container embedCallBlock" >
              <textarea type="text" class="textBoxSmall marBot10" [(ngModel)]="cromaAd.key" placeholder="Enter ad name here..." tabindex="0"></textarea>
              <textarea type="text" class="textBoxSmall" [(ngModel)]="cromaAd.value" placeholder="Enter Custom {{cromaAd.key}} here" tabindex="0"></textarea>
              <span class="deleteHeadline amazonAddSpace" id="headline2" (click)="deleteCromaAd(i)">
                <i class="icon-delete"></i>
              </span>
            </div>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="showFlipkartMeta===true">
          <br/>
          <!-- <label>Title</label> -->
          <!-- <textarea type="text" class="textBoxSmall marBot10" [(ngModel)]="cardData.embed.title" placeholder="Enter Ad title here" tabindex="0"></textarea> -->
          <div class="amazonAds">
          <label>Add Flipkart Custom Ads</label>
          <span id="headline1" class="plusHeadline" (click)="addFlipkartMeta()">
            <i class="icon-add-headline"></i>
          </span>
          </div>

          <ng-container *ngIf="flipkartNewAd">
            <textarea type="text" class="textBoxSmall marBot10" [(ngModel)]="newFlipkartAdName" placeholder="Enter Ad Name here" tabindex="0"></textarea>
            <textarea type="text" class="textBoxSmall" [(ngModel)]="newFlipkartAdEmbed" placeholder="Enter Ad Embed here" tabindex="0"></textarea>
            <button type="button" tabindex="0" name="unlock" (click)="saveFlipkartEmbed()" class="add blue ml10 amazonAddSpace">Add</button>
          </ng-container>
          <ng-container *ngFor="let flipkartAd of flipkartAds; let i =index">
            <div class="container embedCallBlock" >
            <textarea type="text" class="textBoxSmall marBot10" [(ngModel)]="flipkartAd.key" placeholder="Enter ad name here..." tabindex="0"></textarea>
            <textarea type="text" class="textBoxSmall" [(ngModel)]="flipkartAd.value" placeholder="Enter Custom {{flipkartAd.key}} here" tabindex="0"></textarea>
            <span class="deleteHeadline amazonAddSpace" id="headline2" (click)="deleteFlipkartAd(i)">
              <i class="icon-delete"></i>
            </span>
          </div>
          </ng-container>
      </ng-container>
      </ng-container>

      </div>
    <div class="fr wid100 right padlr30 ptb15">
      <button type="button" name="cancel" tabindex="0" (click)="closeEmbedPopup()"
        class="cancel gray ml10">Cancel</button>

      <button *ngIf="!cardData.affiliateMeta" type="button" name="unlock" tabindex="0" (click)="saveEmbed()" class="add blue ml10">Done</button>
      <button *ngIf="cardData.affiliateMeta" type="button" name="unlock" tabindex="0" (click)="updateOtherAffiliateEmbed()" class="add blue ml10">Save Other Affiliate</button>
    </div>
  </div>
</div>

<div class="lightBox faqblock block" *ngIf="showFaqPopup">
  <div class="unlockStory">
    <div class="wid100">
      <h3 class="pad30">Update FAQs</h3><span class="shortCutsKeyPopup">(<i>Press cmd+k/ctrl+k for hyperlink</i>)</span>
      <form [formGroup]="tempFaqData">
        <li>
          <div class="headingBlock">
          <label>Heading of the FAQ section<span>(Max. 100 characters)</span></label>
          <div class="dataField">
              <textarea maxlength="100" class="textBoxSmall" formControlName="heading" placeholder="Enter the heading" tabindex="0" type="text"></textarea>
              <span class="requiredField" *ngIf="tempFaqData.get('heading').touched && !tempFaqData.get('heading').valid &&
              tempFaqData.get('heading').errors?.required">Heading is required</span>
            </div>
        </div>
        </li>
        <div class="faqQueAnsw">
        <ng-container formArrayName="faqs"
            *ngFor="let faq of tempFaqData.get('faqs').controls; let i = index;">
          <div class="faqBlockQue">
            <i *ngIf="tempFaqData.get('faqs').controls.length > 1" class="icon-delete" (click)="deleteFaq(i)"></i>
          <ng-container [formGroupName]="i">

              <li>
                <div class="">
                <label>Question {{i+1}}
                  <!-- <span>(Max. 100 characters)</span> -->
                </label>
                <div class="dataField">
                    <textarea  class="textBoxSmall" formControlName="key" placeholder="Enter the question" tabindex="0" type="text"></textarea>
                    <span class="requiredField" *ngIf="tempFaqData.get('faqs')['controls'][i].get('key').touched && !tempFaqData.get('faqs')['controls'][i].get('key').valid &&
                    tempFaqData.get('faqs')['controls'][i].get('key').errors?.required">Question is required</span>
                </div>
              </div>
              </li>
              <li>
                <div class="">
                <label>Answer {{i+1}}
                  <!-- <span>(Max. 500 characters)</span> -->
                </label>
                <div class="dataField">
                    <ckeditor [editor]="ckEditor"  formControlName="value" placeholder="Enter the answer" tabindex="0" type="text"></ckeditor>
                    <span class="requiredField" *ngIf="tempFaqData.get('faqs')['controls'][i].get('value').touched && !tempFaqData.get('faqs')['controls'][i].get('value').valid &&
                    tempFaqData.get('faqs')['controls'][i].get('value').errors?.required">Answer is required</span>
                </div>
              </div>
              </li>
          </ng-container>
        </div>
        </ng-container>
      </div>
      </form>
    </div>
    <div class="fr wid100 right padlr30 ptb15">
      <button type="button" tabindex="0" name="cancel" (click)="addFaq()" class="cancel btnFaq">+ Add another QnA</button>
      <button type="button" tabindex="0" name="cancel" (click)="closeFaqPopup()" class="cancel gray ml10">Cancel</button>
      <button type="button" tabindex="0" name="unlock" class="add blue ml10 " (click)="updateFaqs()">Done</button>
    </div>
  </div>
</div>

<div class="lightBox listicle-element-popup block" *ngIf="showListiclePopup" style="z-index: 10 !important;" >
  <div class="unlockStory">
    <div class="wid100">
      <h3 class="pad30">Update List</h3>
      <form [formGroup]="tempListicleData" style="overflow-y: scroll;">
        <li>
          <div class="headingBlock">
          <label>Heading</label>
          <div class="dataField">
              <textarea appTextareaAutoresize class="textBoxSmall" formControlName="heading" placeholder="Enter the heading" tabindex="0" type="text"></textarea>
          </div>
          <div style="margin-top: 2%;">
            <span class="listicle-element">
              Bullet Type
            </span>
            <input type="radio" id="yes" name="fav_language" formControlName = "listicleBulletType" name="listicleBulletType" [checked]="cardData.listicleBulletType==='number'" value="number" class="margin-left">
           <span class="listicle-element">Numbered</span>
           <input type="radio" id="no" name="fav_language" formControlName = "listicleBulletType" name="listicleBulletType" [checked]="cardData.listicleBulletType==='bullet'" value="bullet" style="margin-left: 2%;">
           <span class="listicle-element">Bulleted</span>
          <input type="radio" id="no" name="fav_language" formControlName = "listicleBulletType" name="listicleBulletType" [checked]="cardData.listicleBulletType==='border'" value="border" style="margin-left: 2%;">
           <span class="listicle-element">Bordered</span>
          </div>
        </div>
        </li>
        <div class="faqQueAnsw" style="overflow-y: none;">
          <ng-container formArrayName="listicleArray"
              *ngFor="let faq of tempListicleData.get('listicleArray').controls; let i = index;">
            <div class="listBlockQue">
              <i *ngIf="tempListicleData.get('listicleArray').controls.length > 1" class="listElement icon-delete" (click)="deleteListicle(i)"></i>
            <ng-container [formGroupName]="i">
                <li>
                  <div class="">
                  <label>Listicle Title {{i+1}}
                  </label>
                  <div class="dataField">
                      <textarea appTextareaAutoresize class="textBoxSmall" formControlName="key" placeholder="Enter the title" type="text"></textarea>
                  </div>
                </div>
                </li>
                <li>
                  <div class="answer">
                  <label>Listicle Content {{i+1}}
                  </label>
                  <div class="dataField">
                    <textarea appTextareaAutoresize class="textBoxSmall" formControlName="value" placeholder="Enter the content" type="text"></textarea>
                </div>
                </div>
                </li>
                <ng-container *ngIf="enableUrlInListicle">
                <li>
                  <div class="answer">
                  <label>Listicle Url {{i+1}}
                  </label>
                  <div class="dataField">
                    <textarea appTextareaAutoresize class="textBoxSmall" formControlName="url" placeholder="Enter the url" type="text"></textarea>
                </div>
                </div>
                </li>
                </ng-container>
                <label>Listicle Media {{i+1}}</label>
                <div *ngIf="tempListicleData === undefined || tempListicleData.get('listicleArray')['controls'][i].get('media').value === null" >
                  <i class="icon-image" style="color:#888888" (click)="addListicleImage(i,target)"></i>
                  <i class="icon-video listicle-icon" (click)="showVideoGallery('listicleMedia',i)"></i>
                  <i class="icon-embed listicle-icon" (click)="showListcleEmbed(i)"></i>
                </div>
                <ng-container *ngIf="imageLoaderShow && tempListicleData.get('listicleArray')['controls'][i].get('media').value === null && i===videoIndex">
                  <div class="imagepreloader">
                    <div class="a" style="--n: 5;top: 92%">
                      <div class="dot dot1" style="--i: 0;"></div>
                      <div class="dot dot2" style="--i: 1;"></div>
                      <div class="dot dot3" style="--i: 2;"></div>
                      <div class="dot dot4" style="--i: 3;"></div>
                    </div>
                  </div>
                </ng-container>
                <i class="icon-delete media-delete-icon" *ngIf="tempListicleData.get('listicleArray')['controls'][i].get('media').value !== null" (click)="deleteListicleMedia(i)"></i>
                <ng-container *ngIf="enableListicleImageOption && tempListicleData.get('listicleArray')['controls'][i].get('media').value === null && i===videoIndex">
                  <div class="dataField pad30">
                    <div class="stepsDropBlock">
                      <div class="imageInsert" (click)="updateCurrentHowToStep(i)">
                        <span>Upload from file</span>
                        <input type="file" name="myfile" accept="image/*" (change)="onFileChangeSingle($event, 'listicleUploadImage')" />
                      </div>
                      <div class="imageLibrary" (click)="addListicleInlineImage()">
                        <span>Pick from Library</span>
                      </div>
                      </div>
                  </div>
                </ng-container>
                <div *ngIf="tempListicleData.get('listicleArray')['controls'][i].get('mediaType').value === 'video'&&tempListicleData.get('listicleArray')['controls'][i].get('media').value !== null" class="respVideo" [innerHtml]="tempListicleData.get('listicleArray')['controls'][i].get('media').value.video.body | noSanitize">
                </div>
                <div #embedEl>
                <div *ngIf="tempListicleData.get('listicleArray')['controls'][i].get('mediaType').value === 'embed' && tempListicleData.get('listicleArray')['controls'][i].get('media').value !== null" [innerHtml]="tempListicleData.get('listicleArray')['controls'][i].get('media').value.embedCode | noSanitize">
                </div> </div>
                <div *ngIf="tempListicleData.get('listicleArray')['controls'][i].get('mediaType').value === 'image' && tempListicleData.get('listicleArray')['controls'][i].get('media').value !== null">
                  <img width="300px" src="{{tempListicleData.get('listicleArray')['controls'][i].get('media').value.image.images.original}}" (load)="onImageLoad()">
                </div>
            </ng-container>

          </div>
          </ng-container>
          <div #target>
          </div>
        </div>
      </form>
    </div>
    <div class="fr wid100 right padlr30 ptb15">
      <button type="button" tabindex="0" name="cancel" (click)="addListicle(target)" class="cancel btnFaq">+ Add another list</button>
      <button type="button" tabindex="0" name="cancel" (click)="closeListiclePopup()" class="cancel gray ml10">Cancel</button>
      <button type="button" tabindex="0" name="unlock" class="add blue ml10 "  [disabled]="!imageLoaded"
       (click)="updateListicleElement()">Done</button>
    </div>
  </div>
</div>

<div class="lightBox listicle-element-popup block" *ngIf="showNewFAQPopup" style="z-index: 10 !important;">
  <div class="unlockStory">
    <div class="wid100">
      <h3 class="pad30">Add FAQs</h3>
      <form [formGroup]="tempnewFAQData" style="overflow-y: scroll;" >
        <li>
          <div class="headingBlock">
          <label>Heading</label>
          <div class="dataField">
              <textarea appTextareaAutoresize class="textBoxSmall" formControlName="heading" placeholder="Enter the heading" tabindex="0" type="text"></textarea>
          </div>
        </div>
        </li>
        <div class="faqQueAnsw" style="overflow-y: none;">
          <ng-container formArrayName="faqArray"
              *ngFor="let faq of tempnewFAQData.get('faqArray').controls; let i = index;">
            <div class="listBlockQue">
              <i *ngIf="tempnewFAQData.get('faqArray').controls.length > 1" class="listElement icon-delete" (click)="deleteNewFAQ(i)"></i>
            <ng-container [formGroupName]="i">
                <li>
                  <div class="">
                  <label>Question  {{i+1}}
                  </label>
                  <div class="dataField">
                      <textarea appTextareaAutoresize class="textBoxSmall" formControlName="key" placeholder="Enter the Question" type="text"></textarea>
                  </div>
                </div>
                </li>
              <ng-container>
                <label>FAQ Question Media {{i+1}}</label>
                <div *ngIf="tempnewFAQData === undefined || (tempnewFAQData.get('faqArray')['controls'][i].get('mediaKey').value === null)" >
                  <i class="icon-image" style="color:#888888" (click)="addQuesFAQImage(i,target)"></i>
                  <i class="icon-video listicle-icon" (click)="showVideoGallery('quesFAQMedia',i)"></i>
                  <i class="icon-embed listicle-icon" (click)="showQuesFAQEmbed(i)"></i>
                </div>
                <ng-container *ngIf="imageLoaderShow && tempnewFAQData.get('faqArray')['controls'][i].get('mediaKey').value === null && i===videoIndex">
                  <div class="imagepreloader">
                    <div class="a" style="--n: 5;top: 92%">
                      <div class="dot dot1" style="--i: 0;"></div>
                      <div class="dot dot2" style="--i: 1;"></div>
                      <div class="dot dot3" style="--i: 2;"></div>
                      <div class="dot dot4" style="--i: 3;"></div>
                    </div>
                  </div>
                </ng-container>
                <i class="icon-delete media-delete-icon" *ngIf="tempnewFAQData.get('faqArray')['controls'][i].get('mediaKey').value !== null" (click)="deleteNewQuesFAQMedia(i)"></i>
                <ng-container *ngIf="enableQuesFAQImageOption && tempnewFAQData.get('faqArray')['controls'][i].get('mediaKey').value === null && i===videoIndex">
                  <div class="dataField pad30">
                    <div class="stepsDropBlock">
                      <div class="imageInsert">
                        <span>Upload from file</span>
                        <input type="file" name="myfile" accept="image/*" (change)="onFileChangeSingle($event, 'quesFaqUploadImage')" />
                      </div>
                      <div class="imageLibrary" (click)="addQuesFAQInlineImage()">
                        <span>Pick from Library</span>
                      </div>
                      </div>
                  </div>
                </ng-container>
                <!-- <div *ngIf="tempnewFAQData.get('faqArray')['controls'][i].get('mediaTypeKey').value === 'video'&&tempnewFAQData.get('faqArray')['controls'][i].get('mediaKey').value !== null" class="respVideo" [innerHtml]="tempnewFAQData.get('faqArray')['controls'][i].get('mediaKey').value.video.body | noSanitize">
                </div> -->
                <div *ngIf="tempnewFAQData.get('faqArray')['controls'][i].get('mediaTypeKey').value === 'video' &&
                                        tempnewFAQData.get('faqArray')['controls'][i].get('mediaKey').value !== null"
                  class="respVideo">
                  <ng-container
                    *ngIf="tempnewFAQData.get('faqArray')['controls'][i].get('mediaKey').value.video.saranyuEmbedBody; else defaultContent">
                    <!-- Display saranyuEmbedBody when present -->
                    <div
                      [innerHtml]="tempnewFAQData.get('faqArray')['controls'][i].get('mediaKey').value.video.saranyuEmbedBody | noSanitize">
                    </div>
                  </ng-container>
                  <ng-template #defaultContent>
                    <!-- Display video.body when saranyuEmbedBody is not present -->
                    <div [innerHtml]="tempnewFAQData.get('faqArray')['controls'][i].get('mediaKey').value.video.body | noSanitize">
                    </div>
                  </ng-template>
                </div>
                <div #embedEl>
                <div *ngIf="tempnewFAQData.get('faqArray')['controls'][i].get('mediaTypeKey').value === 'embed' && tempnewFAQData.get('faqArray')['controls'][i].get('mediaKey').value !== null" [innerHtml]="tempnewFAQData.get('faqArray')['controls'][i].get('mediaKey').value.embedCode | noSanitize">
                </div> </div>
                <div *ngIf="tempnewFAQData.get('faqArray')['controls'][i].get('mediaTypeKey').value === 'image' && tempnewFAQData.get('faqArray')['controls'][i].get('mediaKey').value !== null">
                  <img width="300px" src="{{tempnewFAQData.get('faqArray')['controls'][i].get('mediaKey').value.image.images.original}}">
                </div>
              </ng-container>
                <li>
                  <div class="answer">
                  <label>Answer Content {{i+1}}
                  </label>
                  <div class="dataField">
                    <textarea appTextareaAutoresize class="textBoxSmall" formControlName="value" placeholder="Enter the Answer" type="text"></textarea>
                </div>
                </div>
                </li>
                <ng-container>
                  <label>FAQ Answer Media {{i+1}}</label>
                  <div *ngIf="tempnewFAQData === undefined || (tempnewFAQData.get('faqArray')['controls'][i].get('mediaValue').value === null)" >
                    <i class="icon-image" style="color:#888888" (click)="addFAQImage(i,target)"></i>
                    <i class="icon-video listicle-icon" (click)="showVideoGallery('FAQMedia',i)"></i>
                    <i class="icon-embed listicle-icon" (click)="showFAQEmbed(i)"></i>
                  </div>
                  <ng-container *ngIf="imageLoaderShow && tempnewFAQData.get('faqArray')['controls'][i].get('mediaValue').value === null && i===videoIndex">
                    <div class="imagepreloader">
                      <div class="a" style="--n: 5;top: 92%">
                        <div class="dot dot1" style="--i: 0;"></div>
                        <div class="dot dot2" style="--i: 1;"></div>
                        <div class="dot dot3" style="--i: 2;"></div>
                        <div class="dot dot4" style="--i: 3;"></div>
                      </div>
                    </div>
                  </ng-container>
                  <i class="icon-delete media-delete-icon" *ngIf="tempnewFAQData.get('faqArray')['controls'][i].get('mediaValue').value !== null" (click)="deleteNewFAQMedia(i)"></i>
                  <ng-container *ngIf="enableFAQImageOption && tempnewFAQData.get('faqArray')['controls'][i].get('mediaValue').value === null && i===videoIndex">
                    <div class="dataField pad30">
                      <div class="stepsDropBlock">
                        <div class="imageInsert">
                          <span>Upload from file</span>
                          <input type="file" name="myfile" accept="image/*" (change)="onFileChangeSingle($event, 'faqUploadImage')" />
                        </div>
                        <div class="imageLibrary" (click)="addFAQInlineImage()">
                          <span>Pick from Library</span>
                        </div>
                        </div>
                    </div>
                  </ng-container>
                  <!-- <div *ngIf="tempnewFAQData.get('faqArray')['controls'][i].get('mediaTypeValue').value === 'video'&&tempnewFAQData.get('faqArray')['controls'][i].get('mediaValue').value !== null" class="respVideo" [innerHtml]="tempnewFAQData.get('faqArray')['controls'][i].get('mediaValue').value.video.body | noSanitize">
                  </div> -->
                    <div *ngIf="tempnewFAQData.get('faqArray')['controls'][i].get('mediaTypeValue').value === 'video' &&
                    tempnewFAQData.get('faqArray')['controls'][i].get('mediaValue').value !== null"
                    class="respVideo">
                    <ng-container
                    *ngIf="tempnewFAQData.get('faqArray')['controls'][i].get('mediaValue').value.video.saranyuEmbedBody; else defaultContent">
                    <!-- Display saranyuEmbedBody when present -->
                    <div
                    [innerHtml]="tempnewFAQData.get('faqArray')['controls'][i].get('mediaValue').value.video.saranyuEmbedBody | noSanitize">
                    </div>
                    </ng-container>
                    <ng-template #defaultContent>
                    <!-- Display video.body when saranyuEmbedBody is not present -->
                    <div [innerHtml]="tempnewFAQData.get('faqArray')['controls'][i].get('mediaValue').value.video.body | noSanitize">
                    </div>
                    </ng-template>
                    </div>
                  <div #embedEl>
                  <div *ngIf="tempnewFAQData.get('faqArray')['controls'][i].get('mediaTypeValue').value === 'embed' && tempnewFAQData.get('faqArray')['controls'][i].get('mediaValue').value !== null" [innerHtml]="tempnewFAQData.get('faqArray')['controls'][i].get('mediaValue').value.embedCode | noSanitize">
                  </div> </div>
                  <div *ngIf="tempnewFAQData.get('faqArray')['controls'][i].get('mediaTypeValue').value === 'image' && tempnewFAQData.get('faqArray')['controls'][i].get('mediaValue').value !== null">
                    <img width="300px" src="{{tempnewFAQData.get('faqArray')['controls'][i].get('mediaValue').value.image.images.original}}">
                  </div>
                </ng-container>
            </ng-container>

          </div>
          </ng-container>
          <div #target>
          </div>
        </div>
      </form>

    </div>
    <div class="fr wid100 right padlr30 ptb15">
      <button type="button" tabindex="0" name="cancel" (click)="addNewFAQ(target)" class="cancel btnFaq">+ Add another list</button>
      <button type="button" tabindex="0" name="cancel" (click)="closeNewFAQPopup()" class="cancel gray ml10">Cancel</button>
      <button type="button" tabindex="0" name="unlock" class="add blue ml10 "
       (click)="updateNewFAQElement()">Done</button>
    </div>
  </div>
</div>

<div class="lightBox faqblock block" *ngIf="showLabelPopup">
  <div class="unlockStory">
    <div class="wid100">
      <h3 class="pad30">Add Label</h3>
        <li>
          <div class="headingBlock">
            <label>Add Label<span>(Max. 100 characters)</span></label>
            <div class="dataField">
              <textarea maxlength="100" [(ngModel)]="label" class="textBox"  placeholder="Enter label"
                tabindex="0" type="text"></textarea>
            </div>
          </div>
        </li>
    </div>
    <div class="fr wid100 right padlr30 ptb15">
      <button type="button" tabindex="0" name="cancel" (click)="closeLabelPopup()"
        class="cancel gray ml10">Cancel</button>
      <button type="button" tabindex="0" name="unlock" class="add blue ml10 " (click)="saveLabel()">Done</button>
    </div>
  </div>
</div>
<div class="lightBox faqblock block" *ngIf="showSeparatorPopup">
  <div class="unlockStory">
    <div class="wid100">
      <h3 class="pad30">Add Separator</h3>
        <li>
          <div class="headingBlock">
            <label>Add Height<span style="color: rgb(185, 50, 50);">(Only Numbers)</span></label>
            <div class="dataField">
              <textarea maxlength="100" [(ngModel)]="separator" class="textBoxSmall" placeholder="Enter Height"
                tabindex="0" (keypress)="numberOnly($event)"></textarea>
            </div>
          </div>
        </li>
    </div>
    <div class="fr wid100 right padlr30 ptb15">
      <button type="button" tabindex="0" name="cancel" (click)="closeSepartorPopup()"
        class="cancel gray ml10">Cancel</button>
      <button type="button" tabindex="0" name="unlock" class="add blue ml10 " (click)="saveSeparator()">Done</button>
    </div>
  </div>
</div>

<div class="lightBox listicle-element-popup block" *ngIf="showNewPollPopup" style="z-index: 10 !important;">
  <div class="unlockStory ">
    <div class="wid100">
      <h3 class="pad30">Add Poll</h3>
      <div class="custom_poll">
      <form [formGroup]="tempnewFAQData" class="formListicleCss" >
        <ul>
        <li>
          <div class="headingBlock">
          <label>Heading</label>
          <div class="dataField">
              <textarea appTextareaAutoresize class="textBoxSmall" formControlName="heading" placeholder="Enter the heading" tabindex="0" type="text"></textarea>
          </div>
          <div style="margin-top: 2%;">
            <span class="listicle-element">
              Bullet Type
            </span>
            <input type="radio" id="yes" name="fav_language" formControlName = "questionType" name="questionType" value="singleSelect" class="margin-left">
           <span class="listicle-element">Single select</span>
           <input type="radio" id="no" name="fav_language" formControlName = "questionType" name="questionType" value="multiSelect"  style="margin-left: 2%;">
           <span class="listicle-element">Multi select</span>
          </div>
        </div>
        </li>
        <li>
          <div class="headingBlock">
          <label>Question
          </label>
          <div class="dataField">
              <textarea appTextareaAutoresize class="textBoxSmall" formControlName="key" placeholder="Enter the Question" type="text"></textarea>
          </div>
        </div>
        </li>
        <li>
          <div class="headingBlock relativeContainer">
      <ng-container>
        <div class="">
        <label>Poll Question Media</label>
        <div *ngIf="tempnewFAQData === undefined || tempnewFAQData.get('mediaKey') == undefined || (tempnewFAQData.get('mediaKey').value === null)" >
          <i class="icon-image" style="color:#888888" (click)="addQuesFAQImage('',target)"></i>
          <i class="icon-video listicle-icon" (click)="showVideoGallery('pollMedia','')"></i>
          <!--i class="icon-embed listicle-icon" (click)="showQuesFAQEmbed(0)"></i-->
        </div>
      </div>
        <ng-container *ngIf="imageLoaderShow && tempnewFAQData.get('mediaKey').value === null">
          <div class="imagepreloader">
            <div class="a" style="--n: 5;top: 92%">
              <div class="dot dot1" style="--i: 0;"></div>
              <div class="dot dot2" style="--i: 1;"></div>
              <div class="dot dot3" style="--i: 2;"></div>
              <div class="dot dot4" style="--i: 3;"></div>
            </div>
          </div>
        </ng-container>
        <i class="icon-delete media-delete-icon" *ngIf="tempnewFAQData.get('mediaKey') != null && tempnewFAQData.get('mediaKey').value !== null" (click)="deleteNewQuesPollMedia()"></i>
        <ng-container *ngIf="enableQuesFAQImageOption && tempnewFAQData.get('mediaKey').value === null">
          <div class="dataField pad30">
            <div class="stepsDropBlock">
              <div class="imageInsert">
                <span>Upload from file</span>
                <input type="file" name="myfile" accept="image/*" (change)="onFileChangeSingle($event, 'quesPollUploadImage')" />
              </div>
              <div class="imageLibrary" (click)="addQuesPollInlineImage()">
                <span>Pick from Library</span>
              </div>
              </div>
          </div>
        </ng-container>
        <div *ngIf="tempnewFAQData.get('mediaKey') != null && tempnewFAQData.get('mediaTypeKey').value === 'video'&& tempnewFAQData.get('mediaKey').value !== null" class="respVideo" [innerHtml]="tempnewFAQData.get('mediaKey').value.video.body | noSanitize">
        </div>
        <!--div #embedEl>
        <div *ngIf="tempnewFAQData.get('mediaKey') != null && tempnewFAQData.get('mediaTypeKey').value === 'embed' && tempnewFAQData.get('mediaKey').value !== null" [innerHtml]="tempnewFAQData.get('mediaKey').value.embedCode | noSanitize">
        </div> </div-->
        <div *ngIf="tempnewFAQData.get('mediaKey') != null && tempnewFAQData.get('mediaTypeKey').value === 'image' && tempnewFAQData.get('mediaKey').value !== null">
          <img width="300px" src="{{tempnewFAQData.get('mediaKey').value.image.images.original}}">
        </div>
      </ng-container>
</div></li>
</ul>
        <div class="faqQueAnsw" style="overflow-y: none;">
          <ng-container formArrayName="ansArray"
              *ngFor="let faq of tempnewFAQData.get('ansArray').controls; let i = index;">
            <div class="listBlockQue">
              <i *ngIf="tempnewFAQData.get('ansArray').controls.length > 1" class="listElement icon-delete" (click)="deleteNewPollAns(i)"></i>
            <ng-container [formGroupName]="i">

                <li>
                  <div class="answer">
                  <label>Answer Content {{i+1}}
                  </label>
                  <div class="dataField">
                    <textarea appTextareaAutoresize class="textBoxSmall" formControlName="value" placeholder="Enter the Answer" type="text"></textarea>
                </div>
                </div>
                </li>
                <ng-container>
                  <label>Poll Answer Media {{i+1}}</label>
                  <div *ngIf="tempnewFAQData === undefined || (tempnewFAQData.get('ansArray')['controls'][i].get('mediaValue').value === null)" >
                    <i class="icon-image" style="color:#888888" (click)="addFAQImage(i,target)"></i>
                    <i class="icon-video listicle-icon" (click)="showVideoGallery('pollMedia',i)"></i>
                    <!--i class="icon-embed listicle-icon" (click)="showFAQEmbed(i)"></i-->
                  </div>
                  <ng-container *ngIf="imageLoaderShow && tempnewFAQData.get('ansArray')['controls'][i].get('mediaValue').value === null && i===videoIndex">
                    <div class="imagepreloader">
                      <div class="a" style="--n: 5;top: 92%">
                        <div class="dot dot1" style="--i: 0;"></div>
                        <div class="dot dot2" style="--i: 1;"></div>
                        <div class="dot dot3" style="--i: 2;"></div>
                        <div class="dot dot4" style="--i: 3;"></div>
                      </div>
                    </div>
                  </ng-container>
                  <i class="icon-delete media-delete-icon" *ngIf="tempnewFAQData.get('ansArray')['controls'][i].get('mediaValue').value !== null" (click)="deleteNewAnsPollMedia(i)"></i>
                  <ng-container *ngIf="enableFAQImageOption && tempnewFAQData.get('ansArray')['controls'][i].get('mediaValue').value === null && i===videoIndex">
                    <div class="dataField pad30">
                      <div class="stepsDropBlock">
                        <div class="imageInsert">
                          <span>Upload from file</span>
                          <input type="file" name="myfile" accept="image/*" (change)="onFileChangeSingle($event, 'ansPollUploadImage')" />
                        </div>
                        <div class="imageLibrary" (click)="addAnsPollInlineImage()">
                          <span>Pick from Library</span>
                        </div>
                        </div>
                    </div>
                  </ng-container>
                  <div *ngIf="tempnewFAQData.get('ansArray')['controls'][i].get('mediaTypeValue').value === 'video'&&tempnewFAQData.get('ansArray')['controls'][i].get('mediaValue').value !== null" class="respVideo" [innerHtml]="tempnewFAQData.get('ansArray')['controls'][i].get('mediaValue').value.video.body | noSanitize">
                  </div>
                  <!--div #embedEl>
                  <div *ngIf="tempnewFAQData.get('faqArray')['controls'][i].get('mediaTypeValue').value === 'embed' && tempnewFAQData.get('faqArray')['controls'][i].get('mediaValue').value !== null" [innerHtml]="tempnewFAQData.get('faqArray')['controls'][i].get('mediaValue').value.embedCode | noSanitize">
                  </div></div-->
                  <div *ngIf="tempnewFAQData.get('ansArray')['controls'][i].get('mediaTypeValue').value === 'image' && tempnewFAQData.get('ansArray')['controls'][i].get('mediaValue').value !== null">
                    <img width="300px" src="{{tempnewFAQData.get('ansArray')['controls'][i].get('mediaValue').value.image.images.original}}">
                  </div>
                </ng-container>
            </ng-container>

          </div>
          </ng-container>
          <div #target>
          </div>
        </div>
      </form>
    </div>
    </div>
    <div class="fr wid100 right padlr30 ptb15">
      <button type="button" tabindex="0" name="cancel" (click)="addNewPollAnswer(target)" class="cancel btnFaq">+ Add another answer</button>
      <button type="button" tabindex="0" name="cancel" (click)="closeNewPollPopup()" class="cancel gray ml10">Cancel</button>
      <button type="button" tabindex="0" name="unlock" class="add blue ml10 "
       (click)="updateNewPollElement()">Done</button>
    </div>
  </div>
</div>

<div class="lightBox stepblock block" *ngIf="showEmbedForFAQElement" style="z-index: 10 !important;">
  <div class="unlockStory">
    <div class="wid100 pad30">
      <h3>Add Embed for FAQ Answer</h3>
      <textarea type="text" id="inputAddEmbedUrl" class="textBox" [(ngModel)]="faqEmbedCode" placeholder="Enter for the Facebook, tweet, etc here…"
      tabindex="0"></textarea>
    </div>
    <div class="fr wid100 right padlr30 ptb15">
      <button type="button" tabindex="0" name="cancel" (click)="closeFAQEmbedPopup()" class="cancel gray ml10">Cancel</button>
      <button type="button" tabindex="0" name="unlock" (click)="saveFAQEmbedData()" class="add blue ml10 ">Add</button>
    </div>
  </div>
</div>

<div class="lightBox stepblock block" *ngIf="showEmbedForQuesFAQElement" style="z-index: 10 !important;">
  <div class="unlockStory">
    <div class="wid100 pad30">
      <h3>Add Embed for FAQ Question</h3>
      <textarea type="text" id="inputAddEmbedUrl" class="textBox" [(ngModel)]="quesFaqEmbedCode" placeholder="Enter for the Facebook, tweet, etc here…"
      tabindex="0"></textarea>
    </div>
    <div class="fr wid100 right padlr30 ptb15">
      <button type="button" tabindex="0" name="cancel" (click)="closeFAQEmbedPopup()" class="cancel gray ml10">Cancel</button>
      <button type="button" tabindex="0" name="unlock" (click)="saveQuesFAQEmbedData()" class="add blue ml10 ">Add</button>
    </div>
  </div>
</div>

<div class="lightBox stepblock block" *ngIf="showEmbedForListcleElement" style="z-index: 10 !important;">
  <div class="unlockStory">
    <div class="wid100 pad30">
      <h3>Add Embed</h3>
      <textarea type="text" id="inputAddEmbedUrl" class="textBox" [(ngModel)]="listicleEmbedCode" placeholder="Enter for the Facebook, tweet, etc here…"
      tabindex="0"></textarea>
    </div>
    <div class="fr wid100 right padlr30 ptb15">
      <button type="button" tabindex="0" name="cancel" (click)="closeListicleEmbedPopup()" class="cancel gray ml10">Cancel</button>
      <button type="button" tabindex="0" name="unlock" (click)="saveEmbedData()" class="add blue ml10 ">Add</button>
    </div>
  </div>
</div>

<div class="lightBox stepblock block" *ngIf="showStepPopup" style="z-index: 10 !important;">
  <div class="unlockStory">
    <div class="wid100">
      <h3 class="pad30">Update How-to Steps</h3><span class="shortCutsKeyPopup">(<i>Press cmd+k/ctrl+k for hyperlink</i>)</span>
      <form [formGroup]="tempHowToStepsData">
        <div class="stepScroll">
          <li>
            <div class="">
            <label>Heading</label>
            <div class="dataField">
                <textarea class="textBoxSmall" formControlName="heading" placeholder="Enter the heading" tabindex="0" type="text"></textarea>
                <span class="requiredField" *ngIf="tempHowToStepsData.get('heading').touched && !tempHowToStepsData.get('heading').valid &&
                tempHowToStepsData.get('heading').errors?.required">Heading is required</span>
            </div>
          </div>
          </li>
          <li>
            <div class="">
            <label>Time to complete</label>
            <div class="dataField">
              <textarea maxlength="2" class="textBoxSmall" style="width: 48%; float: left;" formControlName="timeToCompleteinHrs" placeholder="Hours" tabindex="0" type="text" (keydown)="validateKeyPressForNumberOnlyField($event)" (keyup)="validateMaxPositionValue($event)"></textarea>
              <span class="requiredField" *ngIf="tempHowToStepsData.get('timeToCompleteinHrs').touched && !tempHowToStepsData.get('timeToCompleteinHrs').valid &&
              tempHowToStepsData.get('timeToCompleteinHrs').errors?.required">Time is required</span>
              <textarea maxlength="2" class="textBoxSmall" style="width: 48%; float: right;" formControlName="timeToComplete" placeholder="Minutes" tabindex="0" type="text" (keydown)="validateKeyPressForNumberOnlyField($event)" (keyup)="validateMaxPositionValueMin($event)"></textarea>
              <span class="requiredField" *ngIf="tempHowToStepsData.get('timeToComplete').touched && !tempHowToStepsData.get('timeToComplete').valid &&
              tempHowToStepsData.get('timeToComplete').errors?.required">Time is required</span>
            </div>
          </div>
          </li>
          <li>
            <div class="">
            <label>Supplies<span>(Use comma to add multiple items)</span></label>
            <div class="dataField">
              <tags-creator [data]="tempHowToStepsData.get('supplies').value" [editable]="false" [displayText]="'Add supplies here'"
                    (clickfn)="customFunc($event)" (changefn)="suppliesChangeFunc($event)" (focusedfn)="catchTagFocus($event)"
                    [storyTags]="true" [marketSuggest]="false" [supplyTags]="true"></tags-creator>
            </div>
          </div>
          </li>
          <li>
            <div class="">
            <label>Tools<span>(Use comma to add multiple items)</span></label>
            <div class="dataField">
              <tags-creator [data]="tempHowToStepsData.get('tools').value" [editable]="false" [displayText]="'Add tools here..'"
                (clickfn)="customFunc($event)" (changefn)="toolsChangeFunc($event)" (focusedfn)="catchTagFocus($event)"
                [storyTags]="true" [marketSuggest]="false" [toolTags]="true"></tags-creator>
            </div>
          </div>
          </li>
          <ng-container formArrayName="steps"
            *ngFor="let step of tempHowToStepsData.get('steps').controls; let i = index;">
            <div class="howStepImageBlock">
            <i *ngIf="tempHowToStepsData.get('steps').controls.length > 1" class="icon-delete" (click)="deleteStep(i)"></i>
            <ng-container [formGroupName]="i">
              <div class="stepBlock">
                <li>
                  <div class="">
                  <label>Step {{i+1}}</label>
                  <div class="dataField">
                    <ckeditor [editor]="ckEditor" class="textBoxSmall" formControlName="step" placeholder="Enter step" tabindex="0" type="text"  (ready)="ckchanges($event, 'ready', 'step','step')"
                    (change)="ckchanges($event, 'change', 'step','step',i)"></ckeditor>
                    <span class="requiredField" *ngIf="tempHowToStepsData.get('steps')['controls'][i].get('step').touched && !tempHowToStepsData.get('steps')['controls'][i].get('step').valid &&
                    tempHowToStepsData.get('steps')['controls'][i].get('step').errors?.required">Step information is required</span>
                  </div>
                </div>
                </li>
                <li>
                  <div class="">
                    <ng-container *ngIf="tempHowToStepsData.get('steps')['controls'][i].get('stepImage').value == null || tempHowToStepsData.get('steps')['controls'][i].get('stepImage').value == ''">
                      <label>Upload Step {{i+1}} Image</label>
                      <div class="dataField">
                        <div class="stepsDropBlock">
                          <div class="imageInsert" (click)="updateCurrentHowToStep(i)">
                            <span>Upload from file</span>
                            <input type="file" name="myfile" accept="image/*" (change)="onFileChangeSingle($event, 'howToStepsImage')" />
                          </div>
                          <div class="imageLibrary" (click)="addStepsInlineImage(i, 'howToSteps')">
                            <span>Pick from Library</span>
                          </div>
                          </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="tempHowToStepsData.get('steps')['controls'][i].get('stepImage').value != null && tempHowToStepsData.get('steps')['controls'][i].get('stepImage').value != ''">
                      <label>Upload Step {{i+1}} Image</label>
                      <div class="dataField">
                        <div class="stepsDropBlock imageNameView">
                      {{getImageNameFromUrl(tempHowToStepsData.get('steps')['controls'][i].get('stepImage').value.images)}}
                      <span (click)="removeStepImage(i, 'howToSteps')" style="cursor: pointer;">( Remove Image )</span>
                      </div>
                      </div>
                    </ng-container>
                </div>
                </li>
              </div>
            </ng-container>
          </div>
          </ng-container>

        </div>
      </form>
    </div>
    <div class="fr wid100 right padlr30 ptb15">
      <button type="button" tabindex="0" name="cancel" (click)="addStep()" class="cancel btnFaq">+ Add steps</button>
      <button type="button" tabindex="0" name="cancel" (click)="closeStepPopup()" class="cancel gray ml10">Cancel</button>
      <button type="button" tabindex="0" name="unlock" (click)="updateHowToSteps()" class="add blue ml10 ">Done</button>
    </div>
  </div>
</div>

<div [class]="showPodcastPopup ? 'lightBox photogallerylist inlineImage block' : 'lightBox'">
  <div class="headerLight">
    <div class="close fl spImg" (click)="closePodcastPopup()"></div>
  </div>
  <div class="podcast-listing" (sendPodcastToParentfn)="getPodcastCardDetails($event)" *ngIf="showPodcastPopup"></div>
</div>

<div class="lightBox stepblock block" *ngIf="showRecipePopup" style="z-index: 10 !important;">
  <div class="unlockStory">
    <div class="wid100">
      <h3 class="pad30">Update Recipe</h3>
      <form [formGroup]="tempRecipeData">
        <div class="stepScroll">
          <li>
            <div class="">
            <label>Recipe Name</label>
            <div class="dataField">
                <textarea class="textBoxSmall" formControlName="recipeName" placeholder="Enter the Recipe Name" tabindex="0" type="text"></textarea>
                <span class="requiredField" *ngIf="tempRecipeData.get('recipeName').touched && !tempRecipeData.get('recipeName').valid &&
                tempRecipeData.get('recipeName').errors?.required">Recipe Name is required</span>
            </div>
          </div>
          </li>
          <li>
            <div class="">
            <label>Description</label>
            <div class="dataField">
                <textarea rows="4" class="textArea" formControlName="description" placeholder="Enter the Description" tabindex="0" type="text"></textarea>
            </div>
          </div>
          </li>
          <li>
            <div class="">
            <label>Recipe Yield</label>
            <div class="dataField">
                <textarea class="textBoxSmall" formControlName="recipeYield" placeholder="Enter the Recipe Yield" tabindex="0" type="text"></textarea>
            </div>
          </div>
          </li>
          <li>
            <div class="">
            <label>Preparation Time</label>
            <div class="dataField">
              <textarea maxlength="2" class="textBoxSmall" style="width: 48%; float: left;" formControlName="preparationTimeHr" placeholder="Hours" tabindex="0" type="text" (keydown)="validateKeyPressForNumberOnlyField($event)" (keyup)="validateMaxPositionValue($event)"></textarea>
              <span class="requiredField" *ngIf="tempRecipeData.get('preparationTimeHr').touched && !tempRecipeData.get('preparationTimeHr').valid &&
              tempRecipeData.get('preparationTimeHr').errors?.required">Time is required</span>
              <textarea maxlength="2" class="textBoxSmall" style="width: 48%; float: right;" formControlName="preparationTimeMinute" placeholder="Minutes" tabindex="0" type="text" (keydown)="validateKeyPressForNumberOnlyField($event)" (keyup)="validateMaxPositionValue($event)"></textarea>
              <span class="requiredField" *ngIf="tempRecipeData.get('preparationTimeMinute').touched && !tempRecipeData.get('preparationTimeMinute').valid &&
              tempRecipeData.get('preparationTimeMinute').errors?.required">Time is required</span>
            </div>
            </div>
          </li>
          <li>
            <div class="">
            <label>Cooking Time</label>
            <div class="dataField">
              <textarea maxlength="2" class="textBoxSmall" style="width: 48%; float: left;" formControlName="cookingTimeHr" placeholder="Hours" tabindex="0" type="text" (keydown)="validateKeyPressForNumberOnlyField($event)" (keyup)="validateMaxPositionValue($event)"></textarea>
              <span class="requiredField" *ngIf="tempRecipeData.get('cookingTimeHr').touched && !tempRecipeData.get('cookingTimeHr').valid &&
              tempRecipeData.get('cookingTimeHr').errors?.required">Time is required</span>
              <textarea maxlength="2" class="textBoxSmall" style="width: 48%; float: right;" formControlName="cookingTimeMinute" placeholder="Minutes" tabindex="0" type="text" (keydown)="validateKeyPressForNumberOnlyField($event)" (keyup)="validateMaxPositionValue($event)"></textarea>
              <span class="requiredField" *ngIf="tempRecipeData.get('cookingTimeMinute').touched && !tempRecipeData.get('cookingTimeMinute').valid &&
              tempRecipeData.get('cookingTimeMinute').errors?.required">Time is required</span>
            </div>
            </div>
          </li>
          <li>
            <div class="">
            <label>Total Time</label>
            <div class="dataField">
              <textarea maxlength="2" class="textBoxSmall" style="width: 48%; float: left;" formControlName="totalTimeHr" placeholder="Hours" tabindex="0" type="text" (keydown)="validateKeyPressForNumberOnlyField($event)" (keyup)="validateMaxPositionValue($event)"></textarea>
              <span class="requiredField" *ngIf="tempRecipeData.get('totalTimeHr').touched && !tempRecipeData.get('totalTimeHr').valid &&
              tempRecipeData.get('totalTimeHr').errors?.required">Time is required</span>
              <textarea maxlength="2" class="textBoxSmall" style="width: 48%; float: right;" formControlName="totalTimeMinute" placeholder="Minutes" tabindex="0" type="text" (keydown)="validateKeyPressForNumberOnlyField($event)" (keyup)="validateMaxPositionValue($event)"></textarea>
              <span class="requiredField" *ngIf="tempRecipeData.get('totalTimeMinute').touched && !tempRecipeData.get('totalTimeMinute').valid &&
              tempRecipeData.get('totalTimeMinute').errors?.required">Time is required</span>
            </div>
            </div>
          </li>
          <li>
            <div class="">
            <label>Ingredients<span>(Use comma to add multiple items)</span></label>
            <div class="dataField">
              <tags-creator [data]="tempRecipeData.get('ingredients').value" [editable]="false" [displayText]="'Add ingredients here'"
                  (clickfn)="customFunc($event)" (changefn)="ingredientsChangeFunc($event)"
                   [marketSuggest]="false" ></tags-creator>
            </div>
          </div>
          </li>
          <li>
            <div class="">
            <label>Recipe Cuisine</label>
            <div class="dataField">
                <textarea class="textBoxSmall" formControlName="recipeCuisine" placeholder="Enter the Recipe Cuisine" tabindex="0" type="text"></textarea>
            </div>
          </div>
          </li>
          <li>
            <div class="">
            <label>Recipe Category</label>
            <div class="dataField">
                <textarea class="textBoxSmall" formControlName="recipeCategory" placeholder="Enter the Recipe Category" tabindex="0" type="text"></textarea>
            </div>
          </div>
          </li>
          <li>
            <div class="">
            <label>keywords<span>(Use comma to add multiple items)</span></label>
            <div class="dataField">
              <tags-creator [data]="tempRecipeData.get('keywords').value" [editable]="false" [displayText]="'Add keywords here..'"
              (clickfn)="customFunc($event)" (changefn)="keywordsChangeFunc($event)"
              [storyTags]="true" [marketSuggest]="false" [toolTags]="true"></tags-creator>
            </div>
          </div>
          </li>
          <ng-container formArrayName="steps"
            *ngFor="let step of tempRecipeData.get('steps').controls; let i = index;">
            <div class="howStepImageBlock">
            <i *ngIf="tempRecipeData.get('steps').controls.length > 1" class="icon-delete test" (click)="deleteRecipeStep(i)"></i>
            <ng-container [formGroupName]="i">
              <div class="stepBlock">
                <li>
                  <div class="">
                  <label>Step {{i+1}}</label>
                  <div class="dataField">
                    <ckeditor [editor]="Editor" class="textBoxSmall" formControlName="step" placeholder="Enter step" tabindex="0" type="text"  (ready)="ckchanges($event, 'ready', 'recipe', 'recipe')"
                    (change)="ckchanges($event, 'change', 'recipe','recipe',i)"></ckeditor>
                    <span class="requiredField" *ngIf="tempRecipeData.get('steps')['controls'][i].get('step').touched && !tempRecipeData.get('steps')['controls'][i].get('step').valid &&
                    tempRecipeData.get('steps')['controls'][i].get('step').errors?.required">Step information is required</span>
                  </div>
                </div>
                </li>
                <li>
                  <div class="">
                    <ng-container *ngIf="tempRecipeData.get('steps')['controls'][i].get('stepImage').value == null || tempRecipeData.get('steps')['controls'][i].get('stepImage').value == ''">
                      <label>Upload Step {{i+1}} Image</label>
                      <div class="dataField">
                        <div class="stepsDropBlock">
                          <div class="imageInsert" (click)="updateCurrentHowToStep(i)">
                            <span>Upload from file</span>
                            <input type="file" name="myfile" accept="image/*" (change)="onFileChangeSingle($event, 'recipeImage')" />
                          </div>
                          <div class="imageLibrary" (click)="addStepsInlineImage(i, 'recipe')">
                            <span>Pick from Library</span>
                          </div>
                          </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="tempRecipeData.get('steps')['controls'][i].get('stepImage').value != null && tempRecipeData.get('steps')['controls'][i].get('stepImage').value != ''">
                      <label>Upload Step {{i+1}} Image</label>
                      <div class="dataField">
                        <div class="stepsDropBlock imageNameView">
                      {{getImageNameFromUrl(tempRecipeData.get('steps')['controls'][i].get('stepImage').value.images)}}

                      <span (click)="removeStepImage(i, 'recipe')" style="cursor: pointer;">( Remove Image )</span>
                    </div>
                    </div>
                    </ng-container>
                </div>
                </li>
              </div>
            </ng-container>
          </div>
          </ng-container>
        </div>
      </form>
    </div>
    <div class="fr wid100 right padlr30 ptb15">
      <button type="button" tabindex="0" name="cancel" (click)="addRecipeStep()" class="cancel btnFaq">+ Add steps</button>
      <button type="button" tabindex="0" name="cancel" (click)="closeRecipePopup()" class="cancel gray ml10">Cancel</button>
      <button type="button" tabindex="0" name="unlock" (click)="updateRecipe()" class="add blue ml10 ">Done</button>
    </div>
  </div>
</div>

<div class="lightBox embeddblock block" *ngIf="marketPopup">
  <div class="unlockStory">
    <div class="wid100 pad30">
      <h3>Add Market</h3>
      <ng-container *ngIf="showMutualFunds !== 'true'">
        <label class="toggleName">Company/Index Name</label>
        <div class="selectBoxCompany">
          <select [(ngModel)]="marketCode" (change)="getSelectedOptionText($event)">
            <option [value]="42">TELCOM</option>
            <option [value]="15">AUTO</option>
            <option [value]="73">SML250</option>
            <option [value]="21">REALTY</option>
            <option [value]="11">TECK</option>
            <option [value]="19">SMLCAP</option>
            <option [value]="8">BSE CD</option>
            <option [value]="62">MIDSEL</option>
            <option [value]="75">MSL400</option>
            <option [value]="72">MID150</option>
            <option [value]="18">MIDCAP</option>
            <option [value]="40">INDSTR</option>
            <option [value]="9">BSE HC</option>
            <option [value]="5">BSE IT</option>
            <option [value]="17">OILGAS</option>
            <option [value]="36">CDGS</option>
            <option [value]="35">BASMTR</option>
            <option [value]="68">SNXT50</option>
            <option [value]="60">MFG</option>
            <option [value]="61">SMLSEL</option>
            <option [value]="24">SHA50</option>
            <option [value]="46">ALLCAP</option>
            <option [value]="4">BSE500</option>
            <option [value]="23">BSEIPO</option>
            <option [value]="41">ENERGY</option>
            <option [value]="70">ESG100</option>
            <option [value]="74">LMI250</option>
            <option [value]="3">BSE200</option>
            <option [value]="2">BSE100</option>
            <option [value]="12">BSEPSU</option>
            <option [value]="45">LRGCAP</option>
            <option [value]="67">SNSX50</option>
            <option [value]="1">SENSEX</option>
            <option [value]="10">DOL200</option>
            <option [value]="30">CPSE</option>
            <option [value]="7">BSE CG</option>
            <option [value]="20">DOL100</option>
            <option [value]="6">BSEFMC</option>
            <option [value]="14">BANKEX</option>
            <option [value]="13">DOL30</option>
            <option [value]="69">BHRT22</option>
            <option [value]="27">SMEIPO</option>
            <option [value]="37">FIN</option>
            <option [value]="16">METAL</option>
            <option [value]="43">UTILS</option>
            <option [value]="22">POWER</option>
            <option [value]="151">NIFTYMEDIA</option>
            <option [value]="159">LIQ15</option>
            <option [value]="148">NIFTYAUTO</option>
            <option [value]="142">NIFTYREALTY</option>
            <option [value]="144">INDIA VIX</option>
            <option [value]="177">NIFTYSMALLCAP250</option>
            <option [value]="156">NIFTYALPHA</option>
            <option [value]="145">NIFTYSMALL</option>
            <option [value]="179">NIFTYSMALLCAP50</option>
            <option [value]="181">NIFTYMIDSMALL400</option>
            <option [value]="136">NIFTYMNC</option>
            <option [value]="176">NIFTYMIDCAP150</option>
            <option [value]="139">NIFTYPHARMA</option>
            <option [value]="130">MIDCAP50</option>
            <option [value]="182">NIFTY100WEIGHT</option>
            <option [value]="124">NIFTYIT</option>
            <option [value]="128">NIFTYMIDCAP</option>
            <option [value]="125">NIFTYJR</option>
            <option [value]="147">NIFTYCONSUMP</option>
            <option [value]="141">NIFTYINFRAST</option>
            <option [value]="190">NIFTY 11-15 YR GSEC</option>
            <option [value]="186">NIFTY8-13 YR GSEC</option>
            <option [value]="170">NIFTYTR1X</option>
            <option [value]="171">NIFTYPR1X</option>
            <option [value]="167">NSEQ30</option>
            <option [value]="208">NIFTYGSCOMP</option>
            <option [value]="187">NIFTY 10 YR BMGSEC</option>
            <option [value]="188">NIFTY 10YRBMSECCP</option>
            <option [value]="189">NIFTY 4-8 YR GESC</option>
            <option [value]="175">NIFTYPTBNK</option>
            <option [value]="165">LIX 15 MIDCAP</option>
            <option [value]="129">NIFTY500</option>
            <option [value]="126">NIFTYDEFTY</option>
            <option [value]="155">NIFTYDIV</option>
            <option [value]="206">NIFTY200QLTY30</option>
            <option [value]="150">NIFTY200</option>
            <option [value]="127">BANKNIFTY</option>
            <option [value]="137">NIFTYSERVICE</option>
            <option [value]="131">NIFTY100</option>
            <option [value]="192">NIFTY15YRABOVEGSEC</option>
            <option [value]="123">NIFTY</option>
            <option [value]="152">NIFTYCDTY</option>
            <option [value]="138">NIFTYENERGY</option>
            <option [value]="143">NIFTYPSUBANK</option>
            <option [value]="168">NIFTYTR2X</option>
            <option [value]="169">NIFTYPR2X</option>
            <option [value]="166">NV20</option>
            <option [value]="146">NIFTYPSE</option>
            <option [value]="134">NIFTYFMCG</option>
            <option [value]="164">NI15</option>
            <option [value]="154">NIFTYDIVOPPT</option>
            <option [value]="153">NIFTYFINANCE</option>
            <option [value]="162">NIFTYCPSE</option>
            <option [value]="149">NIFTYMETAL</option>
            <option [value]="132921">Adani Ports and Special Economic Zone Ltd.</option>
            <option [value]="100820">Asian Paints Ltd.</option>
            <option [value]="132215">Axis Bank Ltd.</option>
            <option [value]="200132">Bajaj Auto Ltd.</option>
            <option [value]="100034">Bajaj Finance Ltd.</option>
            <option [value]="205198">Bajaj Finserv Ltd.</option>
            <option [value]="132454">Bharti Airtel Ltd.</option>
            <option [value]="209967">Bharti Infratel Ltd.</option>
            <option [value]="100547">Bharat Petroleum Corporation Ltd.</option>
            <option [value]="100825">Britannia Industries Ltd.</option>
            <option [value]="100087">Cipla Ltd.</option>
            <option [value]="219300">Coal India Ltd.</option>
            <option [value]="100124">Dr. Reddys Laboratories Ltd.</option>
            <option [value]="105200">Eicher Motors Ltd.</option>
            <option [value]="132155">GAIL (India) Ltd.</option>
            <option [value]="100300">Grasim Industries Ltd.</option>
            <option [value]="132281">HCL Technologies Ltd.</option>
            <option [value]="100010">Housing Development Finance Corporation Ltd.</option>
            <option [value]="100180">HDFC Bank Ltd.</option>
            <option [value]="100182">Hero MotoCorp Ltd.</option>
            <option [value]="100440">Hindalco Industries Ltd.</option>
            <option [value]="100696">Hindustan Unilever Ltd.</option>
            <option [value]="132174">ICICI Bank Ltd.</option>
            <option [value]="130965">Indian Oil Corporation Ltd.</option>
            <option [value]="132187">IndusInd Bank Ltd.</option>
            <option [value]="100209">Infosys Ltd.</option>
            <option [value]="100875">ITC Ltd.</option>
            <option [value]="100228">JSW Steel Ltd.</option>
            <option [value]="100247">Kotak Mahindra Bank Ltd.</option>
            <option [value]="100510">Larsen & Toubro Ltd.</option>
            <option [value]="100520">Mahindra & Mahindra Ltd.</option>
            <option [value]="132500">Maruti Suzuki India Ltd.</option>
            <option [value]="100790">Nestle India Ltd.</option>
            <option [value]="132555">NTPC Ltd.</option>
            <option [value]="100312">Oil & Natural Gas Corporation Ltd.</option>
            <option [value]="132898">Power Grid Corporation Of India Ltd.</option>
            <option [value]="100325">Reliance Industries Ltd.</option>
            <option [value]="100112">State Bank Of India</option>
            <option [value]="100387">Shree Cement Ltd.</option>
            <option [value]="124715">Sun Pharmaceutical Industries Ltd.</option>
            <option [value]="100570">Tata Motors Ltd.</option>
            <option [value]="100470">Tata Steel Ltd.</option>
            <option [value]="293521">Tata Steel Ltd. - (TATASTEELPP)</option>
            <option [value]="132540">Tata Consultancy Services Ltd.</option>
            <option [value]="132755">Tech Mahindra Ltd.</option>
            <option [value]="100114">Titan Company Ltd.</option>
            <option [value]="132538">Ultratech Cement Ltd.</option>
            <option [value]="112070">UPL Ltd.</option>
            <option [value]="100295">Vedanta Ltd.</option>
            <option [value]="107685">Wipro Ltd.</option>
            <option [value]="105537">Zee Entertainment Enterprises Ltd.</option>
          </select>
        </div>
      </ng-container>
      <ng-container *ngIf="showMutualFunds === 'true'">
        <label class="toggleName">Company/Index Name</label>
        <tags-creator [textEdit]="deactivateMarketSuggestion" [autoSuggest]="true" [autocompletelist]="getMarketSuggestion()"
          [data]="marketList"
          [displayText]="'Enter Index / Company\'s Names...'" (clickfn)="customFunc($event)" (changefn)="setMarketIndex($event)"
           [isDataKeyValuePair]="true" [isMarket]="true"></tags-creator>
        <label class="toggleName">Mutual Fund Names</label>
          <tags-creator [textEdit]="deactivateMarketSuggestion" [autoSuggest]="true" [autocompletelist]="getMFSuggestion()"
          [data]="mutualFundList"
          [displayText]="'Enter Mutual Fund Names...'" (clickfn)="customFunc($event)" (changefn)="setMutualFunds($event)"
           [isDataKeyValuePair]="true" [isMarket]="true"></tags-creator>
        <label class="toggleName">NEW - Company/Index Name</label>
           <tags-creator [textEdit]="deactivateNewMarketSuggestion" [autoSuggest]="true" [autocompletelist]="getNewMarketSuggestion()"
          [data]="newMarketList"
           [displayText]="'Enter NEW - Index / Company\'s Names...'" (clickfn)="customFunc($event)" (changefn)="setNewMarket($event)"
           [isDataKeyValuePair]="true" [isMarket]="true" [searchByCode]="true"></tags-creator>
      </ng-container>
    </div>
    <div class="fr wid100 right padlr30 ptb15">
      <button type="button" tabindex="0" name="cancel" (click)="closeMarketPopup()"
        class="cancel gray ml10">Cancel</button>
      <ng-container *ngIf="newMarketPopup === false">
      <button type="button" tabindex="0" name="unlock" (click)="saveMarketEmbed()"
        class="add blue ml10 ">Done</button>
      </ng-container>
      <ng-container *ngIf="newMarketPopup === true">
        <button type="button" tabindex="0" name="unlock" (click)="newLiveBlogMarketEmbed()"
          class="add blue ml10 ">Add</button>
        </ng-container>
    </div>
  </div>
</div>
<div class="lightBox embeddblock block" *ngIf="listicleProductPopup">
  <div class="unlockStory">
    <div class="wid100 pad30">
      <h3>Add Product</h3>
        <!-- Brands -->
        <label class="toggleName">Brands</label>
        <div class="selectBoxCompany">
          <select [(ngModel)]="listcleBrand" (change)="getListcleModelList($event)">
           <option disabled>Choose One Brand</option>
           <option [value]="brandList" *ngFor="let brandList of listicleProductBrandList">{{brandList}}</option>
          </select>
        </div>
        <!-- Models -->
        <label class="toggleName">Models</label>
        <div class="selectBoxCompany">
          <select [(ngModel)]="listcleModel">
            <option disabled>Choose One Model</option>
            <option [value]="modelList" *ngFor="let modelList of listicleModelList">{{modelList}}</option>

          </select>
        </div>
    </div>
    <div class="fr wid100 right padlr30 ptb15">
      <button type="button" tabindex="0" name="cancel" (click)="closeMarketPopup()"
        class="cancel gray ml10">Cancel</button>
      <ng-container >
      <button type="button" tabindex="0" name="unlock" (click)="saveListcleProduct()"
        class="add blue ml10 ">Add</button>
      </ng-container>
    </div>
    <div class="imagepreloader" *ngIf="loaded">
      <div class="a" style="--n: 5;">
        <div class="dot dot1" style="--i: 0;"></div>
        <div class="dot dot2" style="--i: 1;"></div>
        <div class="dot dot3" style="--i: 2;"></div>
        <div class="dot dot4" style="--i: 3;"></div>
      </div>
    </div>
  </div>
</div>


<div class="lightBox embeddblock block" *ngIf="matchPopupLiveBLog">
  <app-match-component (sendPopupValueToParentfn)="getPopupValueToParentfn($event)"
  (sendMatchDetailsToParentfn) = createMatchCardLiveBlog($event) ></app-match-component>
</div>

<div class="lightBox embeddblock addProductEle block" *ngIf="showCategoryProductPopup">
  <div class="unlockStory">
    <div class="wid100 pad30">
      <h3>Edit Category & Product Element</h3>
        <label class="toggleName">Category</label>
        <div class="dataField">
          <input #categoryEleInput type="text" class="textBox" #brandInput  placeholder="Add Category here."
            [(ngModel)]="categoryEleQuery" (keyup)="filterAutoCompleteUp($event ,'categoryEle')"
             (focus)="focusInSuggest('categoryEle')" (focusout)="false">
            <ng-container>
              <div #brandList class="autosuggestion block"
                *ngIf="filteredCategorySuggestion && filteredCategorySuggestion.length > 0 && insideCategoryEle">
                <ul *ngFor="let item of filteredCategorySuggestion;let i = index">
                  <li (click)="selectAutoComplete('categoryEle', item)" [class.active]="i === currentSelection">
                    <span class="name">{{item.categoryName}}</span>
                  </li>
                </ul>
              </div>
            <ng-container *ngIf="insideCategoryEle && filteredCategorySuggestion && (1 > filteredCategorySuggestion.length)">
              <div class="autosuggestion block">
                <ul>
                  <li>
                    <span class="name">No Results</span>
                  </li>
                </ul>
              </div>
            </ng-container>
            </ng-container>
          </div>

          <label class="toggleName">Brand</label>
          <div class="dataField">
            <input #brandEleInput type="text" class="textBox"  placeholder="Add Brand here."
              [(ngModel)]="brandEleQuery" (keyup)="filterAutoCompleteUp($event ,'brandEle')"
              (focus)="focusInSuggest('brandEle')" (focusout)="false">
              <ng-container>
                <div class="autosuggestion block"
                  *ngIf="filteredBrandSuggestion && filteredBrandSuggestion.length > 0 && insideBrandEle">
                  <ul *ngFor="let item of filteredBrandSuggestion;let i = index">
                    <li (click)="selectAutoComplete('brandEle', item)" [class.active]="i === currentSelection">
                      <span (click)="selectAutoComplete('brandEle', item)" class="name">{{item}}</span>
                    </li>
                  </ul>
                </div>
              <ng-container *ngIf="insideBrandEle && filteredBrandSuggestion && (1 > filteredBrandSuggestion.length)">
                <div class="autosuggestion block">
                  <ul>
                    <li>
                      <span class="name">No Results</span>
                    </li>
                  </ul>
                </div>
              </ng-container>
              </ng-container>
            </div>

        <label class="toggleName">Model</label>
        <li [class]="setCheckForErrorIndication(22) ? 'errorInput' : ''">
          <div class="dataField">
            <input type="text" class="textBox" #modelEleInput
              placeholder="Add Model here." [(ngModel)]="modelEleQuery" (keyup)="filterAutoCompleteUp($event ,'modelCategoryEle')"
              (focus)="focusInSuggest('modelEle')" (focusout)="false">
            <ng-container >
              <div class="autosuggestion block"
                *ngIf="filteredModelSuggestion && filteredModelSuggestion.length > 0 && insideModelEle">
                <ul *ngFor="let item of filteredModelSuggestion; let i = index">
                  <li (click)="selectAutoComplete('modelEle', item)" [class.active]="i === currentSelection">
                    <span class="name">{{item}}</span>
                  </li>
                </ul>
              </div>
              <ng-container *ngIf="insideModelEle && filteredModelSuggestion && (1 > filteredModelSuggestion.length)">
                <div class="autosuggestion block">
                  <ul>
                    <li><span class="name">No Results</span></li>
                  </ul>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </li>
    </div>
    <div class="fr wid100 right padlr30 ptb15">
      <button type="button" tabindex="0" name="cancel" (click)="closeProductPopup()"
        class="cancel gray ml10">Cancel</button>
      <button type="button" tabindex="0" name="unlock" (click)="saveCategoryProductElement()"
        class="add blue ml10" id="buttonSubmitForMarket">Save</button>
    </div>
  </div>
</div>

<div class="lightBox embeddblock addProductEle block" *ngIf="showProductPopup">
  <div class="unlockStory">
    <div class="wid100 pad30">
      <h3>Edit Product Element</h3>
          <label class="toggleName">Brand</label>
          <div class="dataField">
            <input #brandEleInput type="text" class="textBox"  placeholder="Add Brand here."
              [(ngModel)]="brandEleQuery" (keyup)="filterAutoCompleteUp($event ,'brandEle')"
               (focus)="focusInSuggest('brandEle')" (focusout)="false">
              <ng-container >
                <div class="autosuggestion block"
                  *ngIf="filteredBrandSuggestion && filteredBrandSuggestion.length > 0 && insideBrandEle">
                  <ul *ngFor="let item of filteredBrandSuggestion;let i = index">
                    <li (click)="selectAutoComplete('brandEle', item)" [class.active]="i === currentSelection">
                      <span (click)="selectAutoComplete('brandEle', item)" class="name">{{item}}</span>
                    </li>
                  </ul>
                </div>
              <ng-container *ngIf="insideBrandEle && filteredBrandSuggestion && (1 > filteredBrandSuggestion.length)">
                <div class="autosuggestion block">
                  <ul>
                    <li>
                      <span class="name">No Results</span>
                    </li>
                  </ul>
                </div>
              </ng-container>
              </ng-container>
          </div>

        <label class="toggleName">Model</label>
        <li [class]="setCheckForErrorIndication(22) ? 'errorInput' : ''">
          <div class="dataField">
            <input type="text" class="textBox" #modelEleInput
              placeholder="Add Model here." [(ngModel)]="modelEleQuery" (keyup)="filterAutoCompleteUp($event ,'modelEle')"
              (focus)="focusInSuggest('modelEle')" (focusout)="false">
            <ng-container>
              <div class="autosuggestion block"
                *ngIf="filteredModelSuggestion && filteredModelSuggestion.length > 0 && insideModelEle">
                <ul *ngFor="let item of filteredModelSuggestion; let i = index">
                  <li (click)="selectAutoComplete('modelEle', item)" [class.active]="i === currentSelection">
                    <span class="name">{{item}}</span>
                  </li>
                </ul>
              </div>
              <ng-container *ngIf="insideModelEle && filteredModelSuggestion && (1 > filteredModelSuggestion.length)">
                <div class="autosuggestion block">
                  <ul>
                    <li><span class="name">No Results</span></li>
                  </ul>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </li>
    </div>
    <div class="fr wid100 right padlr30 ptb15">
      <button type="button" tabindex="0" name="cancel" (click)="closeProductPopup()"
        class="cancel gray ml10">Cancel</button>
      <button type="button" tabindex="0" name="unlock" (click)="saveProductElement()"
        class="add blue ml10" id="buttonSubmitForMarket">Done</button>
    </div>
  </div>
</div>

<div class="lightBox embeddblock block" *ngIf="matchPopup">
  <app-match-component (sendPopupValueToParentfn)="getPopupValueToParentfn($event)"
  (sendMatchDetailsToParentfn) = getMatchDetailsToParentfn($event)></app-match-component>
</div>

<div [class]="'lightBox photogallerylist inlineImage block'" *ngIf="replaceImagePopup">
  <div class="headerLight">
    <div class="close fl spImg" (click)="replaceImagePopup = false;"></div>
  </div>
  <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="getLeadMediaId($event)"></div>
</div>

<div [class]="howToStepsInlineImageFlag ? 'lightBox photogallerylist inlineImage block' : 'lightBox'">
  <div class="headerLight">
    <div class="close fl spImg" (click)="disableStepsInlineImage()"></div>
  </div>
  <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="addStepsInlineImageEmit($event, 'howToSteps')" *ngIf="howToStepsInlineImageFlag"></div>
</div>
<div [class]="recipeInlineImageFlag ? 'lightBox photogallerylist inlineImage block' : 'lightBox'">
  <div class="headerLight">
    <div class="close fl spImg" (click)="disableStepsInlineImage()"></div>
  </div>
  <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="addStepsInlineImageEmit($event, 'recipe')" *ngIf="recipeInlineImageFlag"></div>
</div>

<div [class]="listicleInlineImageFlag ? 'lightBox photogallerylist inlineImage block' : 'lightBox'">
  <div class="headerLight">
    <div class="close fl spImg" (click)="disableStepsInlineImage()"></div>
  </div>
  <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="addStepsInlineImageEmit($event, 'listicleUploadImage')" *ngIf="listicleInlineImageFlag"></div>
</div>
<div [class]="FAQInlineImageFlag ? 'lightBox photogallerylist inlineImage block' : 'lightBox'">
  <div class="headerLight">
    <div class="close fl spImg" (click)="disableStepsInlineImage()"></div>
  </div>
  <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="addStepsInlineImageEmit($event, 'FAQUploadImage')" *ngIf="FAQInlineImageFlag"></div>
</div>

<div [class]="quesFAQInlineImageFlag ? 'lightBox photogallerylist inlineImage block' : 'lightBox'">
  <div class="headerLight">
    <div class="close fl spImg" (click)="disableStepsInlineImage()"></div>
  </div>
  <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="addStepsInlineImageEmit($event, 'quesFAQUploadImage')" *ngIf="quesFAQInlineImageFlag"></div>
</div>

<div [class]="pollInlineImageFlag ? 'lightBox photogallerylist inlineImage block' : 'lightBox'">
  <div class="headerLight">
    <div class="close fl spImg" (click)="disableStepsInlineImage()"></div>
  </div>
  <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="addStepsInlineImageEmit($event, 'pollUploadImage')" *ngIf="pollInlineImageFlag"></div>
</div>

<div [class]="logoGalleryFlag ? 'lightBox photogallerylist inlineImage block' : 'lightBox'">
  <div class="headerLight">
    <div class="close fl spImg" (click)="disableStepsInlineImage()"></div>
  </div>
  <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="addAffiliateLogo($event)" *ngIf="logoGalleryFlag"></div>
</div>

<div [class]="addProductImageGalleryFlag ? 'lightBox photogallerylist inlineImage block' : 'lightBox'">
  <div class="headerLight">
    <div class="close fl spImg" (click)="disableStepsInlineImage()"></div>
  </div>
  <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="addProductImage($event)" *ngIf="addProductImageGalleryFlag"></div>
</div>

<div [class]="'lightBox photogallerylist inlineImage block'" *ngIf="replaceImagePopupPhotoStory">
  <div class="headerLight">
    <div class="close fl spImg" (click)="replaceImagePopupPhotoStory = false;"></div>
  </div>
  <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="getLeadMediaId($event)"></div>
</div>


<div [class]="showRelatedStoryPopup ? 'lightBox listrelatedstories block' : 'lightBox'">
  <div class="headerLight">
    <div class="close fl spImg" (click)="closeRelatedStoryModal(null)"></div>
  </div>
  <div class="related-story-listing" [chooseMultiple]="relatedStoryMultipleSelectFlag"
    (sendIdListToParentfn)="getRelatedStoryIds($event)" (closePopupEmit)="closeRelatedStoryModal($event)" (closePopupHowtoEmit)="closeRelatedStoryModalHowto($event)" (sendRelatedStoryData)="getRelatedStoryData($event)" (sendRelatedStoryDataHowto)="getRelatedStoryHowtoIds($event)"
    [exclusionList]="relatedStoryTempList" *ngIf="showRelatedStoryPopup" (openEditRelatedStoryPopupData)="openEditRelatedStoryPopupData($event)" [storyId]="story_Id" [relatedStoryType]="relatedStoryType" [showNextButton]="true"></div>
</div>

<div [class]="showPostRelatedStoryPopup ? 'lightBox listrelatedstories block' : 'lightBox'">
  <div class="headerLight">
    <div class="close fl spImg" (click)="closePostRelatedStoryModal(null)"></div>
  </div>
  <div class="related-story-listing" [chooseMultiple]="relatedStoryMultipleSelectFlag"
    (sendIdListToParentfn)="getPostRelatedStoryIds($event)" (closePopupEmit)="closePostRelatedStoryModal($event)"
    [exclusionList]="relatedStoryTempList" *ngIf="showPostRelatedStoryPopup" (openEditRelatedStoryPopupData)="openPostEditRelatedStoryPopupData($event)" [storyId]="story_Id" [relatedStoryType]="relatedStoryType" ></div>
</div>

<div [class]="showAlsoReadStoryPopup ? 'lightBox listrelatedstories block' : 'lightBox'">
  <div class="headerLight">
    <div class="close fl spImg" (click)="closeRelatedStoryModal(null)"></div>
  </div>
  <div class="related-story-listing" [chooseMultiple]="relatedStoryMultipleSelectFlag" (sendIdListToParentfn)="getRelatedStoryIds($event)" (sendRelatedStoryDataHowto)="getRelatedStoryHowtoIds($event)"
  [exclusionList]="relatedStoryTempList" (closePopupEmit)="closeRelatedStoryModal($event)" (sendAlsoReadData)="getAlsoReadIds($event)" *ngIf="showAlsoReadStoryPopup" [storyId]="id" [relatedStoryType]="relatedStoryType"></div>
</div>

<div class="image-cropper" *ngIf="showCropper" [cropperImageUrl]="cropperImageUrl"
(finish)="finishCropping($event)" (cancel)="cancelCropping($event)" [leadMediaImageGif]="leadMediaImageGif" [isImageLead]="leadMedia"
[verticalImageFlag]="(cardData.image && cardData.image.verticalImage)" [ogImage]="ogImage"
></div>
<div class="image-cropper" *ngIf="showLBcropper" [cropperImageUrl]="cropperImageUrl"
(finish)="finishCropping($event)" (cancel)="cancelCropping($event)" [leadMediaImageGif]="leadMediaImageGif" [isImageLead]="leadMedia" [liveblogCropper]="true"
[verticalImageFlag]="(cardData.image && cardData.image.verticalImage)"
></div>
<div class="image-cropper" *ngIf="showProductImageCropper" [cropperImageUrl]="cropperImageUrl"
  (finish)="finishProductCropping($event, 'productImage')" (cancel)="cancelCropping($event)" [isImageLead]="false" [verticalImageFlag]="false" [isProductImage]="true"
  ></div>


<div class="image-cropper" *ngIf="showHowToStepsCropper" [cropperImageUrl]="cropperImageUrl"
  (finish)="finishCroppingStepsImage($event, 'howToSteps')" (cancel)="cancelCropping($event)" [isImageLead]="false" [verticalImageFlag]="false" [isHowToStepsImage]="true"
  ></div>
  <div class="image-cropper" *ngIf="showListicleCropper" [cropperImageUrl]="cropperImageUrl"
  (finish)="finishCroppingListicleImage($event, 'listicleImage')" (cancel)="cancelCropping($event)" [isImageLead]="false" [verticalImageFlag]="false" [isProductImage]="true"
  ></div>
  <div class="image-cropper" *ngIf="showRecipeStepsCropper" [cropperImageUrl]="cropperImageUrl"
  (finish)="finishCroppingStepsImage($event, 'recipe')" (cancel)="cancelCropping($event)" [isImageLead]="false" [verticalImageFlag]="false" [isHowToStepsImage]="true"
  ></div>
  <div class="image-cropper" *ngIf="addVideoThumbnail" [cropperImageUrl]="cropperImageUrl"
  (finish)="finishCroppingVideoThumbnail($event)" (cancel)="cancelCropping($event)" [leadMediaImageGif]="leadMediaImageGif" [isImageLead]="false"
  [verticalImageFlag]="(cardData.image && cardData.image.verticalImage)" [addVideoThumbnail]="true"
  ></div>
<div class="lightBox cropimagelightbox block" *ngIf="tablePopup">
    <div class="unlockStory">
      <div class="wid100">
        <h3 class=" pad30">Table</h3>
        <div class="cropimageblock pad30">
          <div class="cropAspectRatio">
              <ckeditor #editortable [editor]="Editor" [(ngModel)]="tableHTML"
              [config]="tableConfig"
              (ready)="ckchanges($event, 'ready', 'table','table')"
              (change)="ckchanges($event, 'change', 'table','table')"></ckeditor>
          </div>
        </div>
      </div>
      <div class="fr wid100 right padlr30 ptb15">
        <button type="button" name="cancel" (click)="closeTable()" class="cancel gray ml10">Cancel</button>
        <ng-container *ngIf="createTable === false">
          <button type="button" name="unlock" (click)="changeTable()" class='add blue ml10'>Done</button>
        </ng-container>
        <ng-container *ngIf="createTable === true">
          <button type="button" name="unlock" (click)="addTable()" class='add blue ml10'>Add</button>
        </ng-container>
      </div>
    </div>
</div>

<div class="lightBox videoblock block" *ngIf="quotePopup">
  <div class="unlockStory">
    <div class="wid100 pad30">
      <h3>Add Text for Quote</h3>
      <label></label>
      <textarea type="text" class="textBox" [(ngModel)]="quoteText" placeholder="Enter Quote text here…" tabindex="0"></textarea>
    </div>
    <div>
      <span class="show-quote">
        Show Quote
      </span>
      <input type="radio" id="yes" name="fav_language" [checked]="showQuotes===true" (change)="onQuoteItemChange(true)" value=true class="margin-left">
        <label>Yes</label>
        <input type="radio" id="no" name="fav_language" [checked]="showQuotes===false" value=false (change)="onQuoteItemChange(false)">
        <label>No</label>
    </div>
    <div class="fr wid100 right padlr30 ptb15">
      <button type="button" name="cancel" tabindex="0" (click)="closeQuote()" class="cancel gray ml10">Cancel</button>
      <button type="button" name="unlock" tabindex="0" (click)="saveQuote()" class="add blue ml10"
      [disabled]="quoteText.trim() === ''">Done</button>
    </div>
  </div>
</div>

<div class="lightBox block lightBoxVideo" *ngIf="isLightboxVideo">
  <div class="headerLight">
    <div class="close fl spImg" (click)="disableshowVideoGallery()"></div>
  </div>
  <div class="lightContent">
    <div class="headingPage">
      <ng-container *ngIf="enableJW === 'true'">
        <h2 class="tablinks all_stories"  (click)="showJW = true;showYT = false"
        [class]="showJW ? 'active' : ' '" id="defaultOpen">JW Videos</h2>
      </ng-container>
      <ng-container *ngIf="enableYT">
        <h2 class="tablinks my_workspace"  (click)="showJW = false;showYT = true"
        [class]="showYT ? 'active' : ' '"  id="wire" >Youtube Videos</h2>
      </ng-container>
    </div>
    <ng-container *ngIf="showJW">
    <div class="listing" pageId="videoStory"
      allApi="video_stories"
      searchApi="video_search"
      videoListing = "true"
      [showPagination]="true"
      [videogallery]="true"
      metaApi="" (sendIdVieoToParentfn)="getVideo($event)"
      search_label="Search Videos...">
    </div>
    </ng-container>
      <ng-container *ngIf="showYT">
        <youtube-listing (sendIdVieoToParentfn)="getVideo($event)"></youtube-listing>
      </ng-container>
  </div>
</div>


<div class="lightBox block lightBoxVideo" *ngIf="isPageListing">
  <div class="headerLight">
    <div class="close fl spImg" (click)="disableshowPageListing()"></div>
  </div>
  <div class="lightContent">
    <div class="app-page-type-listing"
    pageId="pages"
    allApi="all_pages"
    searchApi="all_pages"
    pageType="TOPIC"
    [getTopicName] = "topicName"
    (sendpageUrlToParentfn) = "getpageUrlToParentfn($event)"
    search_label="Search Topic Pages...">
    </div>
  </div>
</div>

<div class="lightBox block lightBoxVideo" *ngIf="isStoryListing">
  <div class="headerLight">
    <div class="close fl spImg" (click)="disableshowStoryListing()"></div>
  </div>
  <div class="lightContent">
    <div class="app-story-type-listing"
    [storySearchText] = "topicName"
    (sendpageUrlToParentfn) = "getpageUrlToParentfn($event)"
    search_label="Search Stories...">
    </div>
  </div>
</div>

<div class="lightBox stepblock listicle-element-popup block" *ngIf="showEditRelatedStoryPopup" style="z-index: 10 !important;">
  <div class="unlockStory ">
    <div class="wid100 overflow_scroll">
      <h3 class="pad30">Edit Related Story</h3>
      <form [formGroup]="tempRelatedStoryForm" class="formListicleCss" >
        <li>
          <div class="headingBlock">
          <label>Heading</label>
          <div class="dataField">
              <textarea appTextareaAutoresize class="textBoxSmall" formControlName="heading" placeholder="Enter the heading" tabindex="0" type="text"></textarea>
          </div>
          <label>Description</label>
          <div class="dataField">

              <textarea appTextareaAutoresize class="textBoxSmall" formControlName="description" placeholder="Enter the Description" tabindex="0" type="text"></textarea>
          </div>
        </div>
        </li>
        <div class="faqQueAnsw">
          <ng-container formArrayName="relatedStoryData"
              *ngFor="let faq of tempRelatedStoryForm.get('relatedStoryData').controls; let i = index;">
            <div class="listBlockQue">
            <ng-container [formGroupName]="i">
                <li>
                  <div class="">
                  <label>Story Title {{i+1}}
                  </label>
                  <div class="dataField">
                    <ckeditor [editor]="Editor" class="textBoxSmall" formControlName="title" placeholder="Enter the title" tabindex="0" type="text" (change)="ckchanges($event, 'change', 'relatedStoryTitle','relatedStoryTitle',i)"  (ready)="ckchanges($event, 'ready', 'relatedStoryTitle')"></ckeditor>

                      <!-- <textarea appTextareaAutoresize class="textBoxSmall" formControlName="title" placeholder="Enter the title" type="text"></textarea> -->
                  </div>
                </div>
                </li>
                <li>
                  <div class="answer">
                  <label>Story Description {{i+1}}
                  </label>
                  <div class="dataField">
                    <ckeditor [editor]="Editor" class="textBoxSmall" formControlName="storyDescription" placeholder="Enter the Description" tabindex="0" type="text" (change)="ckchanges($event, 'change', 'relatedStoryDescription','relatedStoryDescription',i)"  (ready)="ckchanges($event, 'ready', 'relatedStoryDescription')"></ckeditor>
                </div>
                </div>
                </li>

            </ng-container>
          </div>
          </ng-container>
        </div>
      </form>

    </div>
    <div class="fr wid100 right padlr30 ptb15">
      <button type="button" tabindex="0" name="cancel" (click)="closeEditRelatedStoryModal()" class="cancel gray ml10">Cancel</button>
      <button type="button" tabindex="0" name="unlock" class="add blue ml10 " [disabled]="!imageLoaded"
      (click)="backEditRelatedStoryModel()">Back</button>
      <button type="button" tabindex="0" name="unlock" class="add blue ml10 " [disabled]="!imageLoaded"
       (click)="updateRelatedStory()">Done</button>
    </div>
  </div>
</div>

<div class="lightBox stepblock listicle-element-popup block" *ngIf="showPostEditRelatedStoryPopup" style="z-index: 10 !important;">
  <div class="unlockStory bigPopup"  >
    <div class="wid100">
      <h3 class="pad30">Add Related Story</h3>
      <form [formGroup]="tempRelatedStoryForm" class="formListicleCss" >
        <li>
          <div class="headingBlock">
          <label>Heading</label>
          <div class="dataField">
              <textarea appTextareaAutoresize class="textBoxSmall" formControlName="heading" placeholder="Enter the heading" tabindex="0" type="text"></textarea>
          </div>
          <label>Description</label>
          <div class="dataField">
              <textarea appTextareaAutoresize class="textBoxSmall" formControlName="description" placeholder="Enter the Description" tabindex="0" type="text"></textarea>
          </div>
        </div>
        </li>
        <div class="faqQueAnsw">
          <ng-container formArrayName="relatedStoryData"
              *ngFor="let faq of tempRelatedStoryForm.get('relatedStoryData').controls; let i = index;">
            <div class="listBlockQue">
              <!-- <i *ngIf="tempRelatedStoryForm.get('relatedStoryData').controls.length > 1" class="listElement icon-delete" (click)="deleteListicle(i)"></i> -->
            <ng-container [formGroupName]="i">
                <li>
                  <div class="">
                  <label>Story Title {{i+1}}
                  </label>
                  <div class="dataField">
                      <textarea appTextareaAutoresize class="textBoxSmall" formControlName="title" placeholder="Enter the title" type="text"></textarea>
                  </div>
                </div>
                </li>
                <li>
                  <div class="answer">
                  <label>Story Description {{i+1}}
                  </label>
                  <div class="dataField">
                    <ckeditor [editor]="Editor" class="textBoxSmall" formControlName="storyDescription" placeholder="Enter the Description" tabindex="0" type="text" (change)="ckchanges($event, 'change', 'relatedStoryDescription',i)"  (ready)="ckchanges($event, 'ready', 'relatedStoryDescription')"></ckeditor>
                </div>
                </div>
                </li>
            </ng-container>
          </div>
          </ng-container>
        </div>
      </form>

    </div>
    <div class="fr wid100 right padlr30 ptb15">
      <!-- <button type="button" tabindex="0" name="cancel" (click)="addListicle(target)" class="cancel btnFaq">+ Add another list</button> -->
      <button type="button" tabindex="0" name="cancel" (click)="closePostEditRelatedStoryModal()" class="cancel gray ml10">Cancel</button>
      <button type="button" tabindex="0" name="unlock" class="add blue ml10 " [disabled]="!imageLoaded"
      (click)="backPostEditRelatedStoryModel()">Back</button>
      <button type="button" tabindex="0" name="unlock" class="add blue ml10 " [disabled]="!imageLoaded"
       (click)="getPostRelatedStoryIds(storyList)">Done</button>
    </div>
  </div>
</div>

<div id="headline3" class="lightBox headlineBox summaryPopup block" *ngIf="openRelatedStoryPreview">
  <div class="headerLight">
    <div class="close fl spImg" (click)="closeRelatedStoryPopup()"></div>
  </div>
  <div class="lightContent headlineBox boxnew">
    <div class="addHeadline" >
      <div class="previewPopup">
     <h4>{{cardData.relatedStoryMainTitle}}</h4>
     <p>{{cardData.relatedStoryMainDescription}}</p>
     <ul *ngIf="cardData.relatedStoryData.length>0">
        <li *ngFor="let data of cardData.relatedStoryData">
          <h5 [innerHtml]="data.title">:</h5>
          <span [innerHtml]="data.storyDescription"></span>
        </li>
     </ul>
     </div>
      <div class="clearBoth"></div>
    </div>
  </div>
</div>


